import { getTranslations } from "../../translations";
import { sendApiCall } from "../../utilities/api";
import { renderTemplate } from "../../utilities/cms.TemplateEngine";
import { Popup, PopupButton, PopupContent, PopupPosition } from "../../utilities/popup";
import { sendDataLayer } from "../../components/ecommerce/ecommerce";
import { sendBreadCrumbImpression, getBreadCrumbImpression } from "../../components/ecommerce/breadcrumb";
import
{
    initNativeSelect,
    getParameterByName,
    removeURLParameter,
    getUrlVar,
    refreshKeyboardInteractions,
    windowMedia
} from "../../helpers";
import { getTemplate } from "../../utilities/templates";
import { FavoritePopup } from "../../widget/favorites/favorites.popup";
import { FilterWizard } from "../../widget/filter/filterwizard";
import { FilterExplanation } from "../../widget/filter/filterexplanation";
import { ProductComparer } from "../../components/productcomparer/productcomparer";
import noUiSlider from "nouislider";
import { progressSpinner, spinnerType } from "../../utilities/progressSpinner";
import { reInitProductComparer } from "../../components/productcomparer/productcomparer.popup";

let filterPopup: Popup;
let filterWizard: FilterWizard;
let filterExplanation: FilterExplanation;
declare const UIkit: any;
declare const Cookies: any;

declare function initLazyLoad(): void;
declare function queryStringValue(key: string): string;

let impressionList: any;
let dataObject: any;
let delayDataLayerSend: boolean;

const mobileMediaQuery = window.matchMedia("(max-width: 768px)");

declare global
{
    interface JQueryStatic
    {
        stash: {
            exists(key: string): boolean,
            set(key: string, value: any): void;
            get(key: string): any;
            remove(key: string): void;
        };

        EstrategyCookie: {
            [key: string]: any;
            LoadAdditionalScripts(): void;
        }
    }

    interface StringConstructor
    {
        format(formatString: string, ...args: any[]): string;
    }
}

const measurePropertyID: number = 5;
const singleColumnClass: string = "c-productview--single-column";
const colourPropertyClass: string = "w-filter__sublist-item--color";
const articlesPerPageAmount = 36;

const articleImagePaths = {
    "imageItem": "/data/cms_uploads/webshop/webshop/",
    "imageThumbnail": "/data/cms_uploads/webshop/webshop/article_thumb/",
    "imageDetail": "/data/cms_uploads/webshop/webshop/productdetail/",
    "imageLarge": "/data/cms_uploads/webshop/webshop/article_large/"
};

// DBO		=	158, 2007, 1880, 2014	(NL, BE, FR, BEFR)
// Dekbed	=	1771, 1943				(NL/BE, (BE)FR)
const dboCatIDs: Array<string> = ["158", "2007", "1880", "2014"];
const duvetCatIDs: Array<string> = ["1771", "1943"];
const sortValues: Array<string> = ["la", "df", "pa", "pd"];

// Default selectors.
let sFilter = ".j-filter";
let sFilterListID = "w-filter__list-item--";
let sFilterLists = `*[id^='${sFilterListID}']`;
let sPropertyValue = "input[data-id^='chk-{0}-']";

let shopmode = getUrlVar("shopmode");
const pushHistory = [];
let searchQueue = [];

let ajaxCallFilters: any = null;
let searchAjaxCall: any = null;
let filterInfoCall: any = null;
let onloadStack = new Array();

let sliderFilterProperties: RangeFilterItem[] = [];
const propertyIDs = [];
const properties = [];
const propertiesArray: PropData[][] = [];
const colorPropertiesArray: PropData[][] = [];
const pinnedPropertyArray: PropData[][] = [];
const pinnedColorArray: PropData[][] = [];

let buttonInfoList = null;
let buttonImpressionList = null;

let priceFilterChanged: boolean = false;
let overrideIsListBlock: boolean = false;
let mobileFilter: boolean = false;
let removeActiveFilterBlock: boolean = false;
let blockVirtualPageView: boolean = null;
let isLoadingTrackablePage: boolean = false;
let manualHashChange: boolean = false;
let stashScroll: number = null;
let scrollLimiter = null;
let initialPageNumber = null;
let filtersReloaded = false;

let filterModalOpen: boolean = false;
let filterResultCount: number = 0;
let currentMobileFilterProperty: number = 0;

let newEvtHash: string = null;
let reloadPageAfterCallback = false;

let allowTimeout: boolean = false;
let hashToApply: string = null;
let previousHash: boolean = null;
let pageLoading: boolean = false;
let mobileFilterScrollTop = 0;

var scrollTimeout: number = null;
let filterModalTimeout = null;

// Slider filter.
let propertySliderHolder = [];
let propertySliderCurrentValues = [];
let previousSliderValue = null;
let preventSliderChange: boolean = false;
let propertySliderTimeout = null;

let previousPriceValue = null; // TODO: Remove? Likely serves no real purpose.

let loadIconState = "relative";

//#region Templates

// TODO: Move to templates TS.
const itemTemplate =
    "<li class=\"w-filter__sublist-item u-checkradio-holder {5} {7}\" title=\"{9}\" " +
    "data-property-id=\"{0}\" data-option-id=\"{1}\" data-disabled=\"{14}\" " +
    "onclick=\"toggleFilterOption(event, this, false, false, false);\">" +
    "<input type=\"checkbox\" data-id=\"chk-{0}-{1}\" value=\"{1}\" {3} />" +
    "<a class=\"w-filter__option-title f-primary-s\" href=\"#\" title=\"{9}\" tabindex=\"-1\" data-no-instant>{2}</a>" +
    "</li>";

const linkItemTemplate =
    "<li class=\"w-filter__sublist-item u-checkradio-holder {5} {7}\" title=\"{9}\" " +
    "data-property-id=\"{0}\" data-option-id=\"{1}\" data-disabled=\"{14}\" " +
    "onclick=\"toggleFilterOption(event, this, false, true, false);\">" +
    "<input type=\"checkbox\" data-id=\"chk-{0}-{1}\" value=\"{1}\" {3} />" +
    "<a class=\"w-filter__option-title f-primary-s\" href=\"{4}\" title=\"{9}\" tabindex=\"-1\" data-no-instant>{2}</a>" +
    "</li>";

// Color HTML layouts updated to align seamlessly with modifier class setups
const colorItemTemplate =
    "<li class=\"w-filter__sublist-item w-filter__sublist-item--color u-checkradio-holder {5} {7}\" title=\"{9}\" " +
    "data-property-id=\"{0}\" data-option-id=\"{1}\" data-disabled=\"{14}\" " +
    "onclick=\"toggleFilterOption(event, this, false, false, false);\">" +
    "<input type=\"checkbox\" data-id=\"chk-{0}-{1}\" value=\"{1}\" {3} />" +
    "<div class=\"w-filter__list-item-color\" style=\"{8}\">{6}</div>" +
    "<a class=\"w-filter__option-title f-primary-s\" href=\"#\" title=\"{9}\" tabindex=\"-1\" data-no-instant>{2}</a>" +
    "</li>";

const colorLinkItemTemplate =
    "<li class=\"w-filter__sublist-item w-filter__sublist-item--color u-checkradio-holder {5} {7}\" title=\"{9}\" " +
    "data-property-id=\"{0}\" data-option-id=\"{1}\" data-disabled=\"{14}\" " +
    "onclick=\"toggleFilterOption(event, this, false, true, false);\">" +
    "<input type=\"checkbox\" data-id=\"chk-{0}-{1}\" value=\"{1}\" {3} />" +
    "<div class=\"w-filter__list-item-color\" style=\"{8}\">{6}</div>" +
    "<a class=\"w-filter__option-title f-primary-s\" href=\"{4}\" title=\"{9}\" tabindex=\"-1\" data-no-instant>{2}</a>" +
    "</li>";

const colorTemplate =
    "<span style=\"background-color: {0}\"></span>" +
    "<span style=\"background-color: {1}\"></span>";

//#endregion Templates

//#region Interfaces

interface PropData
{
    id: number | string;
    name: string;
    disabled: boolean;
    pin?: boolean;
    pinsub?: boolean;
    title: string;

    url?: string | null;
    logo: string;
    colorcode?: string | null;
    articleCount: number | string;

    selected?: string | number | boolean;

    [key: string]: any;
}

interface RangeFilterItem
{
    property_id: number;
    name: string;
    orgName: string;
    unit: string;
    step: number;
    min: number;
    max: number;
    curMin: number;
    curMax: number;
}

interface FetchPriorityKeyItem
{
    count: number;
    key: string;
}

//#endregion Interfaces

//#region Page events

let filterSpinner;

const domContentLoaded = (): void =>
{
    filterSpinner = new progressSpinner(".c-category__holder", spinnerType.smulders);

    initQuickfilter();
    initNativeSelect();
    filterWizard = new FilterWizard();
    initFilters();
    initFilterPropertyFilterbars();
    initMobileFilters();

    if (location.hash.length === 0 && typeof initArticlePriceText === "function")
        initArticlePriceText();

    initActiveFilterBlocks();
    hideSingleBrandFilter();

    window.addEventListener("popstate", (): void =>
    {
        let hasElementWithHash = false;

        if (window.location.hash)
        {
            try
            {
                if (document.querySelector(window.location.hash) !== null)
                    hasElementWithHash = true;
            }
            catch { }
        }

        if (!window.location.hash || !hasElementWithHash)
        {
            isLoadingTrackablePage = true;
            filterSpinner.show(true);
            loadTrackablePage(window.location.href, true);
        }
    });

    checkHashForSeo(location.hash);
    checkForUpdateFilters();
};

const windowOnLoad = (): void =>
{
    initFiltersAndSearch();
    initProductColumnStyle();
    sendCategoryProductImpressions();
    setMoreFilters();
    initCategoryReadMore();
    initFAQ();

    $(".fittext").trigger("resize.fittext");

    if (document.location.hash.length < 4 || priceFilterChanged)
    {
        $(".j-filter .j-filter__list").show();
        $(".j-productview-content > .nosearchresults, .j-productview-content > .w-productcard__holder").show();
    }

    $(".js-more").each(function (this: HTMLElement)
    {
        const $this = $(this);
        if ($this.find(".w-filter__sublist-item:not(:visible)").length === 0)
            $this.find(".w-filter__show-toggle").hide();
    });

    filterExplanation = new FilterExplanation();

    initPaging(false, false);

    initBackToTopEvent();
    initLastProd();

    initButtonEvents();

    pushToHistory(
        window.location.pathname +
        window.location.search +
        window.location.hash,
        false,
        true
    );

    checkHashForMultipleBrands(false, false);

    // Set the pinned options
    if (!window.location.hash.includes("-"))
        setMoreFilters();

    if ($(sFilter).length > 0)
    {
        // Get the property IDs.
        $(sFilter + " " + sFilterLists).each(function (this: HTMLElement)
        {
            const $this = $(this);
            const idProp = $this.data("property-id");

            if (idProp > 0)
                propertyIDs.push(idProp);
        });

        // Clear local storage on enter.
        if ($("input[type=checkbox]:checked").length === 0 && typeof Storage !== "undefined")
            localStorage.removeItem("searchHistory");

        initPriceFilter(false);
        initSlider();
        resetProductOverlayEvents();
        setDeleteFilterVisibility();
    }

    if (onloadStack.length > 0)
    {
        for (let i = 0; i < onloadStack.length; i++)
            onloadStack[i].call(window);
    }

    // Check if we got a mobile device
    initMobileFilters();

    if (location.hash && location.hash.length > 0)
        initArticlePriceText();

    addStashClickEvents();

    if ($(".nosearchresults").length > 0)
        $(".filterLoader").hide();

    $(".j-category-text a[href^=\"#\"]:not(.opener)").on("click", function (this: HTMLElement, e: JQuery.TriggeredEvent)
    {
        const hrefAttr = $(this).attr("href");
        if (hrefAttr)
        {
            const $target = $(hrefAttr);
            if ($target.length > 0)
            {

                // 10px extra offset to not be hard pressed against the edge of the header.
                const scrollTop = $target.offset()!.top - ($(".js-header").outerHeight() || 0) - 10;

                $("html, body").animate({ scrollTop: scrollTop }, 500);
            }
        }
    });

    const $currentCategory = $("input[name*='current_category']");
    const currentCategoryVal = $currentCategory.val() as string;

    if ($currentCategory.length > 0 &&
        ($.inArray(currentCategoryVal, dboCatIDs) > -1 || $.inArray(currentCategoryVal, duvetCatIDs) > -1))
    {
        if (window.location.hash === "" &&
            $.stash.exists("dboActiveFilters") &&
            $.stash.get("dboActiveFilters") !== undefined)
        {
            const measureOption = $.stash.get("dboActiveFilters");
            const str_array = measureOption.split(",");
            const curURL = window.location.href;
            let newFilterHash = "";

            for (let i = 0; i < str_array.length; i++)
            {
                const newHash = `${measurePropertyID}-${str_array[i]}`;

                const $curFilter = $(`.j-filter__list-item .w-filter__sublist .w-filter__sublist-item[data-property-id='${measurePropertyID}'][data-option-id='${str_array[i]}']`);

                if ($curFilter.length > 0)
                {
                    let filterItemName = "";
                    const $anchor = $curFilter.find("a");
                    const $label = $curFilter.find("label");

                    if ($anchor.length > 0)
                        filterItemName = $anchor.first().text().toLowerCase();
                    else if ($label.length > 0)
                        filterItemName = $label.first().text().toLowerCase();

                    // Check if the filter url name is already present in the url and don't add the hash if that is the case.
                    if (curURL.indexOf(filterItemName) <= -1)
                    {
                        if (newFilterHash.length > 0)
                            newFilterHash += "_" + newHash;
                        else
                            newFilterHash = "#" + newHash;
                    }
                }
            }

            if (!($.inArray(currentCategoryVal, dboCatIDs) > -1))
                $.stash.remove("dboActiveFilters");

            window.location.hash = newFilterHash;
        }
    }
    else
        $.stash.remove("dboActiveFilters");

    fillFilterStash(mobileFilter);

    if (window.location.hash !== "")
        previousHash = true;
};

if (document.readyState !== "loading")
    domContentLoaded();
else
    document.addEventListener("DOMContentLoaded", domContentLoaded);

if (document.readyState === "complete")
    windowOnLoad();
else
    window.addEventListener("load", windowOnLoad);

window.addEventListener("hashchange", (event: HashChangeEvent): void =>
{
    if (window.location.hash)
    {
        try
        {
            if (document.querySelector(window.location.hash) !== null)
                return;
        }
        catch { }
    }

    let trigger = false;

    if (event.oldURL.length !== event.newURL.length)
        trigger = true;
    else if (event.oldURL !== event.newURL)
    {
        const result = checkHashChanges(event.oldURL, event.newURL);
        trigger = result.triggerHashChange;
    }

    if (trigger)
    {
        if (manualHashChange)
        {
            manualHashChange = false;
            hashChanged(event, true);
        }
        else
            hashChanged(event);
    }
});

window.addEventListener("resize", (): void =>
{
    initMobileFilters();
});

//#endregion Page events

//#region Initialise

function initFilters(): void
{
    $(".w-filter__show-toggle").off("click");
    $(".w-filter__show-toggle").on("click", function (e)
    {
        // Check if more is already shown.
        const isOpen = $(this).closest(".j-filter__list-item").hasClass("w-filter__show-all");

        // Toggle 'show more'/'show loess' list.
        $(this).closest(".j-filter__list-item").toggleClass("w-filter__show-all");

        // Swap the 'show more'/'show less' text.
        if (isOpen)
            $(this).text(getTranslations().txtShowMore);
        else
            $(this).text(getTranslations().txtShowLess);

        e.preventDefault();
    });
}

function initMobileFilters(): void
{
    if (mobileMediaQuery.matches)
        mobileFilter = true;
    else
        mobileFilter = false;

    if ($(".j-filter--mobile").length > 0)
    {
        $(".j-filter--mobile").off("click");
        $(".j-filter--mobile").on("click", function ()
        {
            filterPopup.show();
        });

        if (!filterPopup)
        {
            const removeFilters = new PopupButton();
            removeFilters.label = getTranslations().eraseMobileFilterMultipleText;
            removeFilters.className = "g-popup__linkbutton js-filter__remove--mobile btn-none";
            removeFilters.onClick = (event) =>
            {
                resetFilters(event);
            };

            const buttons = new Array<PopupButton>();

            buttons.push({
                label: `${getTranslations().txtUtilShow} ${getTranslations().txtUtilProducts}`,
                className: "btn-green w-filtermobile__footer-button js-filtermobile__footer-button",
                onClick: () =>
                {
                    filterPopup.hide();
                    applyPriceFilters($(".j-filtermobile .js-filter-price-apply"));
                    loadTrackablePage(window.location.href, false);
                    setTimeout(() =>
                    {
                        filterPopup.destroy();
                        filterPopup = null;
                    }, 200);
                },
            });

            filterPopup = new Popup({
                id: "mobile-filter-popup",
                popupClass: "w-filtermobile,j-filtermobile,g-popup__buttons--center",
                title: getTranslations().txtFilterOn,
                content: buildMobileFilters(),
                desktopPosition: PopupPosition.Center,
                mobilePosition: PopupPosition.fullScreen,
                backButton: removeFilters,
                buttons: buttons,
                closeButton: {
                    label: getTranslations().txtClose
                }
            });
        }
    }
}

function initPriceFilter(isMobile?: boolean): void
{
    let selectors = null;
    if (isMobile)
        selectors = ".j-filtermobile .w-filter__list-item--price";
    else
        selectors = ".j-filter .w-filter__list-item--price";

    $(selectors).each(function (this: HTMLElement)
    {
        const $holder = $(this);
        const min = parseInt($holder.find(".min").val() as string) || 0;
        const max = parseInt($holder.find(".max").val() as string) || 0;
        const curMin = parseInt($holder.find(".cur-min").val() as string) || 0;
        const curMax = parseInt($holder.find(".cur-max").val() as string) || 0;

        $(".w-filter__price-curmin input").val(curMin);
        $(".w-filter__price-curmax input").val(curMax);

        $(".w-filter__price-curmin input").attr("min", min);
        $(".w-filter__price-curmax input").attr("max", max);
    });
}

function initSlider(): void
{
    $(".w-filter__slide--property").each(function (this: HTMLElement)
    {
        const $holder = $(this);

        const min = parseInt($holder.find(".prop-min").val() as string) || 0;
        const max = parseInt($holder.find(".prop-max").val() as string) || 0;
        const step = parseInt($holder.find(".step").val() as string) || 1;
        const curMin = parseInt($holder.find(".prop-cur-min").val() as string) || 0;
        const curMax = parseInt($holder.find(".prop-cur-max").val() as string) || 0;
        const range = $holder.find(".ui-slider");
        const rangePropertyName = $holder.find(".range-name").val() as string;

        const amountValues = [
            $holder.find(".property-handler.first .num"),
            $holder.find(".property-handler.last .num")
        ];

        if (range.length > 0 && Number.isFinite(min))
        {
            if (!$holder.hasClass("noUi-target"))
            {
                if (min === max || max <= 0)
                {
                    const parentListItem = $holder.closest(".j-filter__list-item");
                    if (parentListItem.length > 0)
                        parentListItem.addClass("hidden");
                    return;
                }

                const currentSlider = noUiSlider.create($holder[0], {
                    start: [curMin, curMax],
                    connect: true,
                    step: step,
                    range: { "min": min, "max": max }
                });

                priceFilterChanged = false;

                currentSlider.on("update", function (this: any, values: any[], handle: number)
                {
                    amountValues[handle].html(String(Math.round(values[handle])));

                    const sliderName = $($holder).find(".range-name").val() as string;
                    propertySliderCurrentValues[sliderName] = values;

                    const [valMin, valMax] = values;

                    $(".prop-cur-min").val(Math.round(valMin));
                    $(".prop-cur-max").val(Math.round(valMax));

                    $(".prop-cur-min").attr("min", Math.round(valMin));
                    $(".prop-cur-max").attr("max", Math.round(valMax));
                });

                currentSlider.on("change", function (values: any[])
                {
                    if (propertySliderTimeout != null)
                        clearTimeout(propertySliderTimeout);

                    propertySliderTimeout = setTimeout(function ()
                    {
                        const [valMin, valMax] = values;
                        const minChanged = ((previousSliderValue != null && previousSliderValue[0] != valMin) || (previousSliderValue == null && min != valMin));
                        const maxChanged = ((previousSliderValue != null && previousSliderValue[1] != valMax) || (previousSliderValue == null && max != valMax));

                        if (previousSliderValue == null ||
                            previousSliderValue[0] != valMin ||
                            previousSliderValue[1] != valMax)
                        {
                            previousSliderValue = values;
                            const preChangedUrl = location.href;

                            if (min == valMin && max == valMax)
                            {
                                reloadPageAfterCallback = true;
                                clearPropertyFilters(true, true);
                                updateFilters(0, true);

                                let newUrl = location.href;
                                newUrl = removeURLParameter(newUrl, `${rangePropertyName}-min`);
                                newUrl = removeURLParameter(newUrl, `${rangePropertyName}-max`);
                                history.pushState(null, null, newUrl);
                            }

                            if (!preventSliderChange)
                            {
                                priceFilterChanged = true;
                                preventSliderChange = true;
                                $("#searchextraform input[name=origin]").val("search");
                                $("#pn").val(0);
                                updateFilters(0, false, false, true);
                                $(".w-filter__slide--property.fixed input").remove();
                                preventSliderChange = false;
                            }

                            if (minChanged || maxChanged)
                            {
                                sendDataLayer({
                                    "category": "productlist",
                                    "action": rangePropertyName,
                                    "label": Math.round(valMin) + "-" + Math.round(valMax),
                                    "url": preChangedUrl,
                                    "event": "filterClick"
                                });
                            }
                        }
                    }, 250);
                });

                $holder.closest(".j-filter__list-item").find(".propcurmin input, .w-filter__price-curmax input")
                    .off("change")
                    .on("change", function ()
                    {
                        const $listItem = $holder.closest(".j-filter__list-item");
                        const inputMin = parseInt($listItem.find(".propcurmin input").val() as string) || 0;
                        const inputMax = parseInt($listItem.find(".w-filter__price-curmax input").val() as string) || 0;

                        currentSlider.set([inputMin, inputMax]);

                        if (inputMin >= min && inputMax <= max)
                        {
                            if (propertySliderTimeout != null)
                                clearTimeout(propertySliderTimeout);

                            propertySliderTimeout = setTimeout(function ()
                            {
                                if (previousPriceValue == null || previousPriceValue[0] != inputMin || previousPriceValue[1] != inputMax)
                                {
                                    previousPriceValue = [inputMin.toFixed(2), inputMax.toFixed(2)];
                                    if (!preventSliderChange)
                                    {
                                        priceFilterChanged = true;
                                        preventSliderChange = true;
                                        $("#searchextraform input[name=origin]").val("search");
                                        updateFilters(0);
                                        $(".w-filter__slide--property.fixed input").remove();
                                        preventSliderChange = false;
                                    }
                                }
                            }, 250);
                        }
                    });

                propertySliderHolder.push(currentSlider);
            }
        }
    });
}

function initProductColumnStyle(): void
{
    if (windowMedia(768))
    {
        // Check cookie if products on mobile should be shown in a single column.
        // Set the appropriate button as selected.
        const catPageMobileSingleColumn = Cookies.get("CategoryPageMobileSingleColumn");
        if (catPageMobileSingleColumn != null && catPageMobileSingleColumn == "1")
        {
            $(`.j-productview:not(.${singleColumnClass})`).addClass(singleColumnClass);
            $("#w-filter__column-single:not(.selected)").addClass("selected");
            $(".j-productview .w-productcard").addClass("w-productcard--small");
        }
        else
            $("#w-filter__column-double:not(.selected)").addClass("selected");

        $("#w-filter__column-double").off("click").on("click", function ()
        {
            // Don't show single column.
            $(`.j-productview.${singleColumnClass}`).removeClass(singleColumnClass);
            $(".j-productview .w-productcard").removeClass("w-productcard--small");

            // Set or update cookie.
            Cookies.set("CategoryPageMobileSingleColumn", "0", { expires: 365, path: "/" });

            // Show double column button as selected.
            $("#w-filter__column-double:not(.selected)").addClass("selected");
            $("#w-filter__column-single.selected").removeClass("selected");
        });

        $("#w-filter__column-single").off("click").on("click", function ()
        {
            // Show single column.
            $(`.j-productview:not(.${singleColumnClass})`).addClass(singleColumnClass);
            $(".j-productview .w-productcard").addClass("w-productcard--small");

            // Set or update cookie.
            Cookies.set("CategoryPageMobileSingleColumn", "1", { expires: 365, path: "/" });

            // Show single column button as selected.
            $("#w-filter__column-double.selected").removeClass("selected");
            $("#w-filter__column-single:not(.selected)").addClass("selected");
        });
    }
}

function initFiltersAndSearch(): void
{
    // Determine the origin of the page.
    if ($("#origin").length > 0)
        origin = $("#origin").val() as string;

    setSortEvents();

    let initialPageNr = 1;

    if (document.location.search.indexOf("page") >= 0)
    {
        // Determine pagenumber
        const tmpNr = parseInt(getParameterByName("page"), 10);

        if (tmpNr !== undefined && !isNaN(tmpNr))
            initialPageNr = tmpNr;
    }

    $("#pn").val(initialPageNr);
    $("#search_page").val(initialPageNr);
    $("#currentPage").val(initialPageNr);

    pushPageHistory(initialPageNr);

    initPaging(true, true);
    showPaging();

    checkForSortOrder();
    hideSingleBrandFilter();
}

function initArticlePriceText(): void
{
    if (getTranslations().propertiesToCheck.length > 0)
    {
        let showPrice = true;
        let isAllowedOption = false;

        // Get all selected filter properties using modern input constraints
        $(".j-filter__list .w-filter__sublist-item input:checked").each(function ()
        {
            const $this = $(this);
            const dataId = $this.data("id") as string;

            if (dataId)
            {
                const itemHash = dataId.replace("chk-", "").replace('_', '-').split('-');

                if (itemHash.length > 0 && getTranslations().propertiesToCheck.indexOf(itemHash[0]) !== -1)
                {
                    if (getTranslations().propertyOptionsToAllow.indexOf(itemHash[1]) !== -1)
                    {
                        showPrice = true;
                        isAllowedOption = true;
                        return false;
                    }
                    showPrice = false;
                }
            }
        });

        if (showPrice)
        {
            // Loop all modern product block elements.
            $(".w-productcard__holder[data-articlegroup]").each(function ()
            {
                const $productBlock = $(this);
                const numberOfActiveArticles = parseInt($productBlock.find('.product-sizes-count').val() as string, 10) || 0;

                let showPriceClass = false;

                // Don't add 'from' text to products with only one active article.
                if (numberOfActiveArticles > 1 || isAllowedOption)
                {
                    const articleGroupName = $productBlock.data("articlegroup") as string;

                    // Check if articlegroup is in list.
                    if (articleGroupName && articleGroupName.length > 0 &&
                        getTranslations().articleGroupsToCheck.indexOf(articleGroupName) !== -1
                    )
                        showPriceClass = true;
                }

                if (showPriceClass)
                {
                    // Show price text for this article.
                    $(".price-text:not(.hidden)", this).each(function ()
                    {
                        $(this).addClass('visible');
                    });
                }
                else
                {
                    // Hide price text for this article.
                    $(".price-text:not(.hidden)", this).each(function ()
                    {
                        $(this).removeClass('visible');
                    });
                }
            });
        }
    }
}

function initCategoryReadMore(): void
{
    if (mobileMediaQuery.matches)
    {
        if ($(".j-category .c-category-description").length > 0)
        {
            let inReadMore = false;

            $(".j-category .c-category-description > *").each(function (this: HTMLElement)
            {
                const $this = $(this);

                if (inReadMore)
                    $this.appendTo(".read-more-content");
                else if ($this.is("p"))
                {
                    if (!$this.next().is("p"))
                    {
                        if (!inReadMore)
                        {
                            inReadMore = true;

                            $("<div class=\"read-more-button\">" + getTranslations().txtReadMore + "</div>").insertAfter($this);
                            $("<div class=\"read-more-content\"></div>").insertAfter(".read-more-button");

                            $(".read-more-button").one("click", function (this: HTMLElement)
                            {
                                const $btn = $(this);
                                $btn.hide();
                                $btn.next().slideDown(500);
                            });
                        }
                        else
                            $this.appendTo(".read-more-content");
                    }
                }
            });
        }
    }
}

function initFAQ(): void
{
    $("ul.faqs:not(.customer-service-faq) a.opener")
        .off("click")
        .on("click", function (this: HTMLElement)
        {
            const $this = $(this);

            if (!$this.data("triggered"))
                $this.data("triggered", "true");
        }
        );
}

function initLastProd(): void
{
    if ($(".c-lastprod .w-productcard__holder").length > 0)
    {
        $(".c-lastprod .w-productcard__holder").on("click", function (this: HTMLElement)
        {
            const $this = $(this);
            const breadcrumbs = getBreadCrumbImpression();
            const items: Record<string, any> = {
                "currency": "EUR",
                "item_list_id": "1",
                "item_list_name": "Onlangs door je bekeken",
                "quantity": "1",
                "google_business_vertical": "retail"
            };

            // Mapping schema for dynamic data attribute extraction
            const dataMapping: Record<string, string> = {
                "name": "item_name",
                "sku": "item_id",
                "price": "price",
                "discount": "discount",
                "brand": "item_brand",
                "category": "item_category",
                "variant": "item_variant",
                "color": "item_color",
                "size": "item_size",
                "livingstyle": "item_woonstijl",
                "priceclass": "item_prijsklasse",
                "material": "item_materiaal",
                "stuffing": "item_vulling",
                "season": "item_seizoen",
                "deliverytime": "item_levertijd",
                "articlenumber": "item_smulcode",
                "sleepingposition": "item_slaaphouding",
                "firmness": "item_stevigheid",
                "stock": "item_voorraad",
                "type": "item_type",
                "thermalclass": "item_warmteklasse",
                "position": "index"
            };

            // Extract values dynamically from the data attributes.
            for (const dataKey in dataMapping)
            {
                if (Object.prototype.hasOwnProperty.call(dataMapping, dataKey))
                {
                    const ecommerceKey = dataMapping[dataKey];
                    const val = $this.data(dataKey);

                    if (val !== undefined && val !== null && val !== "")
                        items[ecommerceKey] = val;
                }
            }

            // Fill 'item_category2' up until 'item_category5'.
            for (let i = 3; i <= 6; i++)
            {
                const bcKey = "item" + i;
                if (breadcrumbs[bcKey] !== undefined && breadcrumbs[bcKey] !== "")
                    // From item3 to item_category2 etc.
                    items["item_category" + (i - 1)] = breadcrumbs[bcKey];
            }

            sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.
            sendDataLayer({
                "event": "productClick",
                "ecommerce": {
                    "items": [items]
                }
            });
        });
    }
}

function initButtonEvents(): void { };

function initBackToTopEvent(): void { };

//#endregion Initialise

//#region Filter property filterbar

function initFilterPropertyFilterbars(): void
{
    $(".j-filter__list-item:has(.w-filter__show-toggle:visible)").each(function (index, item)
    {
        const $item = $(item);

        if ($item.find(".w-filter__property-filter").length <= 0)
        {
            const titleText = $item.find(".w-filter__title").text().trim().toLowerCase();
            const inputWrapperHtml =
                `<div>` +
                `<input type="search" class="c-filter-search__input" oninput="applyPropertyOptionFilter(this);" placeholder="${getTranslations().txtSearchFor} ${titleText}..." />` +
                `<button class="c-filter-search__button btn-icon btn-icon-after ic-search-aft p-none"></button>` +
                `</div>`;

            $item.find(".w-filter__title").after(inputWrapperHtml);
        }
    });
}

function applyPropertyOptionFilter(input: HTMLInputElement): void
{
    const $input = $(input);
    const query = $input.val()?.toString().trim().toLowerCase() || "";

    const $listItem = $input.closest(".j-filter__list-item");

    const $pinnedOptionsList = $listItem.find(".w-filter__sublist-pinned");
    const $allOptionsList = $listItem.find(".w-filter__sublist");
    const $showToggle = $listItem.find(".w-filter__show-toggle");

    const hasPinnedOptions = $pinnedOptionsList.children().length > 0;
    const hasOptions = $allOptionsList.children().length > 0;

    if (query.length > 0)
    {
        if (hasPinnedOptions)
            $pinnedOptionsList.addClass("hidden");

        if (hasOptions)
            $allOptionsList.removeClass("hidden");

        $showToggle.addClass("hidden");

        $allOptionsList.find("li.w-filter__sublist-item").each(function (index, li)
        {
            const $li = $(li);

            const isChecked = $li.find("input[type='checkbox']").is(":checked");

            const optionTitle = $li.find(".w-filter__option-title").text().trim().toLowerCase();
            const matchesQuery = optionTitle.includes(query);

            if (isChecked || matchesQuery)
                $li.removeClass("hidden");
            else
                $li.addClass("hidden");
        });
    }
    else
    {
        const isShowingAll = $listItem.hasClass("w-filter__list-item--show-all");

        if (isShowingAll)
        {
            if (hasPinnedOptions)
                $pinnedOptionsList.addClass("hidden");
            if (hasOptions)
                $allOptionsList.removeClass("hidden");
        }
        else
        {
            if (hasPinnedOptions)
                $pinnedOptionsList.removeClass("hidden");
            if (hasOptions)
                $allOptionsList.addClass("hidden");
        }

        $showToggle.removeClass("hidden");

        $allOptionsList.find("li.w-filter__sublist-item").removeClass("hidden");
    }
}

(window as any).applyPropertyOptionFilter = applyPropertyOptionFilter;

//#endregion Filter property filterbar

//#region Filter

function buildPropertyList(): void
{
    if ($(sFilter).length > 0)
    {
        // Get the property IDs.
        $(`${sFilter} ${sFilterLists}`).each(function (this: HTMLElement)
        {
            const elementId = $(this).data("property-id") || 0;

            if (elementId > 0 && !propertyIDs.includes(elementId))
                propertyIDs.push(elementId);
        });
    }
}

function buildMobileFilters(): HTMLUListElement
{
    const filterHolder = document.createElement("ul");
    filterHolder.classList.add("w-filtermobile__list", "j-filter__list", "nolist");

    let counter = 0;

    $(".j-filter .j-filter__list-item:not(.w-filter__list-item--price)").each(function (index, element)
    {
        counter++;
        const $element = $(element);

        const propertyID = $element.data("property-id");
        const propertyTitle = $element.find(".w-filter__title").text();

        const $mobileElement = $(`.j-filtermobile .j-filter__list-item[data-property-id='${propertyID}']`);

        const isSlider = $element.find(".w-filter__slide").length > 0 || $element.find(".w-filter__slide--property").length > 0;
        const isColorProperty = $element.hasClass("w-filter__list-item--color");

        let isCollapsed =
            (
                $mobileElement.length <= 0 &&
                !document.querySelector(".w-main").classList.contains("ab-mobile-filter-expand")
            ) ||
            $mobileElement.hasClass("w-filter--collapsed");

        if (isCollapsed && counter <= 5 && !$mobileElement.hasClass("w-filter--collapsed"))
            isCollapsed = false;

        const propertyOptionHolder = document.createElement("ul");
        propertyOptionHolder.classList.add("w-filter__sublist", "nolist");

        if (isColorProperty)
            propertyOptionHolder.classList.add("w-filter__sublist--color");

        if (isSlider)
        {
            const sliderId: number = +$element.find(".range-prop-id").val()! || null;
            const sliderName: string = ($element.find(".range-name").val() || null) as string | null;
            const sliderOrgName: string = ($element.find(".range-org-name").val() || null) as string | null;
            const sliderMin: number = +$element.find(".prop-min").val()! || null;
            const sliderMax: number = +$element.find(".prop-max").val()! || null;
            const sliderCurMin: number = +$element.find(".prop-cur-min").val()! || null;
            const sliderCurMax: number = +$element.find(".prop-cur-max").val()! || null;
            const sliderUnit: string = ($element.find(".prop-unit").val() || null) as string | null;
            const sliderStep: number = +$element.find(".step").val()! || null;

            $(propertyOptionHolder).append(
                getSliderFilterHtml(
                    true,
                    sliderId,
                    sliderName,
                    sliderOrgName,
                    sliderStep,
                    sliderUnit,
                    sliderMin,
                    sliderMax,
                    sliderCurMin,
                    sliderCurMax
                )
            );
        }
        else
        {
            $element.find(".w-filter__sublist li").each(function (optionIndex, optionElement)
            {
                const optionClick = $(optionElement).attr("onclick");
                const optionID = $(optionElement).data("option-id");
                const optionTitle = $(optionElement).find(".w-filter__option-title").text();
                const optionUrl = $(optionElement).find(".w-filter__option-title").attr("href");
                const optionValue = $(optionElement).find("input").val();
                const optionValueChecked = $(optionElement).find("input").prop("checked");

                let colorClass = "";
                let colorBlock = "";
                if ($(optionElement).find(".w-filter__list-item-color").length > 0)
                {
                    colorClass = colourPropertyClass;
                    colorBlock = $(optionElement).find(".w-filter__list-item-color")[0].outerHTML;
                }

                let checkedHtml = "";
                if (optionValueChecked)
                    checkedHtml = `checked="checked"`;

                $(propertyOptionHolder).append(
                    `<li class="w-filter__sublist-item ${colorClass} u-checkradio-holder" title="${optionTitle}" data-property-id="${propertyID}" data-option-id="${optionID}" onclick="${optionClick}">` +
                    `<input type="checkbox" data-id="chk-${propertyID}-${optionID}" value="${optionValue}" ${checkedHtml} />` +
                    `${colorBlock}` +
                    `<a class="w-filter__option-title f-primary-s" href="${optionUrl}" title="${optionTitle}" tabindex="-1" data-no-instant>${optionTitle}</a>` +
                    `</li>`
                );
            });
        }

        const propertyHolder = document.createElement("li");
        propertyHolder.classList.add("w-filter__list-item", "j-filter__list-item");

        if (isSlider)
            propertyHolder.classList.add("w-filter__list-item--slider");

        if (isCollapsed)
            propertyHolder.classList.add("w-filter--collapsed");

        if (isColorProperty)
            propertyHolder.classList.add("w-filter__list-item--color");

        propertyHolder.setAttribute("data-property-id", propertyID);

        $(propertyHolder).append(
            `<span class="w-filter__title f-primary-m tl-bold" onclick="toggleFilterList(event, this);">${propertyTitle}</span>` +
            `<div class="w-filter__list-item-content">${propertyOptionHolder.outerHTML}</div>`
        );

        $(filterHolder).append(propertyHolder);
    });

    if ($(".j-filter .j-filter__list-item.w-filter__list-item--price").length > 0)
    {
        const $element = $(".j-filter .j-filter__list-item.w-filter__list-item--price");

        $(filterHolder).append(getMobilePriceFilterHTML($element));
    }

    return filterHolder;
}

function addFilterOption(parent: JQuery, propID: string | number, propData: PropData, isColorProperty: boolean, isSelected: boolean): boolean | void
{
    const itemSelector = String.format(
        "[data-id=property{0}_{1}]",
        escapeFilterOptionContent(propID),
        escapeFilterOptionContent(propData.id)
    );

    // Return if already added.
    if (parent.find(itemSelector).length > 0)
        return false;

    const selectedTemplate = "checked=\"checked\"";
    const itemSelectedClass = "checked";

    let template = "";

    if (isColorProperty)
        template = (propData.url != null && propData.url.length > 0) ? clone(colorLinkItemTemplate) : clone(colorItemTemplate);
    else
        template = (propData.url != null && propData.url.length > 0) ? clone(linkItemTemplate) : clone(itemTemplate);

    let pinnedClass = "";

    if (propData.pin)
        pinnedClass += " pinned";

    if (propData.pinsub)
        pinnedClass += " pinned-more";

    let staticDomain = shopConfig().staticDomain;

    if (staticDomain === undefined)
        staticDomain = "";

    let colorCodes: string[] = [];
    if (propData.colorcode !== undefined && propData.colorcode != null)
        colorCodes = propData.colorcode.split(";");

    const formattedTemplate = String.format(
        template,
        escapeFilterOptionContent(propID),
        escapeFilterOptionContent(propData.id),
        escapeFilterOptionContent(propData.name),
        isSelected ? selectedTemplate : "",
        propData.url != null ? escapeFilterOptionContent(propData.url) : "",
        isSelected ? itemSelectedClass : "", // {5}
        isColorProperty && propData.colorcode !== undefined && propData.colorcode != null
            ? colorCodes.length > 1
                ? String.format(colorTemplate, escapeFilterOptionContent(colorCodes[0]), escapeFilterOptionContent(colorCodes[1]))
                : String.format(colorTemplate, escapeFilterOptionContent(colorCodes[0]), escapeFilterOptionContent(colorCodes[0]))
            : "",
        pinnedClass,
        propData.logo.length > 0
            ? "background-image: url('" + escapeFilterOptionContent(propData.logo) + "');"
            : "background-image: transparent;",
        escapeFilterOptionContent(propData.title),
        "", // {10}
        "false",
        "",
        escapeFilterOptionContent(propData.articleCount),
        propData.disabled ? "true" : "false"
    );

    parent.append(formattedTemplate);
}

function createPropertyOptions(): void
{
    // Remove the events from the rows.
    $(".j-filter__list-item .w-filter__sublist-item").off().remove();
    $(".w-filter__show-toggle").remove();

    // Create the property options using the updated sublist class names
    makeSearch(".w-filter__sublist-pinned", pinnedPropertyArray, pinnedColorArray);
    makeSearch(".w-filter__sublist", propertiesArray, colorPropertiesArray);

    // Set the filters.
    setMoreFilters();
    filterExplanation = new FilterExplanation();
    setDeleteFilterVisibility();
    initActiveFilterBlocks();
    setQuickfilterButtonVisibilty();
    hideSingleBrandFilter();

    setTimeout(function ()
    {
        initPriceFilter(mobileMediaQuery.matches);
        initSlider();
    }, 1);

    $(".w-filter__sublist, .w-filter__sublist-pinned").parent("li").show();
}

function mobileFilterGetProperties(reset: boolean): void
{
    $(".j-filtermobile .j-filter__list").html(buildMobileFilters());

    // Preserve scroll offset after content was replaced.
    if (!reset)
        $(".j-filtermobile .g-popup__contentholder")[0].scrollTop = mobileFilterScrollTop;

    $(".j-filtermobile .c-filter-explanation").on("click", function (event: JQuery.TriggeredEvent)
    {
        const $this = $(this);
        currentMobileFilterProperty = $this.data("propertyID");

        event.preventDefault();
        event.stopPropagation();
    });

    hideSingleBrandFilter();
}

function setMoreFilters(): void
{
    const $toggleHolder = $(".j-filter .j-filter__list-item");
    if ($toggleHolder.length > 0)
    {
        let categoryID: string | number = 0;
        const $currentCategory = $("input[name='current_category']");
        let expandedPropertySelections = "";

        if ($currentCategory.length > 0)
            categoryID = $currentCategory.val() as string;

        if ($.stash.exists("expandedPropertySelections"))
            expandedPropertySelections = $.stash.get("expandedPropertySelections");

        $toggleHolder.each(function (this: HTMLElement)
        {
            const $holder = $(this);

            const isSlider = $holder.find(".w-filter__slide--property").length > 0;

            let $btnToggle = $holder.find(".w-filter__show-toggle");

            const $pinnedOptionList = $holder.find(".w-filter__sublist-pinned");
            const $optionList = $holder.find(".w-filter__sublist");

            const $pinnedOptionItems = $pinnedOptionList.find(".w-filter__sublist-item");
            const $optionItems = $optionList.find(".w-filter__sublist-item");

            const pinnedOptionCount = $pinnedOptionItems.length;
            const optionCount = $optionItems.length;

            let visible = 0;
            const visibleAttr = $holder.attr("data-visible");
            const optionsVisible = $optionList.is(":visible");

            if (visibleAttr !== undefined && !isNaN(Number(visibleAttr)))
                visible = parseInt(visibleAttr, 10);

            const hasSelected = $holder.find(".w-filter__sublist-item input:checked").length > 0;

            if (hasSelected && ($holder.find(".w-filter__sublist-item input:checked").length - 1) > visible)
                visible = $holder.find(".w-filter__sublist-item input:checked").length - 1;

            if (isSlider)
            {
                // TODO? Appears to work without. Might need changes here, still.
            }
            else
            {
                // No pinned options list: Show all options list, and remove toggle button.
                if ($pinnedOptionList.length === 0)
                {
                    $pinnedOptionList.addClass("hidden");
                    $optionList.removeClass("hidden");

                    $holder.addClass("w-filter__list-item--show-all");
                    $btnToggle.remove();
                }
                // Pinned and all options lists have same count: Show pinned options, and remove toggle button.
                else if (pinnedOptionCount === optionCount && pinnedOptionCount > 0)
                {
                    $pinnedOptionList.removeClass("hidden");
                    $optionList.addClass("hidden");

                    $holder.removeClass("w-filter__list-item--show-all");
                    $btnToggle.remove();
                }
                // Pinned and all options lists are different. Handle them.
                else
                {
                    $pinnedOptionList.removeClass("hidden");
                    $optionList.addClass("hidden");
                    $holder.removeClass("w-filter__list-item--show-all");

                    if ($btnToggle.length === 0 &&
                        (
                            (optionsVisible && $holder.find(".w-filter__sublist-item:hidden").length > 0) ||
                            optionCount - pinnedOptionCount > 0 ||
                            (optionCount - visible > 0 && visible > 0)
                        ) &&
                        visible !== optionCount)
                    {
                        $holder.closest(".j-filter__list-item").append("<a class=\"w-filter__show-toggle f-primary-s tl-bold btn-border-flow\" href=\"#\">" + getTranslations().txtShowMore + "</a>");
                        $btnToggle = $holder.closest(".j-filter__list-item").find(".w-filter__show-toggle");
                    }

                    const $listOption = $holder.closest(".j-filter__list-item");
                    let propertyID = 0;

                    if ($listOption.length > 0)
                        propertyID = parseInt($listOption.data("property-id") as string, 10) || 0;

                    if (propertyID > 0)
                    {
                        const currentPropertySelection = categoryID + "-" + propertyID;

                        if (expandedPropertySelections.includes(currentPropertySelection))
                        {
                            $pinnedOptionList.addClass("hidden");
                            $optionList.removeClass("hidden");

                            $holder.addClass("w-filter__list-item--show-all");

                            if ($btnToggle.length > 0)
                                $btnToggle.text(getTranslations().txtShowLess);
                        }
                    }

                    $btnToggle
                        .off("click")
                        .on("click", function (this: HTMLElement, e: JQuery.TriggeredEvent)
                        {
                            e.preventDefault();
                            const $thisBtn = $(this);
                            const isExpanding = $thisBtn.text() === getTranslations().txtShowMore;

                            if (isExpanding)
                            {
                                $pinnedOptionList.addClass("hidden");
                                $optionList.removeClass("hidden");

                                $holder.addClass("w-filter__list-item--show-all");
                                $thisBtn.text(getTranslations().txtShowLess);

                                updateExpandedPropertyStash(this, true);
                            }
                            else
                            {
                                $pinnedOptionList.removeClass("hidden");
                                $optionList.addClass("hidden");

                                $holder.removeClass("w-filter__list-item--show-all");
                                $thisBtn.text(getTranslations().txtShowMore);

                                updateExpandedPropertyStash(this, false);
                            }
                        });

                    $btnToggle.removeClass("disabled-cursor-loading");
                }
            }
        });
    }
}

function hideEmptyFilters(): void
{
    $(".j-filter__list-item").each(function ()
    {
        const $item = $(this);
        const $children = $item.find(".w-filter__sublist-pinned, .w-filter__sublist");

        if ($children.length <= 0)
            $item.hide();
        else
        {
            let subCount = 0;

            for (let i = 0; i < $children.length; i++)
                subCount += $($children[i]).children().length;

            if (subCount === 0)
                $item.hide();
        }
    });
}

function makeSearch(
    listSelector: string,
    propertyArray: PropData[][],
    colorArray: PropData[][]
): void
{
    let passedExisting = false;

    // Fill the lists.
    for (let i = 0; i < propertyIDs.length; i++)
    {
        const propID = propertyIDs[i];
        const isColorProperty = colorArray.indexOf(propID) >= 0;

        const $list = $(`#w-filter__list-item--${propID} ${listSelector}`);

        // Slider property.
        if (sliderFilterProperties.findIndex(x => x.property_id == propID) >= 0)
        {
            if ($list.length > 0 &&
                $list.find("li").length > 0)
            {
                $list.find("li").remove();

                const currentFilter = sliderFilterProperties.find(x => x.property_id == propID);

                const sliderId = currentFilter.property_id;
                const sliderName = currentFilter.name;
                const sliderOrgName = currentFilter.orgName;
                const sliderMin = currentFilter.min;
                const sliderMax = currentFilter.max;
                const sliderCurMin = currentFilter.curMin;
                const sliderCurMax = currentFilter.curMax;
                const sliderUnit = currentFilter.unit;
                const sliderStep = currentFilter.step;

                $list.append(
                    getSliderFilterHtml(
                        false,
                        sliderId,
                        sliderName,
                        sliderOrgName,
                        sliderStep,
                        sliderUnit,
                        sliderMin,
                        sliderMax,
                        sliderCurMin,
                        sliderCurMax
                    )
                );
            }
        }
        else if (propertyArray[propID] !== undefined && (propertyArray[propID].length > 0 || passedExisting))
        {
            const $select = $(".property" + propID);
            let $displayList: JQuery | null = null;

            if ($(".property_active" + propID).length > 0)
                $displayList = $(".property_active" + propID);

            if ($displayList == null)
                $displayList = $("#property_active");

            if ($list.length > 0)
                $list.find("li").remove();

            if ($select.length > 0)
            {
                $select.find("option").filter(function ()
                {
                    const val = $(this).attr("value");
                    return val !== undefined && Number(val) > 0;
                }).remove();
            }

            if ($displayList && $displayList.length > 0)
            {
                if (propertyArray[propID].length > 0)
                    $displayList.find("li[class^=activeprop" + propID + "]").remove();
                else if (propertyArray[propID].length > 0)
                    $displayList.find("li").remove();
            }

            // Loop through the properties and add list items or options for every found option.
            for (let j = 0; j < propertyArray[propID].length; j++)
            {
                let isSelected = false;

                if (propertyArray[propID][j].message !== undefined)
                    $list.append("<li class=\"w-filter__sublist-item message\">" + propertyArray[propID][j].message + "</li>");
                else
                {
                    if (properties[propID] !== undefined)
                    {
                        if (properties[propID].split(",").indexOf(propertyArray[propID][j]["id"].toString()) >= 0 ||
                            propertyArray[propID][j]["selected"] == 1)
                        {
                            isSelected = true;
                        }
                    }

                    if (typeof shopConfig === "undefined" || shopConfig().extraSearchAsList)
                        addFilterOption($list, propID, propertyArray[propID][j], isColorProperty, isSelected);
                    else
                    {
                        $(
                            "<option value=\"" + propertyArray[propID][j]["id"] + "\"" + (isSelected ? " selected=\"selected\"" : "") + ">" +
                            propertyArray[propID][j]["name"] +
                            "</option>"
                        ).appendTo($select);
                    }
                }
            }

            passedExisting = true;
        }
    }
}

function searchDetail(number: number, preservePage: boolean, element?: HTMLElement | JQuery): void
{
    if (isNaN(number))
        number = 0;

    // Updated 'property_list' query to match the new dynamic ID framework pattern
    if (number > 0 && getUrlVar("property" + number) == null &&
        $("#w-filter__list-item--" + number).find("input[type=checkbox]:checked").length === 0)
    {
        if (propertiesArray[number] !== undefined && propertiesArray[number] != null)
        {
            for (let i = 0; i < propertiesArray[number].length; i++)
            {
                if (propertiesArray[number][i].selected == 1)
                    propertiesArray[number][i].selected = 0;
            }
        }
    }

    if (number > 0 || number === -1)
    {
        if (document.location.hash.length >= 2 || priceFilterChanged)
        {
            if (!filterSpinner.isVisible())
            {
                $(".j-filter .j-filter__list").show();
                $(".w-productcard__holder").show();
                $(".j-category").css("height", "");
                $(".j-productview-content").css("height", "");
                // Todo check if needed?
                // filterSpinner.hide();
            }
        }
    }
    else
    {
        const nativeElement = element && (element as any).jquery ? (element as JQuery)[0] : (element as HTMLElement);

        updateFilters(number, false, preservePage, false, null, false, nativeElement, true);
    }
}

function checkForUpdateFilters(): void
{
    if (getUrlVar("shopmode") === "error")
        return;

    let hash = window.location.hash;
    if (hash.length === 0)
        return;

    if (hash.length >= 3)
    {
        const prefixes = ["#la", "#df", "#pa", "#pd"];
        const currentPrefix = hash.substring(0, 3);
        const prefixIndex = prefixes.indexOf(currentPrefix);

        if (prefixIndex > -1)
        {
            // Extract the sorting code directly ("la", "df", etc.)
            setSortOrderFromHash(currentPrefix.substring(1));
            hash = "#" + hash.substring(3);

            if (hash.length >= 4)
                hash = "#" + hash.substring(2);
        }
    }

    if (hash === "#")
        hash = "";

    const hashParts = hash.substring(1).split("_");
    for (let i = 0; i < hashParts.length; i++)
    {
        const part = hashParts[i];
        if (part.split("-").length === 1 && part !== "")
            setSortOrderFromHash(part);
    }

    if (hash.length > 1)
    {
        if (hash.indexOf("#") === 0)
            hash = hash.substring(1);

        const curContentHeight = $(".j-category").outerHeight() || 0;
        $(".j-category-result-count").text("");
        $(".j-category").height(curContentHeight);
        filterSpinner.show(true);
        searchDetail(0, true);
    }
}

function updateFilters(
    number: number,
    reloadResults?: boolean,
    preservePage?: boolean,
    resetPage?: boolean,
    categoryID?: string | number,
    triggerPagePush?: boolean,
    element?: HTMLElement,
    fromSearch?: boolean
): boolean | void
{
    if (categoryID === "error")
        return false;

    // Retrieve the pagenumber
    let pageNumber = 0;

    // When resetpage is true set pagenumber to 1.
    if (resetPage)
        pageNumber = 1;
    else
    {
        if ($("#pn").length > 0)
            pageNumber = parseInt($("#pn").val() as string) || 0;
        else if ($("input[name='search_page']").length > 0)
            pageNumber = parseInt($("input[name='search_page']").val() as string) || 0;
    }

    if (triggerPagePush)
    {
        // Up the page number.
        pageNumber++;
        $("#pn").val(pageNumber);
        $("input[name='search_page']").val(pageNumber);
    }

    if (pageNumber === 0 && document.location.search.includes("page"))
    {
        const tmpNr = parseInt(getParameterByName("page"));
        if (tmpNr !== undefined && !isNaN(tmpNr))
            pageNumber = tmpNr;
    }

    const fakeForm: Record<string, any> = {};

    // Get the current selected discount and page.
    if (categoryID === undefined)
        categoryID = 0;

    let category = "";
    if ($("input[name='current_category']").length > 0)
        category = $("input[name='current_category']").val() as string;

    if ($("input[name='current_category_id']").length > 0)
        categoryID = $("input[name='current_category_id']").val() as string | number;

    let searchUrl = "/Services/Modules/Webshop.asmx/GetFilterPropertyOptionsAndProducts?ajax=1" +
        "&isproduct=" + (($("input[name='is_product']").length > 0 && $("input[name='is_product']").val() == 1) ? 1 : 0) +
        "&t=" + new Date().getTime() +
        "&currentcategoryid=" + categoryID + "&page=" + pageNumber;

    let propID: string | number = 0;

    // Check the url for selected properties.
    const url = window.location.href;
    const urlValues: Record<string, string[]> = {};

    const urlParts = url.split("#");
    if (urlParts.length > 1)
    {
        // Create a form with all the optoins and post it
        const props = urlParts[1].split("_");

        for (let i = 0; i < props.length; i++)
        {
            const [pId, oId] = props[i].split("-");
            if (urlValues[pId] === undefined)
                urlValues[pId] = [];

            urlValues[pId].push(oId);
        }
    }

    // Check if new property types got added
    buildPropertyList();

    // Get the property values for the available property IDs.
    for (let i = 0; i < propertyIDs.length; i++)
    {
        propID = propertyIDs[i];
        if (urlValues[propID] !== undefined)
            properties[propID] = urlValues[propID].join();
        else
            properties[propID] = "";
    }

    if (shopmode === "search")
        searchUrl += "&searchpage=1";

    // Add the category to the url.
    if (category.length > 0)
    {
        searchUrl += "&category=" + category;

        if (location.pathname === "/")
            searchUrl += "&home=1";

        if ($("input[name='is_landingpage']").length > 0 && $("input[name='is_landingpage']").val() == 1)
            searchUrl += "&landingpage=1";

        if ($("input[name='landingspage_type']").length > 0 && $("input[name='landingspage_type']").val() != "")
            searchUrl += "&landingspage_type=" + $("input[name='landingspage_type']").val();

        if ($("input[name='landingspage_id']").length > 0 && $("input[name='landingspage_id']").val() != "0")
            searchUrl += "&landingspage_id=" + $("input[name='landingspage_id']").val();

        if ($("input[name='is_product']").length > 0 && $("input[name='is_product']").val() == 1)
            searchUrl += "&product=1";
    }

    if ($("#selected_discount").val() != "" && $("#selected_discount").val() != "0")
        searchUrl += "&percentage=" + $("#selected_discount").val();

    if ($(".nosearchresults .search-suggestion a").length > 0)
        searchUrl += "&keyword=" + $(".nosearchresults .search-suggestion a").data("suggestion");
    else if ($("#current_keyword").length > 0 && ($("#current_keyword").val() as string).length > 0)
        searchUrl += "&keyword=" + $("#current_keyword").val();
    else if (origin === "search" && $(".searchform.search-holder .search-input").length > 0 && ($(".searchform.search-holder .search-input").val() as string).length > 0)
        searchUrl += "&keyword=" + $(".searchform.search-holder .search-input").val();

    $(".j-paging").hide();

    let priceFilterMinValue = 0;
    let priceFilterMaxValue = 0;

    let $priceHolder = $(".j-filter .j-filter__list-item.w-filter__list-item--price");
    if (mobileMediaQuery.matches)
        $priceHolder = $(".j-filtermobile .j-filter__list-item.w-filter__list-item--price");

    if ($priceHolder.length > 0)
    {
        const orgMin = parseInt($priceHolder.find(".min").val() as string) || 0;
        const orgMax = parseInt($priceHolder.find(".max").val() as string) || 0;

        // Get current inputs with fallback to org prices if nothing was filled in.
        const inputMin = parseInt($priceHolder.find(".w-filter__price-curmin input").val() as string) || orgMin;
        const inputMax = parseInt($priceHolder.find(".w-filter__price-curmax input").val() as string) || orgMax;

        const prevMinValue = parseInt(getParameterByName("price-min")) || orgMin;
        const prevMaxValue = parseInt(getParameterByName("price-max")) || orgMax;

        {
            if (inputMin !== orgMin)
                priceFilterMinValue = inputMin;

            if (inputMax !== orgMax)
                priceFilterMaxValue = inputMax;

            if (inputMin !== prevMinValue ||
                inputMax !== prevMaxValue
            )
                priceFilterChanged = true;
        }

        
        if (priceFilterChanged)
        {
            let urlChanged = false;
            let newUrl = location.href;

            if (priceFilterMinValue === 0)
            {
                newUrl = removeURLParameter(newUrl, "price-min");
                urlChanged = true;
            }

            if (priceFilterMaxValue === 0)
            {
                newUrl = removeURLParameter(newUrl, "price-max");
                urlChanged = true;
            }

            if (urlChanged)
                history.pushState(null, null, newUrl);
        }

        // In case filter occured by search
        if ((inputMax === orgMax) && (inputMin === orgMin) && (prevMaxValue < orgMax) && fromSearch) 
            priceFilterMaxValue = prevMaxValue;

        if ((inputMax === orgMax) && (inputMin === orgMin) && (prevMinValue > orgMin) && fromSearch) 
            priceFilterMinValue = prevMinValue;

        if (priceFilterMinValue > 0)
            searchUrl += "&pricemin=" + priceFilterMinValue;

        if (priceFilterMaxValue > 0)
            searchUrl += "&pricemax=" + priceFilterMaxValue;
    }

    let propName = "";

    let filterMinValue = 0;
    let filterMaxValue = 0;

    if (propertySliderHolder != null)
    {
        let sliderChanged = false;
        const isMobile = mobileMediaQuery.matches;
        const mobilePropertySlider = $(".j-filtermobile .w-filter__slide--property");

        if (isMobile && mobilePropertySlider.length > 0)
        {
            mobilePropertySlider.each(function (idx: number, slider: HTMLElement)
            {
                propName = $(slider).find(".range-name").val() as string;
                const curMin = parseInt($(slider).parent().find(".prop-cur-min").val() as string) || 0;
                const min = parseInt($(slider).find(".prop-min").val() as string) || 0;
                const curMax = parseInt($(slider).parent().find(".prop-cur-max").val() as string) || 0;
                const max = parseInt($(slider).find(".prop-max").val() as string) || 0;

                if (getParameterByName(propName + "-min") != null && curMin === min)
                    sliderChanged = true;
                else
                    filterMinValue = curMin;

                if (getParameterByName(propName + "-max") != null && curMax === max)
                    sliderChanged = true;
                else
                    filterMaxValue = curMax;
            });
        }
        else
        {
            const desktopSliders = propertySliderHolder.filter(x => !x.target.classList.contains("j-filtermobile"));

            desktopSliders.forEach(function (item: any)
            {
                const target = $(item.target);

                if (target.length > 0)
                {
                    propName = target.find("input[name='prop-name']").val() as string;
                    const orgSliderMin = item.options.range.min;
                    const orgSliderMax = item.options.range.max;

                    if (!sliderChanged)
                    {
                        const currentSliderValues = item.get();
                        const minValue = Math.round(currentSliderValues[0]);
                        const maxValue = Math.round(currentSliderValues[1]);

                        if (getParameterByName(propName + "-min") != null && minValue === orgSliderMin)
                            sliderChanged = true;
                        else
                            filterMinValue = minValue;

                        if (getParameterByName(propName + "-max") != null && maxValue === orgSliderMax)
                            sliderChanged = true;
                        else
                            filterMaxValue = maxValue;
                    }
                }
            });

            if (propertySliderHolder.length === 0)
            {
                const parsedMin = parseInt(getParameterByName(propName + "-min"));
                const parsedMax = parseInt(getParameterByName(propName + "-max"));
                if (parsedMin > 0)
                    filterMinValue = parsedMin;
                if (parsedMax > 0)
                    filterMaxValue = parsedMax;
            }
        }

        if (sliderChanged)
        {
            let urlChanged = false;
            let newUrl = location.href;

            if (filterMinValue === 0)
            {
                newUrl = removeURLParameter(newUrl, propName + "-min");
                urlChanged = true;
            }

            if (filterMaxValue === 0)
            {
                newUrl = removeURLParameter(newUrl, propName + "-max");
                urlChanged = true;
            }

            if (urlChanged)
                history.pushState(null, null, newUrl);
        }

        if (filterMinValue > 0)
            searchUrl += "&" + propName + "min=" + filterMinValue;

        if (filterMaxValue > 0)
            searchUrl += "&" + propName + "max=" + filterMaxValue;
    }

    const searchAll = shopConfig != null && shopConfig().searchAllIfNoProperties != null && shopConfig().searchAllIfNoProperties;

    if (!searchAll && $("form[name='searchextraform'] input:checked").length === 0)
        $("#productsoverview").load(window.location.href + " #productsoverview");
    else
    {
        let formProperties = "";

        if (!mobileFilter)
        {
            $(".j-filter .w-filter__sublist .w-filter__sublist-item").filter(function (this: HTMLElement)
            {
                return $(this).find("input[type='checkbox']").prop("checked") === true;
            }).each(function (this: HTMLElement)
            {
                const $chk = $(this).find("input[type='checkbox']");
                formProperties += "&" + $chk.prop("id") + "=" + $chk.val();

                const parentElement = $(this).closest(".j-filter__list-item");
                const pIdAttr = parentElement.data("property-id");
                if (pIdAttr !== undefined && pIdAttr > 0)
                {
                    if (fakeForm["property" + pIdAttr] !== undefined && fakeForm["property" + pIdAttr].length > 0)
                        fakeForm["property" + pIdAttr] = "!" + $chk.val();
                    else
                        fakeForm["property" + pIdAttr] = $chk.val();
                }
            });
        }

        if (window.location.hash.length > 0)
        {
            if (formProperties.length === 0)
            {
                const urlProps = window.location.hash.substring(1).split("_");

                for (let i = 0; i < urlProps.length; i++)
                {
                    const urlProp = urlProps[i].split("-");

                    if (urlProp.length > 1)
                    {
                        formProperties += "&property" + urlProp[0] + "_" + urlProp[1] + "=" + urlProp[1];

                        if (fakeForm["property" + urlProp[0]] > 0)
                            fakeForm["property" + urlProp[0]] += "!" + urlProp[1];
                        else
                            fakeForm["property" + urlProp[0]] = urlProp[1];
                    }
                    else
                        setSortOrderFromHash(urlProp[0]);
                }
            }
            else
            {
                // reapply sorting separately if filter options were already retrieved from checkbox values
                window.location.hash.substring(1).split("_").forEach(function (token: string)
                {
                    if (token.split("-").length === 1)
                        setSortOrderFromHash(token);
                });
            }
        }

        const currentURL = document.location.pathname + document.location.hash;
        formProperties += "&url=" + currentURL;

        if (formProperties.length > 0)
            origin = "search";
        else if ($("#origin").length > 0)
            origin = $("#origin").val() as string;

        if (origin != null)
            searchUrl += "&origin=" + origin;

        if ($("select[name='orderSelect']").val() != null)
            searchUrl += "&filter=" + $("select[name='orderSelect']").val();

        if (window.location.hash.length === 0)
        {
            formProperties += "&forcecatview=1";
            fakeForm["forcecatview"] = 1;
        }
    }

    // Add all the properties to the URL, until we pass the last selected property.
    for (let i = 0; i < propertyIDs.length; i++)
    {
        const currentPropID = propertyIDs[i];

        if (properties[currentPropID] !== undefined && properties[currentPropID] !== "")
            fakeForm["property" + currentPropID] = properties[currentPropID].replace(/,/g, "!");
    }

    const callback = function (numberParam: number, useJson: boolean, reload: boolean, preservePageNumber: boolean)
    {
        return function (data: any)
        {
            trackableFilterTempStorage = {};

            let filterData: any = "";
            let resultData = "";
            let priceFilterData = "";
            let propertyFilterData = "";

            if (data.filterResponse !== null && data.filterResponse.length > 0)
                filterData = data.filterResponse;

            const fetchPriorityKeys = getFetchPriorityCountTags(getTemplate("catviewproduct.html"));

            // Render articles
            data.filterArticles.forEach(function (item: any, index: number)
            {
                try
                {
                    const optionTE = [];

                    optionTE.push({ "impressionTag": renderTemplate([], getTemplate("catviewimpression")) });

                    let priceeuro = "";
                    let pricecent = "";
                    if (item.price.toString().indexOf(",") >= 0 || item.price.toString().indexOf(".") >= 0)
                    {
                        const tmpPrice = item.price.toString();
                        priceeuro = tmpPrice.split(/[,.]/)[0];
                        pricecent = tmpPrice.split(/[,.]/)[1];
                    }
                    else
                    {
                        priceeuro = item.price;
                        pricecent = "00";
                    }

                    optionTE.push({ "priceeuroonly": priceeuro });
                    optionTE.push({ "pricecent": pricecent });
                    optionTE.push({ "variant": item.variant });

                    if (item.hasRemainingStock)
                        optionTE.push({ "hasremainingstock": "stock-info" });
                    else
                        optionTE.push({ "hasremainingstock": "" });

                    if (item.button !== undefined && item.button !== null)
                    {
                        const buttonTE = [];
                        if (item.button.line1Text.length > 0)
                            buttonTE.push({ "first": renderTemplate([{ "css_class": item.button.line1CssClass, "text": item.button.line1Text }] as any, getTemplate("productdetail.button0.html")) });
                        else
                            buttonTE.push({ "first": "" });

                        if (item.button.line2Text.length > 0)
                            buttonTE.push({ "second": renderTemplate([{ "css_class": item.button.line2CssClass, "text": item.button.line2Text }] as any, getTemplate("productdetail.button0.html")) });
                        else
                            buttonTE.push({ "second": "" });

                        buttonTE.push({ "button_name": item.button.name.HTMLAttributeEncode() });
                        buttonTE.push({ "button_class": item.button.cssClass });
                        buttonTE.push({ "first_class": item.button.line1CssClass });
                        buttonTE.push({ "second_class": item.button.line2CssClass });
                        buttonTE.push({ "image": item.button.sticker });

                        optionTE.push({ "button": renderTemplate(buttonTE, getTemplate("productdetail.button.html")) });
                    }
                    else
                        optionTE.push({ "button": "" });

                    optionTE.push({ "articlegroup": item.categoryTree });
                    optionTE.push({ "url": item.articleUrl });

                    optionTE.push({ "index": item.index });
                    optionTE.push({ "id": item.productID });
                    optionTE.push({ "pID": item.productID });
                    optionTE.push({ "aID": item.articleID });
                    optionTE.push({ "sku": item.sku });
                    optionTE.push({ "articlenr": item.sku });
                    optionTE.push({ "ean": item.ean });
                    optionTE.push({ "titlejsEscaped": item.productName.HTMLAttributeEncode() });
                    optionTE.push({ "brand": item.brand });
                    optionTE.push({ "categoryTree": item.categoryTree });

                    const imageUrl = item.images[0]?.image;

                    optionTE.push({ "name": item.productName });
                    optionTE.push({ "productName": item.productName });
                    optionTE.push({ "title": item.productName });
                    optionTE.push({ "summary": item.summary });
                    optionTE.push({ "detailPic": articleImagePaths["imageDetail"] + imageUrl });
                    optionTE.push({ "image": articleImagePaths["imageItem"] + imageUrl });
                    optionTE.push({ "imgstyle": "" });
                    optionTE.push({ "remainingstocktemplate": (item.hasRemainingStock ? renderTemplate([{ "stock": item.remainingStock }] as any, getTemplate("remainingstock.html")) : "") });
                    optionTE.push({ "hideplaceholder": (item.colors != null && item.colors.length > 0 ? "" : "hidden") });

                    optionTE.push({ "showforlowestprice": (item.lowestPrice ? "visible" : "hidden") });
                    optionTE.push({ "hide_old_price": (item.priceOld > 0 ? "" : "hidden") });

                    optionTE.push({ "incvatoldpriceformatted": (item.priceOld > 0 ? item.priceOldFormatted : "") });
                    optionTE.push({ "incvatoldpriceformattednocurrency": (item.priceOld > 0 ? item.priceOldFormattedNoCurrency : "") });

                    optionTE.push({ "incvatpriceformatted": (item.price > 0 ? item.priceFormatted : "") });
                    optionTE.push({ "incvatpriceformattednocurrency": (item.price > 0 ? item.priceFormattedNoCurrency : "") });

                    optionTE.push({ "show_free_shipping": "" });

                    // Render sizes
                    if (item.categoryOverlayProduct !== undefined && item.categoryOverlayProduct !== null && item.categoryOverlayProduct.images !== null)
                    {
                        let sizesTemplate = getTemplate("product.sizes.html");

                        const sizeKeys = Object.keys(item.categoryOverlayProduct.images);
                        const imageCount = sizeKeys.length;

                        if (imageCount == 1)
                            sizesTemplate = getTemplate("product.sizes.single.html");

                        const sizes: Record<string, any>[] = [];
                        sizeKeys.forEach(function (sizeKey)
                        {
                            const size = item.categoryOverlayProduct.images[sizeKey];
                            sizes.push({
                                "name": size.name,
                                "image": size.image,
                                "url": size.link
                            });
                        });

                        const sizesHtmlTE = [];
                        sizesHtmlTE.push({ "sizes": sizes });
                        sizesHtmlTE.push({ "size_count": imageCount });

                        optionTE.push({ "available_sizes": renderTemplate(sizesHtmlTE, sizesTemplate) });
                    }
                    else
                        optionTE.push({ "available_sizes": "" });

                    if (item.propertyValues !== undefined && item.propertyValues != null)
                    {
                        optionTE.push({ "material": item.propertyValues["material"] ?? "" });
                        optionTE.push({ "stuffing": item.propertyValues["stuffing"] ?? "" });
                        optionTE.push({ "season": item.propertyValues["season"] ?? "" });
                        optionTE.push({ "deliverytime": item.propertyValues["deliverytime"] ?? "" });
                        optionTE.push({ "sleepingposition": item.propertyValues["sleepingposition"] ?? "" });
                        optionTE.push({ "firmness": item.propertyValues["firmness"] ?? "" });
                        optionTE.push({ "thermalclass": item.propertyValues["thermalclass"] ?? "" });
                        optionTE.push({ "type": item.propertyValues["type"] ?? "" });
                    }
                    else
                    {
                        optionTE.push({ "material": "" });
                        optionTE.push({ "stuffing": "" });
                        optionTE.push({ "season": "" });
                        optionTE.push({ "deliverytime": "" });
                        optionTE.push({ "sleepingposition": "" });
                        optionTE.push({ "firmness": "" });
                        optionTE.push({ "thermalclass": "" });
                        optionTE.push({ "type": "" });
                    }

                    if (item.hasOldPrice !== undefined && item.hasOldPrice != null)
                        optionTE.push({ "hasoldprice": item.hasOldPrice ? "discount" : "" });

                    if (item.hasStock !== undefined && item.hasStock != null)
                        optionTE.push({ "hasstock": item.hasStock ? "" : "out-of-stock" });

                    const colors: Record<string, any>[] = [];
                    let numberNotShown = 0;

                    if (item.colors !== null)
                    {
                        item.colors.forEach(function (colorItem: any)
                        {
                            const colorJson: Record<string, any> = {};
                            colorJson["productURL"] = colorItem.productURL;
                            colorJson["colorcode"] = colorItem.colorCode;
                            colorJson["colorcode1"] = colorItem.colorCode1;
                            colorJson["colorcode2"] = colorItem.colorCode2;
                            if (colorItem.colorLogo !== undefined && colorItem.colorLogo != null && colorItem.colorLogo.length > 0)
                                colorJson["coloricon"] = `url('${shopConfig().staticDomain}/data/cms_uploads/webshop/property/${colorItem.colorLogo}')`;
                            else
                                colorJson["coloricon"] = "";

                            if (colors.length < 4)
                                colors.push(colorJson);
                            else
                                numberNotShown++;
                        });
                    }

                    optionTE.push({ "availablecolors": colors });
                    optionTE.push({ "hidenumber": numberNotShown > 0 ? "" : "hidden" });
                    optionTE.push({ "numbernotshown": numberNotShown });

                    const images: Record<string, any>[] = [];

                    if (item.images)
                    {
                        let firstImage = true;

                        item.images.forEach(function (imageItem: any)
                        {
                            const image: Record<string, any> = {};
                            image["imageItem"] = articleImagePaths["imageItem"] + imageItem.image;
                            image["imageThumbnail"] = articleImagePaths["imageThumbnail"] + imageItem.image;
                            image["imageDetail"] = articleImagePaths["imageDetail"] + imageItem.image;
                            image["imageLarge"] = articleImagePaths["imageLarge"] + imageItem.image;
                            image["imageVersion"] = imageItem.imageVersion;

                            switch (imageItem.imageType)
                            {
                                case 1:
                                    image["imageType"] = "AmbianceImage";
                                    break;
                                case 2:
                                    image["imageType"] = "FreestandingImage";
                                    break;
                                default:
                                    image["imageType"] = "unspecified";
                                    break;
                            }

                            for (let i = 0; i < fetchPriorityKeys.length; i++)
                            {
                                if (firstImage && index < fetchPriorityKeys[0].count)
                                    image[fetchPriorityKeys[0].key] = "high";
                                else
                                    image[fetchPriorityKeys[0].key] = "low";
                            }

                            images.push(image);
                            firstImage = false;
                        });
                    }

                    optionTE.push({ "images": images });

                    for (let i = 0; i < fetchPriorityKeys.length; i++)
                    {
                        const fetchPriorityObject: Record<string, string> = {};

                        if (index < fetchPriorityKeys[0].count)
                            fetchPriorityObject[fetchPriorityKeys[0].key] = "high";
                        else
                            fetchPriorityObject[fetchPriorityKeys[0].key] = "low";

                        optionTE.push(fetchPriorityObject);
                    }

                    // Set placeholder classes to handle later.
                    optionTE.push({ "list_id": `ph-list_id-${item.articleID}` });
                    optionTE.push({ "added": `ph-added-${item.articleID}` });

                    resultData += renderTemplate(optionTE, getTemplate("catviewproduct.html"));
                }
                catch (ex)
                {
                    console.error(ex);
                }
            });

            priceFilterData = renderPriceFilter(data.priceFilter);

            if (data.rangeFilters !== null && data.rangeFilters !== undefined)
            {
                if (Array.isArray(data.rangeFilters))
                {
                    sliderFilterProperties = [];

                    data.rangeFilters.forEach(function (rangeItem: RangeFilterItem)
                    {
                        sliderFilterProperties.push(rangeItem);

                        propertyFilterData += renderPropertyFilter(rangeItem);
                    });
                }
                else
                    propertyFilterData = renderPropertyFilter(data.rangeFilters);
            }

            filterExplanation = new FilterExplanation();

            setTimeout(function ()
            {
                // Re-check now that category content changed.
                const comparer = new ProductComparer(true);
                comparer.checkProdCompareAddButtons();
            }, 1);

            if (reload)
                reloadResults = true;

            if (useJson)
            {
                if (filterData != null && filterData.length >= 0)
                {
                    for (let i = 0; i < propertyIDs.length; i++)
                    {
                        const pId = propertyIDs[i];
                        propertiesArray[pId] = [];
                        pinnedPropertyArray[pId] = [];
                    }

                    // Loop through the pinned items and add them to their own array.
                    for (let i = 0; i < filterData.length; i++)
                    {
                        const obj = filterData[i];
                        const type = obj.type;

                        if (propertiesArray[type] !== undefined || pinnedPropertyArray[type] !== undefined)
                        {
                            if (obj.showLevel > 0)
                            {
                                const previousLevels = obj.previousLevels;
                                let message = "";
                                if (previousLevels != null)
                                {
                                    for (let j = 0; j < previousLevels.length; j++)
                                        message += (message.length > 0 ? " en" : "") + " een " + previousLevels[j].Value;
                                }

                                message = getTranslations().txtFirstSelectArticleGroup;

                                if (obj.pinned)
                                    pinnedPropertyArray[type].push({ "message": message } as unknown as PropData);
                                else
                                    propertiesArray[type].push({ "message": message } as unknown as PropData);
                            }
                            else
                            {
                                if (obj.type >= 0 && obj.id != null && obj.id > 0)
                                {
                                    const propInfo: PropData = {
                                        "id": obj.id,
                                        "name": obj.name,
                                        "url": obj.url,
                                        "selected": obj.selected,
                                        "disabled": obj.disabled,
                                        "pin": obj.pin,
                                        "pinsub": obj.pinsub,
                                        "logo": obj.logo,
                                        "title": obj.title,
                                        "articleCount": obj.articleCount
                                    };

                                    const additionals = obj.additionals;

                                    for (let j = 0; j < additionals.length; j++)
                                    {
                                        const additionalKey = additionals[j].key;
                                        const additionalValue = additionals[j].value;

                                        propInfo[additionalKey] = additionalValue;

                                        // Check if the property is a color property.
                                        if (additionalKey == "colorcode")
                                        {
                                            if (obj.pinned)
                                                pinnedColorArray.push(type);
                                            else
                                                colorPropertiesArray.push(type);
                                        }
                                    }

                                    if (obj.pinned)
                                        pinnedPropertyArray[type].push(propInfo);
                                    else
                                        propertiesArray[type].push(propInfo);
                                }
                            }
                        }
                    }
                }
            }

            $.EstrategyCookie.LoadAdditionalScripts();

            createPropertyOptions();

            // Set visibility after reloading result.
            setBatchFilterEnabledVisibility();

            $(".fittext").trigger("resize.fittext");
            $(".j-filter__list").show();
            $(".j-category").css("height", "");

            // Check if the pinned options should be shown or hidden.
            for (let i = 0; i < propertyIDs.length; i++)
            {
                const $propertyList = $(`#w-filter__list-item--${propertyIDs[i]}`);
                const notAllowedProperties = [
                    $propertyList.find(".w-filter__slide-holder")[0] !== undefined
                ]

                if ($propertyList.find(".w-filter__sublist-pinned .w-filter__sublist-item").length > 0
                    && notAllowedProperties.every((property) => property === false))
                {
                    const visibleCount = $propertyList.attr("data-visible");
                    const filterCount = $propertyList.find(".w-filter__sublist .w-filter__sublist-item").length;

                    // Check if all options are immediately visible
                    if (visibleCount !== undefined &&
                        filterCount !== undefined &&
                        parseInt(visibleCount) >= filterCount &&
                        filterCount > 0)
                    {
                        // All possible options are visible, use the default sortorder instead of the pinned sortorder
                        $propertyList.find(".w-filter__sublist-pinned").addClass("hidden");
                        $propertyList.find(".w-filter__sublist").removeClass("hidden");
                    }
                    else
                    {
                        $propertyList.find(".w-filter__sublist-pinned").removeClass("hidden");
                        $propertyList.find(".w-filter__sublist").addClass("hidden");
                    }
                }
                else if (notAllowedProperties.every((property) => property === false))
                {
                    // Slider filters are in pinned options only.
                    if ($propertyList.find(".w-filter__slide").length > 0)
                    {
                        $propertyList.find(".w-filter__sublist-pinned").removeClass("hidden");
                        $propertyList.find(".w-filter__sublist").addClass("hidden");
                    }
                    else
                    {
                        $propertyList.find(".w-filter__sublist-pinned").addClass("hidden");
                        $propertyList.find(".w-filter__sublist").removeClass("hidden");
                    }
                }
            }

            hideEmptyFilters();
            filterWizard.checkFilterWizardComplete();

            if ((reloadResults === undefined || reloadResults) && numberParam === 0 && (reloadResults || document.location.hash != ""))
            {
                // Post again
                $(".article-count-spinner .fa-spinner").show();

                let pageNum = 1;

                if (preservePageNumber && $("#pn").length > 0 && parseInt($("#pn").val() as string) > 0)
                    pageNum = parseInt($("#pn").val() as string);

                setPageAndSubmit(pageNum, -1);
            }

            filterWizard = new FilterWizard();

            // Search result
            $("#mainbanner").remove();
            $("#maintextblocks").remove();
            $(".catviewbanner").remove();
            $(".catviewdescription").remove();

            // Remove all products.
            $(".j-productview-content .w-productcard__holder").remove();

            let count = 0;
            let resultText = "";

            if ($(resultData).find(".j-category-result-count").length > 0)
                resultText = $(resultData).find(".j-category-result-count").text();
            else if (data.text !== undefined && data.text.resultText !== null)
                resultText = data.text.resultText;

            if (data.resultCount !== null)
                count = data.resultCount;

            if (resultText.length > 0)
            {
                if (!getTranslations().boolReplaceSearchResultInfoText)
                    $(".j-category-result-count").text(resultText);
                else
                    $(".j-category-result-count").text(resultText.replace("producten", "").replace("product", ""));

                mobileFiltersResetSelectedOptions();

                if (isNaN(count) || count == 0)
                    count = parseInt($(".j-category-result-count").text().substring(0, $(".j-category-result-count").text().indexOf(" "))) || 0;

                if (isNaN(count))
                {
                    if (!$(".j-category-result-count").hasClass("suggestion"))
                        $(".js-filtermobile__footer-button").html($(".j-category-result-count").text() + "<div class=\"article-count-spinner\"><i class=\"fa fa-spinner fa-spin\" style=\"display: none;\"></i>");
                }
                else
                {
                    if (count == 1)
                        $(".js-filtermobile__footer-button").html(`${getTranslations().txtUtilShow}<span class= "mobile-filter-count">1</span>${getTranslations().txtUtilProduct}<div class="article-count-spinner"><i class="fa fa-spinner fa-spin" style="display: none;"></i>`);
                    else
                        $(".js-filtermobile__footer-button").html(`${getTranslations().txtUtilShow}<span class= "mobile-filter-count">${count}</span>${getTranslations().txtUtilProducts}<div class="article-count-spinner"><i class="fa fa-spinner fa-spin" style="display: none;"></i>`);
                }
                $(".js-filtermobile__footer-button").find(".fa-spinner").hide();
            }
            else
                $(".j-category-result-count").text(getTranslations().txtZeroResultsFound);

            if (delayDataLayerSend && typeof (dataObject) !== "undefined")
            {
                dataObject.searchResultAmount = count;
                sendDataLayer(dataObject);
                delayDataLayerSend = false;
            }

            if (data !== null && data.searchInfo !== undefined && data.searchInfo !== null && data.searchInfo.keyword !== undefined && data.searchInfo.keyword !== null)
                $("#current_keyword").val(data.searchInfo.keyword);

            if ($(resultData).find(".c-productview__content-top .select-holder").length > 0)
            {
                // Get select-holder and wrap it in a paragraph to get the element itself as well.
                const resultSelectHolder = $(resultData).find(".c-productview__content-top .select-holder").wrap("</p>").parent();

                // Save selected sort option.
                const activeSortOptionValue = $(".c-productview__content-top .select-holder option:selected").val() as string;

                // Add the select-holder from the resultData.
                $(".c-productview__content-top .select-holder").wrap("</p>").parent().html(resultSelectHolder.html());

                // Unwrap the select-holder.
                $(".c-productview__content-top .select-holder").unwrap();

                const activeSortOption = $(".c-productview__content-top .select-holder option[value=" + activeSortOptionValue + "]");

                // Set selected sort option again, if sort option is either not pricediff, or pricediff is still visible.
                if (activeSortOptionValue != "price_diff" || !activeSortOption.hasClass("hidden"))
                    activeSortOption.attr("selected", "selected");

                // Re-initialise nativeJS select and set sort events.
                setTimeout(function ()
                {
                    initNativeSelect();
                    setSortEvents();
                }, 1);
            }

            // Append the content holder using uniform grid standard mappings
            if ($(".j-productview-content").length > 0)
            {
                if (data.filterArticles !== undefined)
                {
                    $(".j-productview-content").empty();
                    $(".j-productview-content").append(resultData);
                }
                else
                {
                    if ($(".j-productview-content .w-productcard__holder").length > 0 && parseInt($("input[name='search_page']").val() as string) > 1)
                        $(resultData).find(".j-productview-content .w-productcard__holder").insertAfter(".j-productview-content .w-productcard__holder:last");
                    else if ($(resultData).find(".j-productview-content").length > 0)
                        $(".j-productview-content").replaceWith($(resultData).find(".j-productview-content").append($(resultData).find("#current_category_id")));
                    else
                        $(".j-productview-content").replaceWith($(resultData));
                }
            }
            else
            {
                if ($(resultData).find(".j-productview-content").length > 0)
                    $(".nosearchresults").replaceWith($(resultData).find(".j-productview-content").append($(resultData).find("#current_category_id")));
                else
                    $(".nosearchresults").replaceWith($(resultData));
            }

            initProductColumnStyle();
            initArticlePriceText();
            new FavoritePopup();

            // Price and property slider filter
            if (priceFilterData != null || propertyFilterData != null)
            {
                let target;
                propertySliderHolder.forEach(function (item: any)
                {
                    target = item;
                    item.destroy();
                });

                propertySliderHolder = [];

                $(".w-filter__slide--price").each(function (this: HTMLElement)
                {
                    $(this).closest("li").show();
                    $(this).children().remove();
                    $(this).append(priceFilterData);
                    $(this).removeClass("noUi-target noUi-ltr noUi-horizontal");
                });

                $(".w-filter__slide--property").each(function (this: HTMLElement)
                {
                    const $filterHolder = $(this).closest(".j-filter__list-item");
                    const rangesliderPropertyID = $filterHolder.data("property-id");

                    const currentSlider = $("[data-property-id='" + rangesliderPropertyID + "']", ($(propertyFilterData).wrapAll($("<div>")).parent())).find(".range-holder");

                    const propName = currentSlider.find(".range-name").val();
                    const propId = currentSlider.find(".range-prop-id").val();
                    const propOrgName = currentSlider.find(".range-org-name").val();
                    const minValue = currentSlider.find(".prop-min").val();
                    const maxValue = currentSlider.find(".prop-max").val();
                    const curMinValue = currentSlider.find(".prop-cur-min").val();
                    const curMaxValue = currentSlider.find(".prop-cur-max").val();
                    const unitValue = currentSlider.find(".prop-unit").val() as string;
                    const stepValue = currentSlider.find(".step").val();

                    const slider =
                        `
                        <div class="range-holder">
                            <div class="w-filter__slide-units ui-slider">
                                <span class="property-handler w-filter__slide-units--first first f-primary-s">
                                    <span class="num"></span>
                                    <span class="unit">${unitValue}</span>
                                </span>
                                <span class="property-handler w-filter__slide-units--last last f-primary-s">
                                    <span class="num"></span>
                                    <span class="unit">${unitValue}</span>
                                </span>
                            </div>
                            <input type="hidden" name="prop-id" class="range-prop-id" value="${propId}" />
                            <input type="hidden" name="prop-name" class="range-name" value="${propName}" />
                            <input type="hidden" name="prop-org-name" class="range-org-name" value="${propOrgName}" />
                            <input type="hidden" name="prop-min" class="prop-min" value="${minValue}" />
                            <input type="hidden" name="prop-max" class="prop-max" value="${maxValue}" />
                            <input type="hidden" name="prop-cur-min" class="prop-cur-min" value="${curMinValue}" />
                            <input type="hidden" name="prop-cur-max" class="prop-cur-max" value="${curMaxValue}" />
                            <input type="hidden" name="prop-unit" class="prop-unit" value="${unitValue}" />
                            <input type="hidden" class="step" value="${stepValue}" />
                        </div>
                        `;

                    $(this).closest("li").show();
                    $(this).children().remove();
                    $(this).append(slider);
                    $(this).removeClass("noUi-target noUi-ltr noUi-horizontal");
                });

                $.EstrategyCookie.LoadAdditionalScripts();

                if (mobileFilter)
                {
                    updateMobileFilters();
                    initPriceFilter(true);
                }
                else
                    initPriceFilter(false);

                initSlider();
            }

            $.EstrategyCookie.LoadAdditionalScripts();

            let amount = 16;

            if ($("#amountSelect").length > 0)
                amount = parseInt($("#amountSelect").val() as string) || 16;
            else if ($("#default_amount").length > 0)
                amount = parseInt($("#default_amount").val() as string) || 16;

            let pagenumber = 1;
            if (data.pagination !== undefined && data.pagination !== null &&
                data.pagination.pageNumber !== undefined && data.pagination.pageNumber > 0)
            {
                pagenumber = data.pagination.pageNumber;
                $("#pn").val(data.pagination.pageNumber);
                $("#search_page").val(data.pagination.pageNumber);
                $("#currentPage").val(data.pagination.pageNumber);
                initialPageNumber = null;
                pushPageHistory(data.pagination.pageNumber);
            }
            else if ($(resultData).find("#search_page_nr").length > 0)
            {
                pagenumber = parseInt($(resultData).find("#search_page_nr").val() as string) || 1;
                $("#pn").val(pagenumber);
                $("#search_page").val(pagenumber);
                $("#currentPage").val(pagenumber);
                initialPageNumber = null;
                pushPageHistory(pagenumber);
            }
            else if ($("#pn").val() == "1")
            {
                $("#pn").val(1);
                $("#search_page").val(1);
                $("#currentPage").val(1);
                initialPageNumber = null;
                pushPageHistory(1);
            }

            initPaging(true, false);
            showPaging();

            // Initialize the lazy load for the new results using uniform mappings
            if ($(".j-productview-content img.lazy, .nosearchresults img.lazy").length > 0)
                initLazyLoad();

            while ($(".search_filters").length > 1)
                $(".search_filters:last").remove();

            // Show the results.
            $(".j-filter .j-filter__list").show();
            $(".j-category").css("height", "");
            $(".j-productview-content").css("height", "");

            if (newEvtHash != null)
                checkHashForSeo(newEvtHash);

            newEvtHash = null;

            $(".j-filter__list").show();
            $(".j-productview-content > .nosearchresults, .j-productview-content > .w-productcard__holder").show();

            filterSpinner.hide();

            filterWizard.checkFilterWizardComplete();
            resetProductOverlayEvents();
            initButtonEvents();
            initBackToTopEvent();

            // Check if the top products should be shown.
            addStashClickEvents();

            initMobileFilters();
            mobileFilterGetProperties(false);

            setDeleteFilterVisibility();
            initActiveFilterBlocks();
            hideSingleBrandFilter();
            checkExpandedFilters();

            // For paginated pages
            if (pagenumber > 1)
            {
                // Don't have a bottom text for paginated pages
                $(".text-holder").hide();

                // title tag
                const newResultTextCapital = String.format(getTranslations().pageNumberText, pagenumber);
                const newResultText = " " + newResultTextCapital.toLowerCase();
                const currentText = $("title").text();

                const pageIndex = currentText.indexOf(getTranslations().pageText);
                const pageSnippet = currentText.substring(pageIndex, currentText.length);

                if (pageIndex < 0)
                    $("title").text(currentText + " - " + newResultTextCapital);
                else
                    $("title").text(currentText.replace(pageSnippet, newResultTextCapital));

                // h1 tag
                let currentH1Text = $(".js-content-header h1").text();
                const h1PageIndex = currentH1Text.indexOf(getTranslations().pageText.toLowerCase());
                const h1PageSnippet = currentH1Text.substring(h1PageIndex, currentH1Text.length);

                if (h1PageIndex < 0)
                    $(".js-content-header h1").text(currentH1Text + " -" + newResultText);
                else
                    $(".js-content-header h1").text(currentH1Text.replace(h1PageSnippet, newResultText.substring(1)));

                // Breadcrumbs
                let appendBreadCrumb = true;
                let currentHref = "";

                $(".j-breadcrumbs").find("div a").each(function (this: HTMLElement)
                {
                    const thisHref = $(this).attr("href");
                    const thisTitle = $(this).attr("title");
                    if (thisHref != undefined && thisHref.includes("?page="))
                    {
                        const pIdx = thisHref.indexOf("?page=");
                        $(this).attr("href", thisHref.replace(thisHref.substring(pIdx), "?page=" + pagenumber));

                        if (thisTitle != undefined)
                        {
                            const tIdx = thisTitle.indexOf(getTranslations().pageText);
                            $(this).attr("title", thisTitle.replace(thisTitle.substring(tIdx), newResultTextCapital));
                        }

                        if ($(this).find("span").length > 0)
                        {
                            const currentTextNode = $(this).find("span").first().text();
                            const sIdx = currentTextNode.indexOf(getTranslations().pageText);
                            $(this).find("span").first().text(currentTextNode.replace(currentTextNode.substring(sIdx), newResultTextCapital));
                        }
                        else
                        {
                            const currentTextNode = $(this).first().text();
                            const sIdx = currentTextNode.indexOf(getTranslations().pageText);
                            $(this).first().text(currentTextNode.replace(currentTextNode.substring(sIdx), newResultTextCapital));
                        }
                        appendBreadCrumb = false;
                    }
                    else if (thisHref != undefined)
                        currentHref = thisHref;
                });

                if (appendBreadCrumb)
                {
                    $(".j-breadcrumbs").append(
                        `<div class="c-breadcrumbs__item">` +
                        `<a class="c-breadcrumbs__link" href="${currentHref}?page=${pagenumber}" title="${newResultTextCapital}">` +
                        `<span class="c-breadcrumbs__text">${newResultTextCapital}</span>` +
                        `</a>` +
                        `</div>`
                    );
                }
            }
            else
            {
                // Removes all reference to pagenumber outside the paginator
                $(".text-holder").show();

                const currentIndex = $("title").text().indexOf(" - " + getTranslations().pageText);
                if (currentIndex != -1)
                    $("title").text($("title").text().substring(0, currentIndex));

                const h1Index = $(".js-content-header h1").text().indexOf(" - " + getTranslations().pageText.toLowerCase());
                if (h1Index != -1)
                    $("h1").text($("h1").text().substring(0, h1Index));

                // Breadcrumbs
                $(".j-breadcrumbs").find("div a").each(function (this: HTMLElement)
                {
                    const thisHref = $(this).attr("href");

                    if (thisHref != undefined && thisHref.includes("?page="))
                        $(this).parent().remove();
                });
            }

            if (reloadPageAfterCallback)
            {
                reloadPageAfterCallback = false;
                loadTrackablePage(window.location.href, false);
            }

            filterWizard.applyingFilterFromWizard = false;
            fillFilterStash(false);
            refreshKeyboardInteractions();
            scrollToResults(true);

            setTimeout(() => {
                console.log("loading comparer");
                reInitProductComparer();
            }, 100);
        };
    };

    fakeForm["url"] = document.location.pathname + document.location.hash;

    const beforeSend = function (): void
    {
        if (ajaxCallFilters !== undefined && ajaxCallFilters !== null)
            ajaxCallFilters.abort();

        if (searchAjaxCall !== undefined && searchAjaxCall !== null)
            searchAjaxCall.abort();

        const curContentHeight = $(".j-category").outerHeight() || 0;
        $(".j-category").height(curContentHeight);

        filterSpinner.show(true);

        if (allowTimeout && !mobileFilter)
        {
            scrollTimeout = setTimeout(scrollToResults, 2000);
            allowTimeout = false;
        }
    };

    let currentItemIndex: number | null = null;
    let currentStorageLength: number | null = null;
    let currentBatchFilterSearchDelay = 0;

    if (element != null)
    {
        if (shopConfig().enableBatchFilter)
            currentBatchFilterSearchDelay = shopConfig().batchFilterSearchDelay;

        if (currentBatchFilterSearchDelay > 0)
        {
            if (currentFilterStorage.indexOf(element) < 0)
                currentFilterStorage.push(element);

            currentItemIndex = currentFilterStorage.indexOf(element);
            currentStorageLength = currentFilterStorage.length;
        }
    }

    setTimeout(function (): boolean | void
    {
        if (currentBatchFilterSearchDelay > 0)
        {
            if (currentFilterStorage.length !== currentStorageLength ||
                currentFilterStorage.indexOf(element!) !== currentItemIndex
            )
                return false;
        }

        const json: Record<string, string>[] = [];
        const queryStartIdx = searchUrl.indexOf("?");

        if (queryStartIdx >= 0)
        {
            const queryString = searchUrl.substring(queryStartIdx + 1);
            const parameter = queryString.split("&");

            parameter.forEach(function (item: string)
            {
                const [param, value] = item.split("=");
                if (param)
                    json.push({ [param]: value || "" });
            });
        }
        
        ajaxCallFilters = sendApiCall({
            endpoint: "/Filter/GetFilterPropertyOptionsAndProducts",
            shopMode: origin,
            rawUrl: location.pathname,
            qsDictionary: json,
            formDictionary: [fakeForm],
            callback: callback(number, true, true, preservePage),
            beforeSend: beforeSend
        });

        const $propListZero = $("#w-filter__list-item--0");
        if ($propListZero.length > 0)
        {
            $.ajax({
                type: "POST",
                url: searchUrl + "/ajax/1/discount/1/" + new Date().getTime() + "/",
                data: { url: window.location.href },
                dataType: "html",
                success: function (html: string)
                {
                    const $container = $propListZero.parent();
                    $container.show();
                    $propListZero.empty().append(html);

                    $.EstrategyCookie.LoadAdditionalScripts();

                    const currentDiscount = $("#selected_discount").val();
                    if (currentDiscount !== "" && $(`#property0_${currentDiscount}`).length > 0)
                        $(`#property0_${currentDiscount}`).prop("checked", true);

                    const $sublistItems = $propListZero.find(".w-filter__sublist-item");
                    if ($sublistItems.length > 0)
                    {
                        $sublistItems.off("click").on("click", function (this: HTMLElement)
                        {
                            const percentage = ($(this).find("label").attr("for") || "").replace("property0_", "");

                            if ($("#selected_discount").val() == percentage)
                                $("#selected_discount").val("");
                            else
                                $("#selected_discount").val(percentage);

                            setPageAndSubmit(1, 0);
                            return false;
                        });
                    }
                    else
                        $container.hide();

                    initNativeSelect();
                    initFiltersAndSearch();
                }
            });
        }

        setTimeout(function ()
        {
            currentFilterStorage = [];
        }, 1);

    }, currentBatchFilterSearchDelay);
}

function updateMobileFilters(source?: any): void
{
    updateMobilePropertyFilter();
    updateMobilePriceFilter(source);
    initPriceFilter(true);
}

function updateMobilePropertyFilter(): void
{
    const checkedProperties: number[] = [];

    const desktopSliders = propertySliderHolder.filter(x => !x.target.classList.contains("j-filtermobile"));

    $(desktopSliders).each(function (index: number, sliderHolder: any)
    {
        const $target = $(sliderHolder.target);

        if ($target.length > 0 && sliderHolder.target != null)
        {
            const propid = parseInt($target.find('.range-prop-id').val() as string, 10);

            // Prevent adding mobile filter twice
            if (!checkedProperties.includes(propid))
            {
                checkedProperties.push(propid);

                const $source = $(`.j-filter__list-item[data-property-id='${propid}']:not(.j-filtermobile .j-filter__list-item)`);

                if ($source.length > 0)
                {
                    const propID = $source.find(".range-prop-id").val();

                    // Don't add mobile slider filter if already present.
                    if (propID !== undefined &&
                        propID != null &&
                        Number(propID) > 0 &&
                        $(".j-filtermobile .j-filter__list-item[data-property-id=" + propID + "]").length <= 0)
                    {
                        const propId: number = +$source.find(".range-prop-id").val()! || null;
                        const propName: string = ($source.find(".range-name").val() || null) as string | null;
                        const propOrgName: string = ($source.find(".range-org-name").val() || null) as string | null;
                        const minValue: number = +$source.find(".prop-min").val()! || null;
                        const maxValue: number = +$source.find(".prop-max").val()! || null;
                        const curMinValue: number = +$source.find(".prop-cur-min").val()! || null;
                        const curMaxValue: number = +$source.find(".prop-cur-max").val()! || null;
                        const unitValue: string = ($source.find(".prop-unit").val() || null) as string | null;
                        const stepValue: number = +$source.find(".step").val()! || null;

                        let unitElement = '';
                        if (unitValue !== undefined && unitValue != null && unitValue.length > 0)
                            unitElement = `<span class="unit">${unitValue}</span>`;

                        $(".j-filtermobile .j-filter__list").find(`.w-filter__slide--property[data-property-id=${propID} .w-filter__sublist`).empty();

                        const optionSliderTE =
                            getSliderFilterHtml(
                                true,
                                propId,
                                propName,
                                propOrgName,
                                stepValue,
                                unitValue,
                                minValue,
                                maxValue,
                                curMinValue,
                                curMaxValue
                            );

                        $(".j-filtermobile .j-filter__list").find(`.w-filter__slide--property[data-property-id=${propID} .w-filter__sublist`).append(optionSliderTE);
                    }
                }
            }
        }
    });
}

function updateMobilePriceFilter(source?: HTMLElement | JQuery | null): void
{
    if (source == null)
        source = $(".j-filter .j-filter__list-item[data-property-id='price']");

    const $source = $(source);

    $(".j-filtermobile .j-filter__list").find(".w-filter__list-item--price").remove();

    const optionTE = getMobilePriceFilterHTML($source);

    $(".j-filtermobile .j-filter__list").append(optionTE);
}

function setPageAndSubmit(page: string | number, propertyID?: string | number | null, element?: HTMLElement | JQuery): void
{
    $("input[name='search_page']").val(page);
    $("#pn").val(page);

    if (propertyID)
    {
        const safePropertyID = Number(propertyID) && !isNaN(Number(propertyID)) ? Number(propertyID) : 0;

        searchDetail(safePropertyID, false, element);
    }
    else
        searchDetail(-1, false, element);
}

function clearPriceFilters(clearMin: boolean, clearMax: boolean): void
{
    const $priceHolder = $(".j-filter__list-item.w-filter__list-item--price");

    let min = 0;
    let max = 0;

    if (clearMin)
    {
        min = parseInt($priceHolder.find(".min").val() as string) || 0;
        $priceHolder.find(".cur-min").val(min);
    }
    else
        min = parseInt($priceHolder.find(".cur-min").val() as string) || 0;

    if (clearMax)
    {
        max = parseInt($priceHolder.find(".max").val() as string) || 0;
        $priceHolder.find(".cur-max").val(max);
    }
    else
        max = parseInt($priceHolder.find(".cur-max").val() as string) || 0;

    $priceHolder.find(".w-filter__price-curmin input").val(min);
    $priceHolder.find(".w-filter__price-curmax input").val(max);

    priceFilterChanged = true;
}

function resetFilters(event: Event | JQuery.TriggeredEvent): boolean
{
    try
    {
        $.stash.remove("dboActiveFilters");

        let currentEvent = event;
        if (!currentEvent)
            currentEvent = window.event as unknown as Event;

        // Support both native events and JQuery wrapper event targets safely
        const target = (currentEvent.target || (currentEvent as any).srcElement) as HTMLElement;
        const path = window.location.pathname;
        let pathSplit = path.split("/").filter(Boolean);
        const min = $(target).parent().siblings(".quick-filter").length > 0;

        if (pathSplit.length > 0)
        {
            const filterlessPath = getURLWithoutFilters();

            if (mobileFilter)
            {
                clearPriceFilters(true, true);
                clearPropertyFilters(true, true);

                history.pushState(null, "", "/" + filterlessPath + "/");
                updateFilters(0, true);

                $(".mobile-filter-delete-filters").addClass("hidden");
                $(".mobile-filter-header-title").text(getTranslations().txtFilter);

                mobileFilterGetProperties(true);
            }
            else
                window.location.href = "/" + filterlessPath + "/";

            sendDataLayer({
                "category": "productlist",
                "action": "filters wissen" + (min ? "-filterblock" : ""),
                "label": "filters wissen" + (min ? "-filterblock" : ""),
                "url": createVirtualURL(),
                "event": "filterClick"
            });
        }
    }
    catch (err)
    {
        console.error(err);
    }
    return false;
}

(window as any).resetFilters = resetFilters;

function mobileFiltersResetSelectedOptions(): void
{
    let hasSelected = false;

    $(".j-filter__list-item").each(function (this: HTMLElement)
    {
        const propertyID = $(this).data("property-id");
        let selectedOptions = "";
        const selectedOptionList: string[] = [];

        $(this).find(".w-filter__sublist-item").each(function (this: HTMLElement)
        {
            const $subItem = $(this);

            if ($subItem.find("input[type='checkbox']:checked").length > 0)
            {
                hasSelected = true;
                if ($(".mobile-filter-delete-filters").hasClass("hidden"))
                    $(".mobile-filter-delete-filters").removeClass("hidden");

                let optionValue = "";

                if ($subItem.find("a").length > 0)
                    optionValue = $subItem.find("a").text();
                else if ($subItem.find("label").length > 0)
                    optionValue = $subItem.find("label").text();

                if (selectedOptionList.indexOf(optionValue) < 0)
                {
                    selectedOptionList.push(optionValue);

                    if (selectedOptions.trim().length === 0)
                        selectedOptions = optionValue;
                    else
                        selectedOptions += ", " + optionValue;
                }
            }
        });

        if (!hasSelected)
            $(".mobile-filter-delete-filters").addClass("hidden");
        else
            $(".mobile-filter-delete-filters").removeClass("hidden");
    });
}

function setDeleteFilterVisibility(): void
{
    // TODO: Classes.
    let currentFilterCount = 0;

    const $activeFilters = $(".j-filter .j-filter__list-item:not(.hidden) .w-filter__sublist input:checked");

    // Get price filters.
    const curPriceMin = getParameterByName("price-min");
    const curPriceMax = getParameterByName("price-max");

    if ($activeFilters.length > 0)
        currentFilterCount += $activeFilters.length;

    if (curPriceMin !== undefined && curPriceMin != null && curPriceMin !== "")
        currentFilterCount += 1;

    if (curPriceMax !== undefined && curPriceMax != null && curPriceMax !== "")
        currentFilterCount += 1;

    const desktopSliders = propertySliderHolder.filter(x => !x.target.classList.contains("j-filtermobile"));

    $(desktopSliders).each(function (index: number, sliderHolder: any)
    {
        const $target = $(sliderHolder.target);

        if ($target.length > 0 && sliderHolder.target != null)
        {
            const propName = $target.find(".range-name").val() as string;
            const curPropertyMin = getParameterByName(propName + "-min");
            const curPropertyMax = getParameterByName(propName + "-max");

            if (curPropertyMin !== undefined && curPropertyMin != null && curPropertyMin !== "")
                currentFilterCount += 1;

            if (curPropertyMax !== undefined && curPropertyMax != null && curPropertyMax !== "")
                currentFilterCount += 1;
        }
    });

    if (currentFilterCount <= 0)
    {
        $(".js-filter__remove").hide();
        $(".js-filter__remove--mobile").hide();
    }
    else
    {
        $(".js-filter__remove").show();
        $(".js-filter__remove--mobile").show();

        if (currentFilterCount === 1)
        {
            $(".js-filter__remove").text(getTranslations().eraseFilterSingleText);
            $(".js-filter__remove--mobile").text(getTranslations().eraseMobileFilterSingleText);
        }
        else
        {
            $(".js-filter__remove").text(getTranslations().eraseFilterMultipleText);
            $(".js-filter__remove--mobile").text(getTranslations().eraseMobileFilterMultipleText);
        }
    }
}

function renderPropertyFilter(propertyFilter: any)
{
    return renderTemplate([propertyFilter], getTemplate("filter_range_item.html"));
}

function renderPriceFilter(priceFilter: any): string
{
    return renderTemplate([priceFilter], getTemplate("search_price.html"));
}

function setBatchFilterEnabledVisibility(): void
{
    const enabledRowSelector = ".w-filter__sublist-item[data-disabled=\"false\"]";

    $(".j-filter__list-item .w-filter__list-item-content").each(function (index: number, list: HTMLElement)
    {
        const $list = $(list);

        if ($list.find(".w-filter__sublist").length > 0)
        {
            const $listItem = $list.closest(".j-filter__list-item");
            let propertyID = $listItem.data("property-id");

            if (propertyID === undefined || propertyID == null)
                propertyID = 0;

            const enabledCount = $list.find(".w-filter__sublist " + enabledRowSelector).length;
            const isSlider = $list.find(".w-filter__slide--property").length > 0;

            if (enabledCount > 0)
            {
                $listItem.show();

                if (Number(propertyID) > 0)
                    $(`.j-filtermobile .j-filter__list-item[data-prop-id=${propertyID}]`).show();

                const $btnToggle = $listItem.find(".w-filter__show-toggle");

                if ($btnToggle.length > 0)
                {
                    let pinnedEnabledCount = -1;

                    if ($list.find(".w-filter__sublist-pinned").length > 0)
                        pinnedEnabledCount = $list.find(".w-filter__sublist-pinned " + enabledRowSelector).length;

                    if (pinnedEnabledCount >= 0 && pinnedEnabledCount !== enabledCount)
                    {
                        $btnToggle.show();

                        if ($list.hasClass("showall"))
                            $btnToggle.text(getTranslations().txtShowLess);
                        else
                            $btnToggle.text(getTranslations().txtShowMore);
                    }
                    else
                        $btnToggle.hide();
                }
            }
            else if (isSlider)
                $listItem.show();
            else
            {
                $listItem.hide();

                if (Number(propertyID) > 0)
                    $(`.j-filtermobile .j-filter__list-item[data-prop-id=${propertyID}]`).hide();
            }
        }
    });
}

function applyPriceFilters(sender: any): void
{
    const $holder = $(sender).closest(".j-filter__list-item[data-property-id='price']");

    const storedMin = parseInt($holder.find(".min").val() as string) || 0;
    const storedMax = parseInt($holder.find(".max").val() as string) || 0;

    const inputMin = parseInt($holder.find(".w-filter__price-curmin input").val() as string) || 0;
    const inputMax = parseInt($holder.find(".w-filter__price-curmax input").val() as string) || 0;

    // Apply values to all price filters.
    $(".w-filter__price-curmin input").val(inputMin);
    $(".w-filter__price-curmax input").val(inputMax);

    if (inputMin >= storedMin && inputMax <= storedMax)
    {
        const minChanged = ((previousPriceValue != null && previousPriceValue[0] != inputMin) || (previousPriceValue == null && inputMin != storedMin));
        const maxChanged = ((previousPriceValue != null && previousPriceValue[1] != inputMax) || (previousPriceValue == null && inputMax != storedMax));

        if (previousPriceValue == null ||
            previousPriceValue[0] != inputMin ||
            previousPriceValue[1] != inputMax)
        {
            previousPriceValue = [inputMin, inputMax];
            const preChangedUrl = location.href;

            if (inputMin == storedMin &&
                inputMin == storedMax)
            {
                reloadPageAfterCallback = true;
                clearPriceFilters(true, true);
                updateFilters(0, true);

                let newUrl = location.href;
                newUrl = removeURLParameter(newUrl, "price-min");
                newUrl = removeURLParameter(newUrl, "price-max");
                history.pushState(null, null, newUrl);
            }

            if (!preventSliderChange)
            {
                priceFilterChanged = true;
                preventSliderChange = true;
                $("#searchextraform input[name=origin]").val("search");
                $("#pn").val(0);
                updateFilters(0, false, false, true);
                $(".w-filter__slide--price.fixed input").remove();
                preventSliderChange = false;
            }

            if (minChanged || maxChanged)
            {
                sendDataLayer({
                    "category": "productlist",
                    "action": "price",
                    "label": Math.round(inputMin) + "-" + Math.round(inputMax),
                    "url": preChangedUrl,
                    "event": "filterClick"
                });
            }
        }
    }
}

(window as any).applyPriceFilters = applyPriceFilters;

function getMobilePriceFilterHTML($dataHolder: JQuery<HTMLElement>): string
{
    const minPrice = $dataHolder.find(".min").val();
    const maxPrice = $dataHolder.find(".max").val();
    const curMinPrice = $dataHolder.find(".cur-min").val();
    const curMaxPrice = $dataHolder.find(".cur-max").val();
    const step = $dataHolder.find(".step").val();

    const priceOption =
        `
        <li class="w-filter__list-item j-filter__list-item w-filter__list-item--price" data-property-id="price">
            <span class="w-filter__title f-primary-m tl-bold">${getTranslations().txtPrice}</span>
            <div class="w-filter__price-slide">
                <div class="w-filter__price-slide-top">
                    <span class="f-primary-s">&euro;</span>
                    <span class="w-filter__price-curmin">
                        <input name="curminprice" type="number" step="${step}" value="${curMinPrice}"/>
                    </span>
                    <span class="f-primary-s">${getTranslations().txtUntil}</span>
                    <span class="w-filter__price-curmax">
                        <input name="curmaxprice" type="number" step="${step}" value="${curMaxPrice}"/>
                    </span>
                    <button class="js-filter-price-apply btn-arrow" onclick="applyPriceFilters(this);"></button>
                </div>
                <div class="w-filter__slide w-filter__slide--price hidden">
                    <input type="hidden" name="min" class="min" value="${minPrice}"/>
                    <input type="hidden" name="max" class="max" value="${maxPrice}"/>
                    <input type="hidden" name="price-min" class="cur-min" value="${curMinPrice}"/>
                    <input type="hidden" name="price-max" class="cur-max" value="${curMaxPrice}"/>
                    <input type="hidden" class="step" value="${step}" />
                </div>
            </div>
        </li>
        `;

    return priceOption;
}

function getSliderFilterHtml(
    isMobile: boolean,
    propertyID: number,
    propertyName: string,
    propertyOrgName: string,
    sliderStep: number,
    sliderUnit: string,
    sliderMin: number,
    sliderMax: number,
    sliderCurMin: number,
    sliderCurMax: number
): string
{
    let mobileClass = "";
    if (isMobile)
        mobileClass = "j-filtermobile";

    const sliderHtml =
        `
        <div class="w-filter__slide w-filter__slide--property propertyslider ${propertyName} ${mobileClass}" data-property-id="${propertyID}">
            <div class="range-holder">
                <div class="w-filter__slide-units ui-slider">
                    <span class="property-handler w-filter__slide-units--first first f-primary-s">
                        <span class="num"></span>
                        <span class="unit">${sliderUnit}</span>
                    </span>
                    <span class="property-handler w-filter__slide-units--last last f-primary-s">
                        <span class="num"></span>
                        <span class="unit">${sliderUnit}</span>
                    </span>
                </div>
                <input type="hidden" name="prop-id" class="range-prop-id" value="${propertyID}" />
                <input type="hidden" name="prop-name" class="range-name" value="${propertyName}" />
                <input type="hidden" name="prop-org-name" class="range-org-name" value="${propertyOrgName}" />
                <input type="hidden" name="prop-min" class="prop-min" value="${sliderMin}" />
                <input type="hidden" name="prop-max" class="prop-max" value="${sliderMax}" />
                <input type="hidden" name="prop-cur-min" class="prop-cur-min" value="${sliderCurMin}" />
                <input type="hidden" name="prop-cur-max" class="prop-cur-max" value="${sliderCurMax}" />
                <input type="hidden" name="prop-unit" class="prop-unit" value="${sliderUnit}" />
                <input type="hidden" class="step" value="${sliderStep}" />
            </div>
        </div>
        `;

    return sliderHtml;
}

//#endregion Filter

//#region Toggle filter list

function checkExpandedFilters(): void
{
    // TODO: Change 'showall' class.
    const $moreHolder = $(".js-more");
    if ($moreHolder.length > 0)
    {
        let categoryID: string | number = 0;
        const currentCategory = $("input[name='current_category']");
        let expandedPropertySelections = "";

        if (currentCategory.length > 0)
            categoryID = currentCategory.val() as string | number;

        if ($.stash.exists("expandedPropertySelections"))
            expandedPropertySelections = $.stash.get("expandedPropertySelections");

        $moreHolder.each(function (this: HTMLElement)
        {
            const $holder = $(this);
            const $btnToggle = $holder.find(".w-filter__show-toggle");

            if ($holder.find(".w-filter__sublist-item:not(:visible)").length == 0)
                $btnToggle.hide();

            const $items = $holder.find(".w-filter__sublist-item");
            let propertyID = 0;
            const $listOption = $btnToggle.closest(".j-filter__list-item");

            if ($listOption.length > 0)
                propertyID = $listOption.data("property-id");

            if (propertyID > 0)
            {
                const currentPropertSelection = categoryID + "-" + propertyID;

                // Check to see if filteroptions should be expanded.
                if (expandedPropertySelections.includes(currentPropertSelection))
                {
                    $btnToggle.siblings(".w-filter__sublist-pinned").addClass("hidden");
                    $btnToggle.siblings(".w-filter__sublist").removeClass("hidden");
                    $items.show();
                    $holder.addClass("showall");
                }
            }
        });
    }
}

export const toggleFilterList = (e: Event, header: HTMLElement): void =>
{
    if (e?.target && $(e.target).hasClass("js-filter-explanation-icon"))
        return;
    else if (header)
        $(header).parent().toggleClass("w-filter--collapsed");
}

(window as any).toggleFilterList = toggleFilterList;

//#endregion Toggle filter list

//#region Toggle filter option

interface TrackableFilterStorage
{
    hasitem?: boolean;
    element?: HTMLElement;
    mobile?: boolean;
    isFilterBlock?: boolean;
}

// Used to keep track of a currently loading trackable filter.
// If another filter is (de)activated before this one is done, it will be cancelled and
// applied as a non-trackable filter instead.
// Example:
// - Add trackable '1-persoons'
// - Add trackable '2-persoons' (will be handled as non-trackable)
// - Now trackable '1-peroons' is cancelled; '1-persoons' and '2-persoons' are applied as
//   non-trackable in that order.
let trackableFilterTempStorage: TrackableFilterStorage = {};
(window as any).filteringInProgress = false;

// Keeps track of the current filters that have to be applied.
// This is also used to prevent applying a filter after 'batchFilterSearchDelay' passed
// if there was a new filter added in the meantime.
let currentFilterStorage = [];

function toggleFilterOption(
    event: Event,
    element: HTMLElement,
    mobile: boolean,
    useURL: boolean,
    isFilterBlock: boolean
): void
{
    // Keep track of mobile filter scroll offset to preserve it after callback.
    const $contentHolder = $(".j-filtermobile .g-popup__contentholder");
    mobileFilterScrollTop = 0;

    if ($contentHolder.length > 0)
        mobileFilterScrollTop = $contentHolder[0].scrollTop;

    // Show loading spinner immediately to prevent clicking multiple filters.
    if (!shopConfig().enableBatchFilter)
    {
        const curContentHeight = $(".j-category").outerHeight();
        $(".j-category").height(curContentHeight);
        filterSpinner.show(true);
    }

    // Don't use URL if there was already a call.
    if (shopConfig().enableBatchFilter &&
        (window as any).filteringInProgress)
    {
        // Only enforce no URL (non-trackable) if filtering is currently in progress.
        useURL = false;

        if (trackableFilterTempStorage.hasitem)
        {
            const tempElement = trackableFilterTempStorage.element;
            const tempMobile = trackableFilterTempStorage.mobile;
            const tempIsFilterBlock = trackableFilterTempStorage.isFilterBlock;

            trackableFilterTempStorage = {};

            // Reinitiate trackable filter as non-trackable, before continuing with current filter as non-trackable.
            toggleFilterOption(event, tempElement, tempMobile, false, tempIsFilterBlock);

            const $element = $(tempElement);
            const isRowItem = $element.hasClass("w-filter__sublist-item");

            // Keep checkbox visually checked!
            if (isRowItem)
                $element.find("input[type='checkbox']").prop("checked", true);
        }
    }
    else
    {
        if (useURL == null)
        {
            useURL =
                $(element).find("a").length > 0 &&
                $(element).find("a").attr("href") != "#";
        }
    }

    (window as any).filteringInProgress = true;

    isFilterBlock ??= $(element).data("minimal");

    if (shopConfig().enableBatchFilter)
    {
        if (useURL)
        {
            trackableFilterTempStorage.hasitem = true;
            trackableFilterTempStorage.element = element;
            trackableFilterTempStorage.mobile = mobile;
            trackableFilterTempStorage.isFilterBlock = isFilterBlock;
        }
    }

    const $element = $(element);

    toggleOption(element, useURL, isFilterBlock);

    if (mobile)
    {
        $(".js-filtermobile__footer-button").find(".fa-spinner").show();

        if ($(".mobile-filter-delete-filters").hasClass("hidden"))
            $(".mobile-filter-delete-filters").removeClass("hidden");

        const $checkbox = $element.find("input[type=checkbox]");
        const isChecked = $checkbox.prop("checked");
        $checkbox.prop("checked", !isChecked);
    }

    let dataProperty = $(element).data("property-id");

    if (typeof (dataProperty) === typeof (undefined) || dataProperty == null)
        dataProperty = $(element).parent().data("property-id");

    selectProp(dataProperty, element);

    event.preventDefault();
    event.stopPropagation();
}

function selectProp(propertyID: number | string, element: HTMLElement): void
{
    clearTimeout(scrollTimeout);
    allowTimeout = true;
    searchQueue = [];

    // Set the page to one and submit the search form.
    if (!mobileFilter)
        setPageAndSubmit(1, propertyID, element);
}

function toggleOption(element: HTMLElement, useURL: boolean, isFilterBlock: boolean): void
{
    let onBrandPage = false;
    let hashSuffix = "";
    let propID = 0;
    let optionID = 0;

    const $element = $(element);

    if ($element.data("property-id") !== undefined)
        propID = $element.data("property-id");

    if ($element.data("option-id") !== undefined)
        optionID = $element.data("option-id");

    hashSuffix = propID + "-";

    let propValueName = "";
    let propertyName = "";

    propValueName = $element.find("a").text().toLowerCase();
    propertyName = $element.closest(".j-filter__list-item").find(".w-filter__title").text().toLowerCase();

    if (!propertyName)
        propertyName = $(`#w-filter__list-item--${propID}`).find(".w-filter__title").text().toLowerCase();

    if (isFilterBlock || overrideIsListBlock)
        propertyName += "--filterblock";

    overrideIsListBlock = false;

    // Check if we have hash and it's not already active.
    if (propertyName.length > 0 &&
        propValueName.length > 0)
    {
        let filterHash = window.location.hash;
        const newFilterHash = hashSuffix + optionID;

        if (newFilterHash.length > 0 &&
            propID > 0 &&
            optionID > 0 &&
            !filterHash.includes(newFilterHash) &&
            window.location.href.indexOf(propValueName) === -1)
        {
            if (filterHash.length > 0)
                filterHash += '_' + newFilterHash;
            else
                filterHash = '#' + newFilterHash;
        }

        sendDataLayer({
            "category": "productlist",
            "action": propertyName,
            "label": propValueName,
            "url": createVirtualURL(filterHash),
            "event": "filterClick"
        });
    }

    if (useURL)
    {
        if (typeof (Storage) != "undefined")
        {
            let items: string[] = [];
            const history = localStorage.getItem("searchHistory");
            if (history != null)
                items = history.split(";");

            items.push(document.location.href);
            localStorage.setItem("searchHistory", items.join(";"));
        }
    }

    const $checkbox = $element.find("input[type='checkbox']");
    const isChecked = $checkbox.prop("checked");
    if (isChecked)
    {
        $checkbox.removeAttr("checked");
        $checkbox.prop("checked", false);
    }
    else
        $checkbox.prop("checked", true);

    if (useURL)
    {
        const qsArr: string[] = [];
        let qs = "";

        if ($("input[name='price-min']").length > 0 && $("input[name='min']").length > 0)
        {
            const $minInput = $(".w-filter__price-slide input[name='price-min']");
            if ($(".w-filter__price-slide input[name='min']").val() != $minInput.val() ||
                (
                    getParameterByName("price-min") != "" &&
                    $minInput.val() == getParameterByName("price-min")
                )
            )
                qsArr.push("price-min=" + $minInput.val());
        }

        if ($("input[name='price-max']").length > 0 && $("input[name='max']").length > 0)
        {
            const $maxInput = $(".w-filter__price-slide input[name='price-max']");
            if ($(".w-filter__price-slide input[name='max']").val() != $maxInput.val() ||
                (
                    getParameterByName("price-max") != "" &&
                    $maxInput.val() == getParameterByName("price-max")
                )
            )
                qsArr.push("price-max=" + $maxInput.val());
        }

        if (qsArr.length > 0)
            qs = "?" + qsArr.join("&");

        appendQS($element.find("a").attr("href"), qs, element);
    }
    else
    {
        let tmpOption = $element.attr("title") || "";
        let handled = false;
        const $brandIdInput = $("#brand_id");

        if ($brandIdInput.length > 0 &&
            $brandIdInput.val() != "" &&
            !isNaN(parseInt($brandIdInput.val() as string)) &&
            $brandIdInput.val() == propID)
        {
            const brandId = parseInt($brandIdInput.val() as string);

            if (isChecked)
            {
                // Target the new uniform <li> elements that are actively checked under this brand property block
                const $activeBrandItems = $(`#w-filter__list-item--${brandId}.w-filter__sublist-item`).filter(function (this: HTMLElement)
                {
                    return $(this).find("input[type='checkbox']").prop("checked") === true;
                });

                if ($activeBrandItems.length > 1)
                {
                    let newhash = "#";

                    // Rebuild the filter hash based on all checked new list items across the whole filter component
                    $(".w-filter__sublist-item").filter(function (this: HTMLElement)
                    {
                        return $(this).find("input[type='checkbox']").prop("checked") === true;
                    }).each(function (this: HTMLElement)
                    {
                        const $item = $(this);
                        const pId = $item.data("property-id");
                        const oId = $item.data("option-id");
                        const itemHash = `${pId}-${oId}`;

                        if (newhash === "#")
                            newhash += itemHash;
                        else
                            newhash += "_" + itemHash;
                    });

                    if (newhash === "#")
                        newhash = "";

                    let newurl = window.location.href;
                    if (newurl.indexOf("#") > 0)
                        newurl = newurl.substring(0, newurl.indexOf("#"));
                    newurl += newhash;

                    // Strip active brand names from the URL.
                    $activeBrandItems.each(function (this: HTMLElement)
                    {
                        const $item = $(this);
                        let title = $item.attr("title");
                        if (title == null)
                            title = $item.find("a").attr("title");

                        if (title != null)
                        {
                            // Replace accented characters with non-accented equivelants. Normalize splits é into e and `
                            title = title.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                            title = title.replace(/[^a-zA-Z ]/g, "").replaceAll(" ", "-");
                            title = title.toLowerCase() + "/";
                        }

                        onBrandPage = onBrandPage || newurl.indexOf(title || "") > -1;
                        newurl = newurl.replace(title || "", "");
                    });

                    if (newhash.length == 0)
                    {
                        handled = true;
                        loadTrackablePage(newurl, false, false, false, element);
                    }
                }
            }
        }

        if (!handled)
            toggleURLHash(hashSuffix + optionID, tmpOption, element);
    }

    if (!mobileFilter || onBrandPage)
        checkHashForMultipleBrands(useURL);

    if (!mobileFilter)
        fillFilterStash(false);

    return;
}

function createVirtualURL(hash?: string): string | void
{
    if (hash == null)
        hash = window.location.hash;

    if (blockVirtualPageView != null)
    {
        blockVirtualPageView = null;
        return;
    }

    let url = document.location.pathname.toLowerCase();
    let query = document.location.search.toLowerCase();

    let priceMin = 0;
    let priceMax = 0;

    interface PropertyValue
    {
        Name: string;
        Min: string | number;
        Max: string | number;
    }

    const propertyValues: PropertyValue[] = [];

    {
        const $priceHolder = $(".j-filter__list-item.w-filter__list-item--price");

        const minValue = parseInt($priceHolder.find("input[name='min']").val() as string);
        const maxValue = parseInt($priceHolder.find("input[name='max']").val() as string);
        const currentMin = parseInt($priceHolder.find(".cur-min").val() as string);
        const currentMax = parseInt($priceHolder.find(".cur-max").val() as string);

        if (currentMin > minValue && currentMin < maxValue)
            priceMin = currentMin;

        if (currentMax < maxValue && currentMax > minValue)
            priceMax = currentMax;
    }

    if (propertySliderHolder != null && propertySliderHolder.length > 0)
    {
        const checkedProperties: string[] = [];

        const desktopSliders = propertySliderHolder.filter(x => !x.target.classList.contains("j-filtermobile"));

        desktopSliders.forEach(function (item: any)
        {
            const target = $(item.target).parent().parent();

            if (target != null)
            {
                const propName = $(target).find("input[name='prop-name']").val() as string;

                // Prevent adding active filter twice.
                if (!checkedProperties.includes(propName))
                {
                    checkedProperties.push(propName);

                    const minValue = parseInt($(target).find("input[name='prop-min']").val() as string);
                    const maxValue = parseInt($(target).find("input[name='prop-max']").val() as string);
                    const currentMin = parseInt($(target).find(".prop-cur-min").val() as string);
                    const currentMax = parseInt($(target).find(".prop-cur-max").val() as string);

                    // Current user selected values
                    let selectedMinValue: number = currentMin;
                    let selectedMaxValue: number = currentMax;

                    if (minValue == currentMin && getParameterByName(propName + "-min").length > 0)
                    {
                        selectedMinValue = parseInt(getParameterByName(propName + "-min"));
                        $(".prop-cur-min").val(selectedMinValue);
                    }

                    if (currentMin > minValue && currentMin < maxValue)
                        selectedMinValue = currentMin;
                    // Prevent removing the url filter parameter if min and max value are equal
                    else if (selectedMinValue == 0 && currentMin == currentMax && maxValue == currentMin)
                        selectedMinValue = currentMin;

                    if (selectedMinValue == 0 && parseInt(getParameterByName(propName + "-min")) > 0)
                        selectedMinValue = currentMin;

                    if (selectedMinValue == minValue)
                        selectedMinValue = 0;

                    if (maxValue == currentMax && getParameterByName(propName + "-max").length > 0)
                    {
                        selectedMaxValue = parseInt(getParameterByName(propName + "-max"));
                        $(".prop-cur-max").val(selectedMaxValue);
                    }

                    if (currentMax < maxValue && currentMax > minValue)
                        selectedMaxValue = currentMax;
                    // Prevent removing the url filter parameter if min and max value are equal
                    else if (selectedMaxValue == 0 && currentMin == currentMax && minValue == currentMax)
                        selectedMaxValue = currentMax;

                    if (selectedMaxValue == 0 && parseInt(getParameterByName(propName + "-max")) > 0)
                        selectedMaxValue = currentMax;

                    if (selectedMaxValue == maxValue)
                        selectedMaxValue = 0;

                    if (selectedMinValue > 0 || selectedMaxValue > 0)
                    {
                        propertyValues.push({
                            Name: propName,
                            Min: selectedMinValue,
                            Max: selectedMaxValue
                        });
                    }
                }
            }
        });
    }

    const valueArray: Record<string, string | number> = {};

    if (priceMin > 0)
        valueArray["price-min"] = priceMin;

    if (priceMax > 0)
        valueArray["price-max"] = priceMax;

    // Parse existing query string parameters if they exist.
    if (query.length > 0)
    {
        query = query.replace("?", "");
        const queryParts = query.split("&");

        for (let i = 0; i < queryParts.length; i++)
        {
            const itemParts = queryParts[i].split("=");
            const key = itemParts[0];

            if (key === "page")
                continue;
            else if (key === "price-min" || key === "price-max")
                continue;
            else
            {
                if (itemParts.length > 1 && itemParts[1].length > 0)
                    valueArray[key] = itemParts[1];
                else
                    valueArray[key] = "";
            }
        }
    }

    // Add property values seamlessly regardless of existing query presence
    if (propertyValues.length > 0)
    {
        for (let i = 0; i < propertyValues.length; i++)
        {
            const minValue = propertyValues[i].Min as number;
            const maxValue = propertyValues[i].Max as number;

            if (minValue > 0)
                valueArray[propertyValues[i].Name + '-min'] = minValue;

            if (maxValue > 0)
                valueArray[propertyValues[i].Name + '-max'] = maxValue;
        }
    }

    // Construct the single new query string output
    let newQuery = '';
    for (const key in valueArray)
    {
        if (Object.prototype.hasOwnProperty.call(valueArray, key))
        {
            const value = valueArray[key];

            if (newQuery.length > 0)
                newQuery += "&";
            else
                newQuery += "?";

            if (value !== "")
                newQuery += `${key}=${value}`;
            else
                newQuery += key;
        }
    }
    query = newQuery;

    let virtualUrl = url;

    if (hash.length > 1)
    {
        hash = hash.substring(1);
        const items = hash.split("_");

        for (let i = 0; i < items.length; i++)
        {
            const currentItem = items[i];
            const property = parseInt(currentItem.split("-")[0]);
            const value = parseInt(currentItem.split("-")[1]);

            if (property > 0 && value > 0)
            {
                let $item = $($(`.j-filter .w-filter__sublist-item[data-property-id='${property}'][data-option-id='${value}']`)[0]).find("a");
                let text = "";

                if ($item.length > 0)
                    text = $item.text();
                else
                {
                    $item = $(`input[data-id='chk-${property}-${value}']`).siblings("a");
                    text = $item.text();
                }

                if (text != undefined && virtualUrl.indexOf(text) === -1)
                    virtualUrl += '/' + escapeForUrl(text) + '/';
            }
        }
    }

    virtualUrl = virtualUrl.replaceAll("///", "/");
    virtualUrl = virtualUrl.replaceAll("//", "/");
    virtualUrl += query;

    return virtualUrl;
}

function escapeForUrl(input: string): string
{
    input = input.trim();
    input = input.toLowerCase();
    input = removeAccents(input);
    input = input.replaceAll(" ", "-");
    input = input.replaceAll("&", "-");
    input = input.replaceAll("_", "-");

    input = input.replaceAll("--", "-");

    return input;
}

function appendQS(url: string, qs: string | null, element?: HTMLElement): void
{
    if (url.indexOf("#") == -1 && window.location.hash.length > 0)
        url += window.location.hash;

    if (qs != null && qs != "")
    {
        if (url.indexOf("#") > 0)
        {
            const [urlBase, urlHash] = url.split("#");
            url = urlBase + qs + "#" + urlHash;
        }
        else
            url += qs;
    }

    // If we go to the search page, from not a search page
    if (url.indexOf("#") > 0 && url.indexOf("shopmode/search") > -1 && window.location.href.indexOf("shopmode/search") == -1)
    {
        const urlParts = url.split("#");
        if (urlParts.length > 1)
        {
            // Create a form with all the optoins and post it
            const props = urlParts[1].split("_");
            const $form = $("<form />");
            $form.attr("action", url);
            $form.attr("method", "POST");

            for (let i = 0; i < props.length; i++)
            {
                const [propId, optionId] = props[i].split("-");
                const $input = $("<input />").attr("type", "hidden").attr("name", "property" + propId + "_" + optionId).val(optionId);
                $form.append($input);
            }
            $form.appendTo("body");
            $form.trigger("submit");

            return;
        }
    }

    if (mobileFilter && !removeActiveFilterBlock)
    {
        history.pushState(null, null, url);
        updateFilters(0, false, false, false, null, false, element);
        removeActiveFilterBlock = false;
    }
    else
        loadTrackablePage(url, false, false, false, element);
}

export function loadTrackablePage(pageUrl: string, ignoreState?: boolean, preventCheckMultipleBrands?: boolean, clearHash?: boolean, element?: HTMLElement): void | boolean
{
    if (mobileFilter && !preventCheckMultipleBrands)
        checkHashForMultipleBrands(false, true);

    if (pageLoading /* || priceFilterChanged */)
        return;

    pageLoading = true;

    let newUrl = '';
    const hashIndex = pageUrl.indexOf("#");
    let reApplyHash = false;

    if (hashIndex > -1 && hashIndex + 1 < pageUrl.length)
    {
        let isValid = false;
        newUrl = pageUrl.substring(hashIndex);

        if (!mobileFilter)
        {
            const items = newUrl.replace("#", "").split("_");
            for (let i = 0; i < items.length; i++)
            {
                const pv = items[i].split("-");
                if (pv.length == 2)
                {
                    // Check if hash exists in regular filters
                    const propertyItem = $(`.w-filter__sublist-item[data-property-id='${pv[0]}'][data-option-id='${pv[1]}']`);

                    if (propertyItem.length > 0)
                        isValid = true;
                }
            }
        }

        pushToHistory(pageUrl, false, ignoreState);
        if (mobileFilter || isValid)
            reApplyHash = true;
    }
    else if (clearHash && hashIndex < 0)
    {
        // Push clearing of hash.
        pushToHistory(pageUrl, false, ignoreState);
    }

    filterSpinner.show(true);

    const beforeSend = function (jqXHR?: any)
    {
        if (ajaxCallFilters !== undefined && ajaxCallFilters != null)
            ajaxCallFilters.abort();

        if (typeof (searchAjaxCall) !== typeof (undefined) && searchAjaxCall != null)
            searchAjaxCall.abort();

        const curContentHeight = $(".j-category").outerHeight();
        $(".j-category").height(curContentHeight || 0);

        filterSpinner.show(true);

        if (allowTimeout && !mobileFilter)
        {
            scrollTimeout = setTimeout(scrollToResults, 2000);
            allowTimeout = false;
        }
    };

    const afterSend = function (jqXHR?: any)
    {
        initProductColumnStyle();
        initArticlePriceText();

        // If there are no search results update the content
        if ($(".nosearchresults").length > 0)
            updateFilters(0);

        // Since the loader is stubborn we call this explicitly to hide it after we loaded all the content
        setMoreFilters();

        $(".property_list:has(div, ul), .property_list0").parent("li").show();
        $(".property_list:not(:has(div, ul), .property_list0)").parent("li").hide();

        if (reApplyHash)
        {
            manualHashChange = false;

            if (mobileFilter)
                updateMobileFilters();

            isLoadingTrackablePage = false;

            hashChanged({ oldURL: '', newURL: newUrl });
        }
        else
        {
            filterWizard = new FilterWizard();
            filterExplanation = new FilterExplanation();
            $(".j-category").css("height", "");
            filterWizard.checkFilterWizardComplete();
            initMobileFilters();
            addStashClickEvents();
        }

        if (mobileFilter)
        {
            mobileFilterGetProperties(true);
            initPriceFilter(true);
        }
        else
            initPriceFilter(false);

        initSlider();

        // Show the results.
        // TODO: Fix classes!
        $(".j-productview-content > .nosearchresults, .j-productview-content > .w-productcard__holder").show();
        $(".j-filter .j-filter__list").show();
        $(".j-category").css("height", "");
        $(".j-productview-content").css("height", "");
        $(".j-productview-content").show();
        $(".text-holder").show();
        $(".j-filter__list").show();
        $(".js-filtermobile__footer-button").find(".fa-spinner").hide();

        filterSpinner.hide();

        pageLoading = false;
        filterWizard.checkFilterWizardComplete();
        resetProductOverlayEvents();
        hideSingleBrandFilter();
        initButtonEvents();
        initBackToTopEvent();
        initNativeSelect();
        refreshKeyboardInteractions();
        removeActiveFilterBlock = false;
    };

    let currentItemIndex: number | null = null;
    let currentStorageLength: number | null = null;
    let currentBatchFilterSearchDelay = 0;

    if (element != null)
    {
        if (shopConfig().enableBatchFilter)
            currentBatchFilterSearchDelay = shopConfig().batchFilterSearchDelay;

        if (currentBatchFilterSearchDelay > 0)
        {
            if (currentFilterStorage.indexOf(element) < 0)
                currentFilterStorage.push(element);

            currentItemIndex = currentFilterStorage.indexOf(element);
            currentStorageLength = currentFilterStorage.length;
        }
    }

    setTimeout(function ()
    {
        const curContentHeight = $(".j-category").outerHeight();

        $(".j-category").height(curContentHeight || 0);
        filterSpinner.show(true);

        if (currentBatchFilterSearchDelay > 0)
        {
            if (currentFilterStorage.length !== currentStorageLength ||
                currentFilterStorage.indexOf(element!) !== currentItemIndex)
            {
                // Current filter is not the last in the batch; don't apply it.
                pageLoading = false;
                return false;
            }
        }

        try
        {
            let pathName = pageUrl;

            if (location.origin.length > 0 && pathName.indexOf(location.origin) >= 0)
                pathName = pathName.substring(location.origin.length);

            let keyword = "";
            if ($("#current_keyword").length > 0)
            {
                keyword = $("#current_keyword").val() as string;
                if (keyword == null)
                    keyword = "";
            }

            const innerHashIndex = pathName.lastIndexOf("#");
            const removingHash = innerHashIndex <= -1 && previousHash;

            // Check if url needs to be retrieved again based on the hash. 
            if (
                (
                    innerHashIndex > -1 &&
                    !sortValues.some(x => pathName.includes(x))
                ) || removingHash
            )
            {
                previousHash = true;
                // Filter pathname so it doesn't register as requiring another request
                pathName = pathName.substring(0, pathName.lastIndexOf("#"));
            }

            if (removingHash)
                previousHash = false;

            // Check if the current trackable page is the same as the one being requested.
            // No need to retrieve the same page twice. Only retrieve if urls are different.
            if (window.location.pathname != pathName || innerHashIndex <= -1)
            {
                ajaxCallFilters = $.ajax({
                    type: "GET",
                    url: pageUrl,
                    data: {
                        url: pathName,
                        keyword: keyword
                    },
                    beforeSend: beforeSend,
                    success: function (data: string, statusText: string, jqXHR: any)
                    {
                        trackableFilterTempStorage = {};

                        let contentArea = $(".j-category");
                        let filterArea = $(".j-filter");
                        const searchResultInfo = $(".j-category-result-count");
                        const searchFilters = $(".j-searchfilters");
                        const breadcrumbs = $(".j-breadcrumbs");
                        const bannerHolder = $(".j-category-banner");
                        const contentHeader = $(".js-content-header");
                        let seoBlock = $(".j-quickfilter");

                        const response = $("<html></html>");
                        response.html(data);

                        // Only replace content when we already landed on a page where we can replace sections else we just skip this
                        if ((contentArea && contentArea.length > 0) && (filterArea && filterArea.length > 0))
                        {
                            contentArea.html(response.find(".j-category").html() || "");
                            filterArea.html(response.find(".j-filter").html() || "");
                            searchResultInfo.html(response.find(".j-category-result-count").html() || "");
                            searchFilters.html(response.find(".j-searchfilters").html() || "");
                            breadcrumbs.html(response.find(".j-breadcrumbs").html() || "");
                            contentHeader.html(response.find(".js-content-header").html() || "");

                            if (response.find(".j-category-banner").length > 0 && bannerHolder)
                                bannerHolder.replaceWith(response.find(".j-category-banner"));
                            document.title = response.find("title").text();

                            // Check if new property types got added
                            buildPropertyList();

                            if (reApplyHash)
                            {
                                const innerContentHeight = $(".j-category").outerHeight();

                                $(".j-productview-content").height($(".j-productview").height() || 0);
                                $(".j-category").height(innerContentHeight || 0);

                                filterSpinner.show(true);

                                if (!mobileFilter)
                                    activateResultScroll();
                            }

                            if (response.find(".j-quickfilter") && response.find(".j-quickfilter").length > 0)
                            {
                                if (seoBlock.length == 0)
                                {
                                    const tmpSeoBlock = $("<div></div>");
                                    tmpSeoBlock.addClass("j-quickfilter");

                                    const noSeoFilterBlock = $(".c-quickfilter--no-seo");

                                    // Don't put the seo blocks beneath the no seo blocks filter
                                    if (noSeoFilterBlock.length > 0)
                                        $(".c-quickfilter--no-seo").before(tmpSeoBlock);
                                    else
                                        $(".j-category").before(tmpSeoBlock);

                                    seoBlock = $(".j-quickfilter");
                                }

                                // Update seoblock data
                                const quickFilterResponse = response.find(".j-quickfilter");
                                const newExcludedProperties = $(quickFilterResponse).data("excludedProperties");
                                $(".j-quickfilter").data("excluded-properties", newExcludedProperties);
                                seoBlock.attr("class", $(quickFilterResponse).attr("class"));

                                seoBlock.html($(quickFilterResponse).html() || "");

                                seoBlock.show();

                                if ($(seoBlock).next().hasClass("c-quickfilter--no-seo"))
                                    $(seoBlock).next().hide();
                            }
                            else
                            {
                                // Empty existing seo block
                                seoBlock.html("");
                                seoBlock.hide();
                            }

                            if (!reApplyHash)
                                $(".j-filter__list").show();

                            // Push to the cutom history array, so when onpopstate is called we can retrieve the page
                            pushToHistory(pageUrl, false, ignoreState);

                            // If the page has a SEO block we replace it with the newly retrieved content
                            if (seoBlock.length > 0)
                                initQuickfilter();

                            initFilterPropertyFilterbars();

                            // If the page has a content area we replace it with the newly retrieved content
                            if (contentArea.length > 0)
                            {
                                const items = $(".j-productview-content img.lazy, .nosearchresults img.lazy");

                                if (items.length > 0)
                                    initLazyLoad();

                                initPaging(true, false);
                            }
                        }

                        initFiltersAndSearch();
                        setDeleteFilterVisibility();
                        initActiveFilterBlocks();
                        checkExpandedFilters();
                        if (!mobileFilter)
                            activateResultScroll();

                        fillFilterStash(false);

                        // Send new trackable breadcrumb to datalayer
                        sendBreadCrumbImpression();
                    },
                    error: function (error: any)
                    {
                        pageLoading = false;
                    },
                    complete: function ()
                    {
                        afterSend();
                    }
                });
            }
            else
            {
                beforeSend();
                afterSend();
            }
        }
        catch (err)
        {
            pageLoading = false;
        }

        setTimeout(function ()
        {
            currentFilterStorage = [];
        }, 1);
    }, currentBatchFilterSearchDelay);
}

// Pushes a url to the history array and push state, only when not ignored
function pushToHistory(url: string, ignoreHistory?: boolean, ignoreState?: boolean): void
{
    const lastHistoryEntry = pushHistory[pushHistory.length - 1];

    // Skip adding url to history if it already is the last entry, prevents window reload to add the same url.
    if (url === lastHistoryEntry)
        return;

    url = url.replace("#keuzehulp", "");

    if (!ignoreHistory)
        pushHistory.push(url);

    if (!ignoreState)
        history.pushState({}, null, url);

    $.stash.set("pushHistory", JSON.stringify(pushHistory));
}

function clearPropertyFilters(clearMin: boolean, clearMax: boolean, clearProperty?: string | null): void
{
    const desktopSliders = propertySliderHolder.filter(x => !x.target.classList.contains("j-filtermobile"));

    $(desktopSliders).each(function (index: number, sliderHolder: any)
    {
        const $target = $(sliderHolder.target);

        if ($target.length > 0 && (clearProperty == null || $target.hasClass(clearProperty)))
        {
            const min = clearMin
                ? (parseInt($target.find(".prop-min").val() as string) || 0)
                : (parseInt($target.find(".prop-cur-min").val() as string) || 0);

            const max = clearMax
                ? (parseInt($target.find(".prop-max").val() as string) || 0)
                : (parseInt($target.find(".prop-cur-max").val() as string) || 0);

            if (clearMin)
                $target.find(".prop-cur-min").val(min);

            if (clearMax)
                $target.find(".prop-cur-max").val(max);

            sliderHolder.set([min, max]);

            const $parent = $target.parent();
            $parent.find(".prop-cur-min").val(min);
            $parent.find(".prop-cur-max").val(max);

            priceFilterChanged = true;
        }
    });
}

(window as any).toggleFilterOption = toggleFilterOption;

//#endregion Toggle filter option

//#region SEO/quickfilter

function initQuickfilter(): void
{
    const $wrapper = $(".c-quickfilter__wrapper");

    if ($wrapper.length > 0)
    {
        setQuickfilterButtonVisibilty();
    }
}

function setQuickfilterButtonVisibilty(): void
{
    const activeFilterCount = $(".w-filter__sublist-item").filter(function (this: HTMLElement)
    {
        return $(this).find("input[type='checkbox']").prop("checked") === true;
    }).length;

    $(".c-quickfilter--no-seo").toggleClass("hidden", activeFilterCount > 1);
}

//#endregion SEO/quickfilter

//#region Active filter blocks

function initActiveFilterBlocks(): void
{
    const activeFilterBlockHolders = $(".w-filters-activeblocks");

    let totalFilterCount = 0;

    if (activeFilterBlockHolders.length > 0)
    {
        activeFilterBlockHolders.empty().off();

        const activeFilters = $(".j-filter .w-filter__sublist .w-filter__sublist-item").filter(function (this: HTMLElement)
        {
            return $(this).find("input[type='checkbox']").prop("checked") === true;
        });

        totalFilterCount += activeFilters.length;

        // Get price filters.
        const curPriceMin = getParameterByName("price-min");
        const curPriceMax = getParameterByName("price-max");

        // Check for active filters.
        if (activeFilters.length > 0)
        {
            activeFilters.each(function (this: HTMLElement)
            {
                const $filterItem = $(this);

                const propertyName = $filterItem.closest(".j-filter__list-item").find(".w-filter__title").text();

                const filterItemName = $filterItem.find("a").text() || "";
                const filterItemPropertyValue = $filterItem.data("option-id");
                const filterItemPropertyClass = "w-filters-activeblocks__item-" + filterItemPropertyValue;

                const filterItemBlock = `<div class="${filterItemPropertyClass} ic-x-aft" title="${filterItemName}"><span class="f-primary-s">${propertyName}</span>: <span class="f-primary-s tl-bold">${filterItemName}</span></div>`;

                activeFilterBlockHolders.append(filterItemBlock);

                // Add click event from the active filter item to the active filter block.
                activeFilterBlockHolders.on("click", "." + filterItemPropertyClass, function ()
                {
                    removeActiveFilterBlock = true;
                    $filterItem.trigger("click");
                });
            });
        }

        // Check for min price filter.
        if (curPriceMin != null && curPriceMin !== "")
        {
            totalFilterCount++;

            const filterItemBlock = `<div class="w-filters-activeblocks__item-minprice ic-x-aft"><span class="f-primary-s">${getTranslations().txtActiveFilterMinPrice}</span>: <span class="f-primary-s tl-bold">${curPriceMin}${getTranslations().priceSignAfter}</span></div>`;

            activeFilterBlockHolders.append(filterItemBlock);

            // Clear min price filter if filter block is clicked.
            activeFilterBlockHolders.on("click", ".w-filters-activeblocks__item-minprice", function ()
            {
                reloadPageAfterCallback = true;
                clearPriceFilters(true, false);
                updateFilters(0, true);

                let newUrl = location.href;
                newUrl = removeURLParameter(newUrl, "price-min");
                history.pushState(null, null, newUrl);

                if (mobileMediaQuery.matches)
                    loadTrackablePage(window.location.href, false);
            });
        }

        // Check for max price filter.
        if (curPriceMax != null && curPriceMax !== "")
        {
            totalFilterCount++;

            const filterItemBlock = `<div class="w-filters-activeblocks__item-maxprice ic-x-aft"><span class="f-primary-s">${getTranslations().txtActiveFilterMaxPrice}:</span> <span class="f-primary-s tl-bold">${curPriceMax}${getTranslations().priceSignAfter}</span></div>`;

            activeFilterBlockHolders.append(filterItemBlock);

            // Clear max price filter if filter block is clicked.
            activeFilterBlockHolders.on("click", ".w-filters-activeblocks__item-maxprice", function ()
            {
                reloadPageAfterCallback = true;
                clearPriceFilters(false, true);
                updateFilters(0, true);

                let newUrl = location.href;
                newUrl = removeURLParameter(newUrl, "price-max");
                history.pushState(null, null, newUrl);

                if (mobileMediaQuery.matches)
                    loadTrackablePage(window.location.href, false);
            });
        }

        const propertySelectors = ".w-filter__slide--property";
        const checkedProperties: string[] = [];
        $(propertySelectors).each(function (this: HTMLElement)
        {
            const holder = $(this);
            const propName = holder.find("input[name='prop-name']").val() as string;
            const propOrgName = holder.find("input[name='prop-org-name']").val() as string;

            // Prevent adding active filter twice
            if (!checkedProperties.includes(propName))
            {
                checkedProperties.push(propName);

                // Get property filters.
                const curPropMin = getParameterByName(propName + "-min");
                const curPropMax = getParameterByName(propName + "-max");

                if (curPropMin != null && curPropMin !== "")
                {
                    totalFilterCount++;

                    const filterItemName = `<span class="f-primary-s">${getTranslations().txtFrom} ${propOrgName}:</span> <span class="f-primary-s tl-bold">${curPropMin}</span`;

                    const filterItemBlock = `<div class="w-filters-activeblocks__item-min-${propName} ic-x-aft">${filterItemName}</div>`;

                    activeFilterBlockHolders.append(filterItemBlock);

                    // Clear min filter if filter block is clicked.
                    activeFilterBlockHolders.on("click", ".w-filters-activeblocks__item-min-" + propName, function ()
                    {
                        reloadPageAfterCallback = true;
                        clearPropertyFilters(true, false, propName);
                        updateFilters(0, true);

                        let newUrl = location.href;
                        newUrl = removeURLParameter(newUrl, propName + "-min");
                        history.pushState(null, null, newUrl);

                        if (mobileMediaQuery.matches)
                            loadTrackablePage(window.location.href, false);
                    });
                }

                if (curPropMax != null && curPropMax !== "")
                {
                    totalFilterCount++;

                    const filterItemName = `<span class="f-primary-s">${getTranslations().txtUntil} ${propOrgName}:</span> <span class="f-primary-s tl-bold">${curPropMax}</span>`;

                    const filterItemBlock = `<div class="w-filters-activeblocks__item-max-${propName} ic-x-aft">${filterItemName}</div>`;

                    activeFilterBlockHolders.append(filterItemBlock);

                    // Clear max filter if filter block is clicked.
                    activeFilterBlockHolders.on("click", ".w-filters-activeblocks__item-max-" + propName, function ()
                    {
                        reloadPageAfterCallback = true;
                        clearPropertyFilters(false, true, propName);
                        updateFilters(0, true);

                        let newUrl = location.href;
                        newUrl = removeURLParameter(newUrl, propName + "-max");
                        history.pushState(null, null, newUrl);

                        if (mobileMediaQuery.matches)
                            loadTrackablePage(window.location.href, false);
                    });
                }
            }
        });
    }

    $(".js-filter-count").each(function (this: HTMLElement)
    {
        const $filterCountItem = $(this);

        if (totalFilterCount > 0)
            $filterCountItem.text(`(${totalFilterCount})`);
        else
            $filterCountItem.text("");
    });
}

function hideSingleBrandFilter(): void
{
    let showActiveBlockHolder = true;

    // Hide the brand filter options if there is only one
    const brandID = $("#brand_id").val();
    const $brandFilters = $(`#w-filter__list-item--${brandID} .w-filter__sublist-item input[type='checkbox']`);
    if (brandID !== undefined && $brandFilters.length <= 1)
    {
        if ($brandFilters.length == 1)
        {
            const brandPropertyID = $brandFilters.val() as string;

            // Hide active filters on desktop and mobile.
            $(`.w-filters-activeblocks .w-filters-activeblocks__item-${brandPropertyID}`).hide();

            // If there is no more than 1 active filter block, and it is the single brand filter that is hidden, hide the active filter block container.
            if ($(".w-filters-activeblocks:not('.mobile') div[class*='w-filters-activeblocks__item-']").length <= 1 &&
                $(`.w-filters-activeblocks:not('.mobile') div[class*='w-filters-activeblocks__item-${brandPropertyID}']`).length > 0
            )
                showActiveBlockHolder = false;
        }

        $(`.j-filter__list-item[data-property-id='${brandID}']`).addClass("hidden");
    }

    $(".w-filters-activeblocks").toggleClass("hidden", !showActiveBlockHolder);
}

//#endregion Active filter blocks

//#region Sort

function setSortEvents(): void
{

    const $desktopSelect = $("select[name='orderSelect']");
    const $mobileSelect = $("select[name='orderSelectMobile']");

    $mobileSelect.on("change", function (this: HTMLSelectElement)
    {
        $desktopSelect.val($(this).val() as string).trigger("change");
    });

    $desktopSelect.on("change", function (event: JQuery.TriggeredEvent)
    {
        const $this = $(this);

        if ($this.find("option:selected[value]").length > 0)
        {
            filterSpinner.show(true);

            buttonInfoList = null;
            buttonImpressionList = null;

            const $selectedOption = $this.find("option:selected");
            const hash = $selectedOption.data("hash") as string;
            const orgHash = window.location.hash;
            let newHash = window.location.hash;
            const optionName = $selectedOption.text();

            if (optionName.length > 0)
            {
                sendDataLayer({
                    "category": "productlist",
                    "action": "sort",
                    "label": optionName.toLowerCase(),
                    "event": "sortClick"
                });
            }

            if (newHash.length > 0)
            {
                if (newHash[0] === "#")
                    newHash = newHash.substring(1);

                const possibleHashes: string[] = [];
                $this.find("option").each(function ()
                {
                    const optHash = $(this).data("hash");
                    if (optHash !== "")
                        possibleHashes.push(optHash);
                });

                const curHashes = newHash.split("_");
                for (let i = 0; i < curHashes.length; i++)
                {
                    if (possibleHashes.indexOf(curHashes[i]) > -1)
                        newHash = newHash.replace(curHashes[i], "");
                }

                newHash = newHash.replace("__", "_");
                if (newHash.startsWith("_"))
                    newHash = newHash.substring(1);

                if (newHash.length > 1 && !newHash.endsWith("_"))
                    newHash += "_";

                newHash += hash;
            }
            else
                newHash = hash;

            if (newHash.length > 0)
                document.location.hash = newHash;
            else if (orgHash !== newHash)
                removeHash();

            searchDetail(0, false);
        }

        return false;
    });

    /*#region Price diff classes */

    // Copy the desktop price diff. (largest discount) option classes to mobile, so that if it's hidden on desktop, it's hidden on mobile too.
    const $desktopPriceDiff = $desktopSelect.find(`option[value="price_diff"]`);
    const $mobilePriceDiff = $mobileSelect.find(`option[value="price_diff"]`);

    const desktopClasses = $desktopPriceDiff.attr("class");

    if (desktopClasses)
        $mobilePriceDiff.attr("class", desktopClasses);
    else
        $mobilePriceDiff.removeAttr("class");

    /*#endregion Price diff classes */
}

function checkForSortOrder(): void
{
    const currentUrl = document.location.href;

    if (currentUrl.indexOf("#") > 0)
    {
        let hash = currentUrl.substring(currentUrl.indexOf("#"));
        hash = hash.substring(1);

        const split = hash.split("_");

        if (split.length === 1)
        {
            for (let i = 0; i < split.length; i++)
            {
                const option = split[i];

                if (option.length === 2)
                {
                    $("#orderSelect option[data-hash=" + option + "]").prop("selected", true);
                    $("#orderSelect").trigger("change");
                }
            }
        }
    }
}

function toggleMobileSortOption(source: HTMLElement | JQuery, value: string | number): void
{
    // TODO: Remove? Or change, depending on what mobile sort should be.
    $(".mobile-sort-option").find(".sort-checkbox").removeClass("checked");
    $(source).find(".sort-checkbox").addClass("checked");

    $("#orderSelect").find("option[value='" + value + "']").prop("selected", true);
    $("#orderSelect").trigger("change");

    $(".article-count-spinner .fa-spinner").show();

    searchDetail(0, false);
}

function setSortOrderFromHash(hashValue: string): void
{
    if (hashValue.length > 0)
    {
        const $matchingOptions = $(`option[data-hash='${hashValue}']`);
        if ($matchingOptions.length > 0)
            $matchingOptions.prop("selected", true);
    }

    // Update native-js select elements
    const $targetOption = $(`select[name='orderSelect']:hidden option[data-hash='${hashValue}']`);

    if ($targetOption.length > 0)
    {
        const nativeOption = $targetOption.get(0) as HTMLOptionElement;
        const selectedText = nativeOption.innerText;

        // Safely find the index of the selected option without breaking the reference
        let sortSelectionIndex = 0;
        let previousSibling = nativeOption.previousElementSibling;
        while (previousSibling)
        {
            sortSelectionIndex++;
            previousSibling = previousSibling.previousElementSibling;
        }

        // Get the selected option from nativejs-select
        const $selectedSortOption = $(`.nativejs-select__dropdown .nativejs-select__options button:eq(${sortSelectionIndex})`);

        if ($selectedSortOption.length > 0)
        {
            // Deselect all sort options
            $(".nativejs-select__dropdown .nativejs-select__options .nativejs-select__option").each(function ()
            {
                const element = $(this).get(0);
                if (element)
                    element.dataset.selected = "false";
            });

            // Select sort option from hash and update text
            const sortOptionElement = $selectedSortOption.get(0);
            if (sortOptionElement)
                sortOptionElement.dataset.selected = "true";

            const placeholderElement = $('.nativejs-select__placeholder-value').get(0);
            if (placeholderElement)
                placeholderElement.innerText = selectedText;
        }
    }
}

//#endregion Sort

//#region Paging

function initPaging(rebuild: boolean, initial: boolean): void
{
    if (initial && getParameterByName("page").length > 0)
    {
        const tmpPage = parseInt(getParameterByName("page"), 10);

        if (tmpPage > 1)
            initialPageNumber = tmpPage;
    }

    if (rebuild)
    {
        $(".j-paging").prev(".clear").remove();
        $(".j-paging").remove();

        if ($(".j-productview-content .j-paging").length === 0)
        {
            const $pager = $("<div></div>");
            $pager.addClass("w-paging j-paging");

            $(".j-productview-content").append($pager);
        }

        let currentPage = 1;

        if ($("#currentPage").length > 0)
            currentPage = parseInt($("#currentPage").val() as string, 10);
        else if ($("#search_page").length > 0)
            currentPage = parseInt($("#search_page").val() as string, 10);

        const count = parseInt($(".j-category-result-count").text().substring(0, $(".j-category-result-count").text().indexOf(" ")), 10);
        const maxPerPage = parseInt($("#default_amount").val() as string, 10);
        const maxPage = Math.ceil(count / maxPerPage);

        if (count > articlesPerPageAmount)
        {
            let currentStart = 0;

            if (currentPage > 1)
                currentStart = maxPerPage * (currentPage - 1);

            let currentEnd = currentStart + maxPerPage;

            currentStart++;

            if (currentEnd > count)
                currentEnd = count;

            const $newPagingTopContainer = $("<div></div>");
            $newPagingTopContainer.addClass("w-paging__top");

            const $newPagingContainer = $("<div></div>");
            $newPagingContainer.addClass("w-paging__buttons");

            const url = document.location.pathname.toLowerCase();
            let query = document.location.search.toLowerCase();

            if (query.length > 0)
            {
                if (query.indexOf("page=") > -1)
                {
                    const startIndex = query.indexOf("page=");
                    const endIndex = query.substring(startIndex).indexOf("&");

                    let newQuery = query.substring(0, startIndex - 1);

                    if (endIndex > -1)
                        newQuery += query.substring(startIndex).substring(endIndex);

                    if (newQuery === "?")
                        newQuery = "";

                    if (newQuery.startsWith("&"))
                        newQuery = "?" + newQuery.substring(1, newQuery.length);

                    query = newQuery;
                }
            }

            const fullUrl = url + query;
            let tmpHash = "";

            if (document.location.hash.length > 0)
                tmpHash = document.location.hash;

            let lastItemUrl = fullUrl;
            let prevItemUrl = fullUrl;
            let nextItemUrl = fullUrl;

            if (query.length > 0)
            {
                lastItemUrl += "&";
                nextItemUrl += "&";

                if (currentPage > 2)
                    prevItemUrl += "&";
            }
            else
            {
                lastItemUrl += "?";
                nextItemUrl += "?";

                if (currentPage > 2)
                    prevItemUrl += "?";
            }

            lastItemUrl += "page=" + maxPage;
            nextItemUrl += "page=" + (currentPage + 1);

            if (currentPage > 2)
                prevItemUrl += "page=" + (currentPage - 1);

            const $newTopButton = $(`<a>${getTranslations().nextPageTitleText}</a>`);
            $newTopButton.addClass("w-paging__top-btn j-paging__top-btn btn-green btn-icon-small btn-icon-aft ic-chevron-right-aft");
            $newTopButton.attr("title", getTranslations().nextPageTitleText);
            $newTopButton.attr("href", nextItemUrl + tmpHash);
            $newTopButton.data("page", currentPage + 1);

            $newPagingTopContainer.append($newTopButton);

            const $prevItem = $("<a></a>");
            const $nextItem = $("<a></a>");
            const $firstItem = $("<a></a>");
            const $lastItem = $("<a></a>");

            $firstItem.addClass("w-paging__btn w-paging__btn--num w-paging__btn--first pagenrlink");
            $firstItem.text("1");
            $firstItem.data("page", 1);
            $firstItem.attr("title", String.format(getTranslations().pageTitleText, 1));
            $firstItem.attr("href", fullUrl + tmpHash);

            $lastItem.addClass("w-paging__btn w-paging__btn--num w-paging__btn--last pagenrlink");
            $lastItem.text(maxPage);
            $lastItem.data("page", maxPage);
            $lastItem.attr("title", String.format(getTranslations().pageTitleText, maxPage));
            $lastItem.attr("href", lastItemUrl + tmpHash);

            $prevItem.addClass("w-paging__btn w-paging__btn--prev btn-arrow btn-arrow-left");
            $prevItem.attr("title", getTranslations().previousPageTitleText);
            $prevItem.attr("href", prevItemUrl + tmpHash);

            $nextItem.addClass("w-paging__btn w-paging__btn--next btn-arrow");
            $nextItem.attr("title", getTranslations().nextPageTitleText);
            $nextItem.attr("href", nextItemUrl + tmpHash);

            if (currentPage === 1)
                $firstItem.addClass("pagenrlinksel");
            else
                $firstItem.addClass("pagenrlink");

            if (currentPage === maxPage)
                $lastItem.addClass("pagenrlinksel");
            else
                $lastItem.addClass("pagenrlink");

            $prevItem.data("page", currentPage - 1);
            $nextItem.data("page", currentPage + 1);

            if (currentPage > 1)
                $newPagingContainer.append($prevItem);

            $newPagingContainer.append($firstItem);

            if ((currentPage - 2) > 2)
            {
                const $spanItem = $("<span></span>");
                $spanItem.addClass("w-paging__text");
                $spanItem.text("...");
                $newPagingContainer.append($spanItem);
            }

            let lastDynamicItemIndex = 0;

            for (let i = currentPage - 2; i <= currentPage + 2; i++)
            {
                if (i > 1 && i < maxPage)
                {
                    let tmpUrl = fullUrl;

                    if (query.length > 0)
                        tmpUrl += "&";
                    else
                        tmpUrl += "?";

                    tmpUrl += "page=" + i;

                    const $href = $("<a></a>");
                    $href.addClass("w-paging__btn w-paging__btn--num");
                    $href.data("page", i);
                    $href.attr("title", String.format(getTranslations().pageTitleText, i));
                    $href.attr("href", tmpUrl + tmpHash);
                    $href.text(i);

                    if (i === currentPage)
                        $href.addClass("pagenrlinksel");
                    else
                        $href.addClass("pagenrlink");

                    $newPagingContainer.append($href);
                    lastDynamicItemIndex = i;
                }
            }

            if (lastDynamicItemIndex < (maxPage - 1))
            {
                const $spanItem = $("<span></span>");
                $spanItem.addClass("w-paging__text");
                $spanItem.text("...");
                $newPagingContainer.append($spanItem);
            }

            $newPagingContainer.append($lastItem);

            if (currentPage < maxPage)
            {
                $(".j-productview-content .j-paging").append($newPagingTopContainer);

                $newPagingContainer.append($nextItem);
            }

            $newPagingContainer.append($newPagingContainer);

            $(".j-productview-content .j-paging .w-paging__buttons").remove();
            $(".j-productview-content .j-paging").append($newPagingContainer);
        }

        if ($(".j-productview-content .w-productcard__holder").length > 0 &&
            $(".j-productview-content .w-paging__buttons").length > 0)
        {
            $(".w-paging__buttons span").off("click");

            $(".w-paging__buttons a, .j-paging__top-btn")
                .off("click")
                .on("click", function ()
                {
                    const currentPg = parseInt($("#pn").val() as string, 10);
                    const pageNR = $(this).data("page");

                    if (currentPg !== pageNR)
                        switchPage(pageNR, true);

                    return false;
                });
        }
    }
}

(window as any).initPaging = initPaging;

function showPaging(): void
{
    $(".j-productview-content").removeClass("paging-visible");

    // Check if we have enough items to determine if we should show paging
    const countText = $(".j-category-result-count").text().substring(0, $(".j-category-result-count").text().indexOf(" "));
    const count = parseInt(countText, 10);
    const maxPerPage = parseInt($("#default_amount").val() as string, 10);
    let hide = false;

    if (isNaN(count))
        hide = true;

    if (count > maxPerPage && !hide)
    {
        $(".w-paging__buttons").show();
        $(".j-productview-content").addClass("paging-visible");
    }
    else
        $(".w-paging__buttons").hide();

    if (hide || mobileFilter)
        $(".c-productview__content-top .select").hide();
    else
        $(".c-productview__content-top .select").show();
}

function switchPage(newPage: number, manual: boolean): void
{
    scrollToResults(true);

    filterSpinner.show(true);
    $(".w-paging").hide();
    $(".btp, .btp-pos").hide();

    $("#pn").val(newPage - 1);
    $("#search_page").val(newPage - 1);
    $("#currentPage").val(newPage);

    $(".w-paging .w-paging__buttons span").off("click");
    $(".w-paging .w-paging__buttons a").on("click", function ()
    {
        return false;
    });

    if (manual)
        initialPageNumber = null;

    buttonInfoList = null;
    buttonImpressionList = null;

    if (origin !== "category")
        updateFilters(0, false, false, false, origin, true);
    else
        updateFilters(0, false, false, false, $("input[name='current_category']").val() as string, true);
}

//#endregion Paging

//#region Hash

function checkHashChanges(oldURL: string | null | undefined, newURL: string | null | undefined): { triggerHashChange: boolean; removedFilters: string[]; addedFilters: string[] }
{
    let oldUrlHash = "";
    let newUrlHash = "";

    if (oldURL != null && oldURL.length > 0)
        oldUrlHash = oldURL.split("#")[1];

    if (newURL != null && newURL.length > 0)
        newUrlHash = newURL.split("#")[1];

    let oldUrlHashFilters: string[] = [];
    let newUrlHashFilters: string[] = [];

    if (oldUrlHash != null && oldUrlHash.length > 0)
        oldUrlHashFilters = oldUrlHash.split("_");

    if (newUrlHash != null && newUrlHash.length > 0)
        newUrlHashFilters = newUrlHash.split("_");

    const removedFilters = oldUrlHashFilters.filter(item => !newUrlHashFilters.includes(item));
    const addedFilters = newUrlHashFilters.filter(item => !oldUrlHashFilters.includes(item));
    const trigger = removedFilters.length > 0 || addedFilters.length > 0;

    return {
        "triggerHashChange": trigger,
        "removedFilters": removedFilters,
        "addedFilters": addedFilters
    };
}

function hashChanged(evt: { oldURL: string; newURL: string }, manual?: boolean): void | boolean
{
    if (!manual)
    {
        pushToHistory(
            document.location.pathname +
            document.location.search +
            document.location.hash,
            false,
            true
        );
    }

    let hasPropID = false;
    let hash = window.location.hash;
    let isChanged = false;
    if (hash.length > 1)
    {
        if (hash.indexOf("#") == 0)
            hash = hash.substring(1);

        if (hash.length > 3)
        {
            if (hash.indexOf("la_") == 0)
                hash = hash.substring(3) + "_la";
            else if (hash.indexOf("df_") == 0)
                hash = hash.substring(3) + "_df";
            else if (hash.indexOf("pa_") == 0)
                hash = hash.substring(3) + "_pa";
            else if (hash.indexOf("pd_") == 0)
                hash = hash.substring(3) + "_pd";
        }

        if ($("select[name='orderSelect'] option[data-hash='" + evt.oldURL + "']").length > 0 &&
            $("select[name='orderSelect'] option[data-hash='" + evt.newURL + "']").length > 0)
        {
            $(".filter-list .row a[href^='/']").each(function (this: HTMLElement)
            {
                $(this).prop("href", `${$(this).prop("href")}#${evt.newURL}`);
            });

            return false;
        }
    }
    else
        removeHash();

    const checkHashChangesResult = checkHashChanges(evt.oldURL, evt.newURL);
    const removedFilters = checkHashChangesResult.removedFilters;
    const addedFilters = checkHashChangesResult.addedFilters;

    if (removedFilters.length > 0)
    {
        removedFilters.forEach(function (item: string, index: number)
        {
            const pv = item.split("-");
            if (pv.length == 2)
            {
                const $item = $(`.w-filter__sublist-item[data-property-id='${pv[0]}'][data-option-id='${pv[1]}']`);

                if ($item.length > 0)
                {
                    isChanged = true;
                    $item.find("input[type='checkbox']").prop("checked", false);
                }
            }

            if (pv[0] != null)
                hasPropID = true;
        });
    }

    if (addedFilters.length > 0)
    {
        addedFilters.forEach(function (item: string, index: number)
        {
            const pv = item.split("-");
            if (pv.length == 2)
            {
                const $item = $(`.w-filter__sublist-item[data-property-id='${pv[0]}'][data-option-id='${pv[1]}']`);

                if ($item.length > 0)
                {
                    isChanged = true;
                    $item.find("input[type='checkbox']").prop("checked", true);
                }
            }

            if (pv[0] != null)
                hasPropID = true;
        });
    }

    newEvtHash = evt.newURL;
    if (newEvtHash.indexOf("#") > -1)
        newEvtHash = newEvtHash.replace(newEvtHash.substring(0, newEvtHash.indexOf("#") + 1), "");
    else
        newEvtHash = null;

    if (hasPropID && isChanged)
    {
        clearTimeout(scrollTimeout);
        allowTimeout = true;

        // Set the page to one and submit the search form.
        $("#pn").val(0);

        if (isLoadingTrackablePage == false)
            updateFilters(0, false, false, true);
    }

    // Re-enable seo blocks if available after navigating with browser history.
    checkHashForSeo(newEvtHash);
};

function toggleURLHash(option: string, optionName: string, element?: HTMLElement): void
{
    let currentItemIndex: number | null = null;
    let currentStorageLength: number | null = null;
    let currentBatchFilterSearchDelay = 0;

    if (element != null)
    {
        if (shopConfig().enableBatchFilter)
            currentBatchFilterSearchDelay = shopConfig().batchFilterSearchDelay;

        if (currentBatchFilterSearchDelay > 0)
        {
            if (currentFilterStorage.indexOf(element) < 0)
                currentFilterStorage.push(element);

            currentItemIndex = currentFilterStorage.indexOf(element);
            currentStorageLength = currentFilterStorage.length;
        }
    }

    // Make 'hash to apply' match the current hash if none is set yet.
    if (hashToApply == null)
        hashToApply = window.location.hash;

    if (!hashToApply)
    {
        if (window.location.href.indexOf(optionName) === -1)
            hashToApply = option;
    }
    else
    {
        const cleanHash = hashToApply.startsWith("#") ? hashToApply.substring(1) : hashToApply;
        const split = cleanHash.split("_");

        // Optimized array toggle logic: if it exists, filter it out; otherwise, push it
        if (split.includes(option))
            hashToApply = split.filter(item => item !== option).join("_");
        else
            hashToApply = cleanHash + "_" + option;
    }

    if (hashToApply.length > 0 && !hashToApply.startsWith("#"))
        hashToApply = "#" + hashToApply;

    // Call without setTimeout since even delay of 0 can cause it to run later.
    if (currentBatchFilterSearchDelay > 0)
    {
        setTimeout(function ()
        {
            applyToggleUrlhash(false, currentItemIndex, currentStorageLength, element);
        }, currentBatchFilterSearchDelay);
    }
    else
        applyToggleUrlhash(true);
}

function applyToggleUrlhash(skipStorageCheck: boolean, currentItemIndex?: number | null, currentStorageLength?: number | null, element?: HTMLElement): boolean | void
{
    if (!skipStorageCheck)
    {
        if (currentFilterStorage.length !== currentStorageLength ||
            currentFilterStorage.indexOf(element!) !== currentItemIndex
        )
            // Current filter is not the last in the batch; don't apply it.
            return false;
    }

    if (!hashToApply)
        removeHash();
    else
        window.location.hash = hashToApply;

    setTimeout(function ()
    {
        // Clear 'hash to apply' as it is applied now.
        hashToApply = null;
        currentFilterStorage = [];
    }, 1);
}

function removeHash(): void
{
    hashToApply = "";

    if (mobileFilter)
    {
        window.location.hash = "";
        history.pushState(null, null, window.location.pathname + window.location.search);
        updateFilters(0, false, false, false);
    }
    else
    {
        let pathWithQuerystring = window.location.pathname + window.location.search;

        pathWithQuerystring = pathWithQuerystring.replaceAll("//", "/");

        loadTrackablePage(pathWithQuerystring, false, false, true);
    }
}

function checkHashForMultipleBrands(useURL: boolean, preventCheckMultipleBrandsTwice?: boolean): void
{
    const $brandIdInput = $("#brand_id");

    if ($brandIdInput.length > 0 &&
        $brandIdInput.val() != "" &&
        !isNaN(parseInt($brandIdInput.val() as string)) &&
        ($("input[name='current_category']").val() as any) > 0)
    {
        const brandId = parseInt($brandIdInput.val() as string);

        // Get all checked items
        const $allCheckedItems = $(".j-filter .w-filter__sublist:not(.hidden) .w-filter__sublist-item").filter(function (this: HTMLElement)
        {
            return $(this).find("input[type='checkbox']").prop("checked") === true;
        });

        // Count the selected brand filters
        const $activeBrandFilters = $allCheckedItems.filter(function (this: HTMLElement)
        {
            return $(this).closest(`.w-filter__list-item--${brandId}`).length > 0 || $(this).attr("data-property-id") == String(brandId);
        });

        const numberOfBrands = $activeBrandFilters.length;

        // Local helper to avoid repeating the text normalisation logic
        const getCleanTitle = ($item: JQuery): string =>
        {
            let title = $item.attr("title") || $item.find("a").attr("title") || "";
            title = title.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            return title.replace(/[^a-zA-Z ]/g, "").replaceAll(" ", "-").toLowerCase();
        };

        // Change the url based on the amount of brandfilters that are active
        if (numberOfBrands === 1)
        {
            const currentHash = window.location.hash;
            let newurl = window.location.href;
            let nameAlreadyPresent = false;
            let brandName = "";

            // check url for brandname
            $activeBrandFilters.each(function (this: HTMLElement)
            {
                const title = getCleanTitle($(this));
                if (newurl.indexOf(title) >= 0)
                    nameAlreadyPresent = true;

                brandName = title;
            });

            if (!nameAlreadyPresent &&
                brandName != null &&
                brandName != "" &&
                useURL)
            {
                // Add brandname to the url and remove it's hash
                const index = newurl.lastIndexOf("/", newurl.lastIndexOf("/") - 1);
                newurl = newurl.slice(0, index) + "/" + brandName + newurl.slice(index, newurl.length);

                // Removehash
                if (newurl.includes("#"))
                    newurl = newurl.split("#")[0];

                loadTrackablePage(newurl, false, preventCheckMultipleBrandsTwice);
            }
            // No url available use lone brand hash
            else if ($allCheckedItems.length === 1)
            {
                const $loneBrandItem = $($activeBrandFilters[0]);
                const pId = $loneBrandItem.data("property-id");
                const oId = $loneBrandItem.data("option-id");
                const brandHashToKeep = `${pId}-${oId}`;

                // NOTE: Might need to be re-added? Appears to work a lot better without, though, when removing filters.
                // if (brandHashToKeep != "" &&
                //     !hashToApply
                // )
                //     hashToApply = "#" + brandHashToKeep;
            }
        }
        else if (numberOfBrands > 1)
        {
            // Create new hash
            let newhash = "#";

            // Get all selected filter properties            
            $allCheckedItems.each(function (this: HTMLElement)
            {
                const $item = $(this);
                const pId = $item.data("property-id");
                const oId = $item.data("option-id");
                const itemHash = `${pId}-${oId}`;

                if (newhash === "#")
                    newhash += itemHash;
                else
                    newhash += "_" + itemHash;
            });

            if (newhash === "#")
                newhash = "";

            // Create new url
            let newurl = window.location.href;

            if (newurl.indexOf("#") > 0)
                newurl = newurl.substring(0, newurl.indexOf("#"));
            newurl += newhash;

            let urlChanged = false;

            if (newurl != window.location.href)
                urlChanged = true;

            $activeBrandFilters.each(function (this: HTMLElement)
            {
                const title = getCleanTitle($(this)) + "/";

                if (newurl.indexOf(title) >= 0)
                {
                    const updatedurl = new URL(newurl.replace(title, ""));

                    // Some categories are also brands. We can remove brandnames but we shouldn't remove categorynames.
                    // Check if we still have one before changing the url.
                    if (updatedurl != undefined && updatedurl.pathname != "/")
                    {
                        urlChanged = true;
                        newurl = updatedurl.href;
                    }
                }
            });

            if (urlChanged)
                loadTrackablePage(newurl, false, preventCheckMultipleBrandsTwice);
        }
    }
}

function checkHashForSeo(fullHash: string | null): void
{
    if (fullHash != null && fullHash.startsWith("#"))
        fullHash = fullHash.substring(1);
    else
    {
        // No hash filters found, show all SEO blocks.
        $(".j-quickfilter").each(function (this: HTMLElement)
        {
            $(this).show();

            if ($(this).next().hasClass("c-quickfilter--no-seo"))
                $(this).next().hide();
        });
    }

    if (fullHash != null && fullHash.length > 0)
    {
        // Get hash items.
        if (fullHash.startsWith("_"))
            fullHash = fullHash.substring(1);
        const hashItems = fullHash.split("_");

        $(".j-quickfilter").each(function (this: HTMLElement)
        {
            if ($(this).data("excluded-properties") !== undefined)
            {
                const seoExcludedProperties = $(this).data("excluded-properties").toString().split(",");

                // Optimized matching check using a native inline matcher instead of a nested loop block
                const isExcluded = hashItems.some(item => seoExcludedProperties.includes(item.split("-")[0]));

                // Set associated filterwizard visibility based on whether the SEO block will be shown.
                let filterWizard = null;
                if ($(this).next().hasClass("c-quickfilter--no-seo"))
                    filterWizard = $(this).next();

                // If hash item is in the current SEO block's excluded property list, hide the current SEO block.
                if (isExcluded)
                {
                    $(this).hide();
                    if (filterWizard != null)
                        filterWizard.show();
                }
                else
                {
                    $(this).show();

                    if (filterWizard != null)
                        filterWizard.hide();
                }
            }
        });
    }
}

//#endregion Hash

//#region Filter stash

function addStashClickEvents(): void
{
    const $productContent = $(".j-productview-content");

    if ($productContent.length > 0)
    {
        $productContent.find(".w-productcard__holder a")
            .off("click")
            .on("click", function (this: HTMLElement)
            {
                const $breadCrumbs = $(".j-breadcrumbs a");
                let lastItemCategoryName = $breadCrumbs.last().text().trim();

                let openFilter = "0";
                const $filterList = $(".j-filter__list");
                const filterListStyle = $filterList.attr("style");

                if ($filterList.css("display") == "block" && filterListStyle !== undefined && filterListStyle.indexOf('block') > 0 && $(".filterbtn").css("display") == "block")
                    openFilter = "1";

                // Don't use page as categoryname
                if (lastItemCategoryName.includes(getTranslations().pageTitleText.replace("{0}", "")))
                    lastItemCategoryName = $breadCrumbs.eq(-2).text().trim();

                $.stash.set("lastCategoryName", lastItemCategoryName);
                $.stash.set("lastCategoryUrl", window.location.href);
                $.stash.set("scroll-from-top", $(window).scrollTop() || 0);
                $.stash.set("filter-is-open", openFilter);

                if ($("#lazy_load").length > 0)
                    $.stash.set("show-all-products", $("#lazy_load").val());

                //TODO: Save complete breadcrumb

                let breadcrumb = "";
                $breadCrumbs.each(function (this: HTMLElement)
                {
                    breadcrumb += $(this).attr("href") + "|" + $(this).attr("title") + "||";
                });
                $.stash.set("lastBreadcrumb", breadcrumb);

                const sku = $(this).closest(".w-productcard__holder").find(".bullet").data("sku");

                if (buttonInfoList != null && sku in buttonInfoList)
                {
                    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
                    sendDataLayer({
                        "event": "promotionClick",
                        "ecommerce": {
                            "items": buttonInfoList[sku]
                        }
                    });
                }
            }
            );

        if (stashScroll != null)
            dynamicScroll(stashScroll);
    }
}

function fillFilterStash(isMobile: boolean): void
{
    const currentCategory = $("input[name*='current_category']");

    if (currentCategory.length > 0 && dboCatIDs.includes($(currentCategory).val() as string))
    {
        const selectorContext = isMobile ? ".j-filtermobile" : ".j-category";

        // Get checked measure options.
        const measureOption = $(`${selectorContext} .w-filter__sublist .w-filter__sublist-item`)
            .filter(function (this: HTMLElement)
            {
                return $(this).find("input[type='checkbox']").prop("checked") === true && $(this).data("property-id") == measurePropertyID;
            })
            .map(function (this: HTMLElement)
            {
                return ($(this).data("option-id") || "").toString();
            })
            .get();

        // Add all active measure filters to stash
        if (measureOption.length > 0)
            $.stash.set("dboActiveFilters", measureOption);
        else
            $.stash.remove("dboActiveFilters");
    }
    else
        $.stash.remove("dboActiveFilters");
}

function updateExpandedPropertyStash(propertyList: HTMLElement | JQuery, isMore: boolean): void
{
    let categoryID: string | number = 0;
    const $currentCategory = $("input[name='current_category']");
    let propertyID = 0;

    const $listOption = $(propertyList).closest(".j-filter__list-item");

    if ($currentCategory.length > 0)
        categoryID = $currentCategory.val() as string;

    if ($listOption.length > 0)
        propertyID = parseInt($listOption.data("property-id") as string, 10) || 0;

    if (propertyID > 0)
    {
        let expandedPropertySelections = "";
        const currentPropertySelection = categoryID + "-" + propertyID;

        if ($.stash.exists("expandedPropertySelections"))
            expandedPropertySelections = $.stash.get("expandedPropertySelections");

        if (!expandedPropertySelections.includes(currentPropertySelection) && isMore)
        {
            if (expandedPropertySelections.length > 0)
                expandedPropertySelections += "_" + currentPropertySelection;
            else
                expandedPropertySelections += currentPropertySelection;

            $.stash.set("expandedPropertySelections", expandedPropertySelections);
        }
        else if (!isMore)
        {
            expandedPropertySelections = expandedPropertySelections
                .replace("_" + currentPropertySelection, "")
                .replace(currentPropertySelection + "_", "")
                .replace(currentPropertySelection, "");

            $.stash.set("expandedPropertySelections", expandedPropertySelections);
        }
    }
}

//#endregion Filter stash

//#region Get URL (no filters)

export const getURLWithoutFilters = () =>
{
    let path = window.location.pathname;
    let pathSplit = path.split("/").filter(Boolean);

    const activeFilters = $(".j-filter .w-filter__sublist-item input[type='checkbox']:checked");

    // Ensure we don't redirect to one of the filter's pages
    if (activeFilters != null && activeFilters.length > 0)
    {
        activeFilters.each(function ()
        {
            const $filterItem = $(this);
            const $filterItemRow = $filterItem.closest(".w-filter__sublist-item");
            let filterItemName = "";

            if ($filterItemRow.find("a").length > 0)
                filterItemName = $($filterItemRow.find("a")[0]).text().toLowerCase();
            else if ($filterItemRow.find("label").length > 0)
                filterItemName = $($filterItemRow.find("label")[0]).text().toLowerCase();

            const filterIndex = pathSplit.indexOf(filterItemName)
            if (filterIndex > -1)
                pathSplit.splice(filterIndex, 1);
        });
    }

    if (pathSplit != null && pathSplit.length > 0)
        return pathSplit[0];
    else
    {
        // Remove starting / character.
        if (path.startsWith("/"))
            path = path.substring(1);

        // Remove ending / character.
        if (path.endsWith("/"))
            path = path.slice(0, -1);

        return path;
    }
}

(window as any).getURLWithoutFilters = getURLWithoutFilters;

//#endregion Get URL (no filters)

//#region Scroll

// Scrolls page to results, leaving filterwizard and result count just in view beneath header or top of screen.
// Parameter 'recalc' is only used for the function to call itself, if the page started at the top.
function activateResultScroll(recalc?: boolean): void
{
    let offset = 0;
    const screenWidth = $(window).width() || 0;
    const quickFilter = $(".j-quickfilter");
    const main = $(".j-category");
    let headerFixed = false;

    // Determine if header is fixed and calculate offset accordingly
    if ($("body").hasClass("fixed"))
    {
        headerFixed = true;

        if (screenWidth >= 768)
        {
            offset = $(".w-header__inner").outerHeight(true) || 0;

            if (screenWidth >= 1025)
                offset = ($(".js-header").outerHeight(true) || 0) - ($(".js-header-topbar").outerHeight(true) || 0) + 30;
        }
    }
    else
        offset = $(".js-header").outerHeight(true) + 16;

    const animDuration = recalc ? 100 : 500;

    // Determine scroll target
    let target: JQuery | null = null;

    if (quickFilter.length && quickFilter.is(":visible") && !quickFilter.is(":empty"))
        target = quickFilter;
    else if (main.length)
        target = main;

    if (target)
    {
        $("html, body").animate({
            scrollTop: (target.offset()?.top ?? 0) - offset
        }, animDuration);
    }

    // Recalculate scroll if header wasn't fixed before
    if (!headerFixed && !recalc)
    {
        setTimeout(function ()
        {
            activateResultScroll(true);
        }, animDuration);
    }
}

function scrollToResults(forceScroll?: boolean): void
{
    setTimeout(function ()
    {
        let isInView = false;

        // Only check whether to scroll or not if it's not being forced.
        if (!forceScroll)
        {
            const $window = $(window);
            const winHeight = $window.height() || 0;
            const windowTop = $window.scrollTop() || 0;
            const windowBottom = windowTop + winHeight;
            const productBlockTop = $(".j-productview-content").offset()?.top ?? 0;
            const productBlockBottom = productBlockTop + $(".j-productview-content").outerHeight(true);

            // Allow j-productview-content to be a maximum of this amount off-screen to still count as being in view.
            const allowedOffset = (winHeight / 2);

            if ((windowTop + allowedOffset) > productBlockTop &&
                (windowBottom - allowedOffset) < productBlockBottom)
                isInView = true;
        }

        if (!isInView)
            activateResultScroll();

        scrollTimeout = null;
    }, 250);
}

function dynamicScroll(scroll: number): void
{
    const docTotalHeight = $(document).height() || 0;
    const footerHeight = $("#footer").height() || 0;
    let docHeight = docTotalHeight - footerHeight;

    if ($(".j-category-banner").length > 0)
        docHeight = docHeight - ($(".j-category-banner").height() || 0);

    const filterHeight = $(".j-filter").height() || 0;
    const productHeight = $(".j-productview-content").height() || 0;

    if (filterHeight == 0 || productHeight < filterHeight)
    {
        const $lastItem = $(".j-productview-content .w-productcard__holder").last();
        if ($lastItem.length > 0)
            $(window).scrollTop(($lastItem.offset()?.top ?? 0) - 120);
        stashScroll = scroll;
    }
    else if (docHeight < scroll)
    {
        $(window).scrollTop(docTotalHeight - footerHeight);
        stashScroll = scroll;
    }
    else
    {
        $(window).scrollTop(scroll);
        stashScroll = null;
    }
}

//#endregion Scroll

function escapeFilterOptionContent(content: string | number | null | undefined): string | number
{
    if (content == null || content === undefined)
        return "";
    else if (typeof content === "string" && isNaN(Number(content)))
    {
        return content
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }
    else
        return content;
}

function resetProductOverlayEvents(): void
{
    const $loadingItems = $(".j-productview-content .w-productcard__holder.loading");

    if ($loadingItems.length > 0)
    {
        $loadingItems.removeClass("loading");
    }
}

function getFetchPriorityCountTags(template: string | null | undefined): FetchPriorityKeyItem[]
{
    const fetchPriorityKeys: FetchPriorityKeyItem[] = [];

    if (template)
    {
        const fetchPriorityRegExp = /fetchpriority_[0-9]+_high/g;
        let match: RegExpExecArray | null;

        while ((match = fetchPriorityRegExp.exec(template)) !== null)
        {
            const fetchPriorityKey = match[0];
            const fetchPriorityCount = parseInt(
                fetchPriorityKey
                    .replace("fetchpriority_", "")
                    .replace("_high", ""),
                10
            );

            // Check if not yet exists before pushing.
            if (fetchPriorityKeys.filter((item): boolean => item.count === fetchPriorityCount).length <= 0)
                fetchPriorityKeys.push({ count: fetchPriorityCount, key: fetchPriorityKey });
        }
    }

    return fetchPriorityKeys;
}

function sendCategoryProductImpressions(): void
{
    function buildEcommerceItem(impressionItem: Record<string, any>, breadcrumbs: Record<string, string>): Record<string, any>
    {
        const items: Record<string, any> = {
            "currency": "EUR",
            "item_list_id": "1",
            "item_list_name": location.pathname,
            "quantity": "1",
            "google_business_vertical": "retail"
        };

        const dataMapping: Record<string, string> = {
            "name": "item_name",
            "id": "item_id",
            "price": "price",
            "discount": "discount",
            "brand": "item_brand",
            "category": "item_category",
            "variant": "item_variant",
            "color": "item_color",
            "size": "item_size",
            "livingstyle": "item_woonstijl",
            "priceclass": "item_prijsklasse",
            "material": "item_materiaal",
            "stuffing": "item_vulling",
            "season": "item_seizoen",
            "deliverytime": "item_levertijd",
            "articlecode": "item_smulcode",
            "sleepingposition": "item_slaaphouding",
            "firmness": "item_stevigheid",
            "stock": "item_voorraad",
            "type": "item_type",
            "thermalclass": "item_warmteklasse",
            "position": "index"
        };

        for (const key in dataMapping)
        {
            if (Object.prototype.hasOwnProperty.call(dataMapping, key))
            {
                const targetKey = dataMapping[key];
                const val = impressionItem[key];

                if (val !== undefined && val !== null && val !== "")
                    items[targetKey] = val;
            }
        }

        for (let i = 3; i <= 6; i++)
        {
            const bcKey = "item" + i;
            if (breadcrumbs[bcKey] !== undefined && breadcrumbs[bcKey] !== "")
                items["item_category" + (i - 1)] = breadcrumbs[bcKey];
        }

        return items;
    }

    if (typeof impressionList !== "undefined" && impressionList != null)
    {
        const shortImpressionList = impressionList.slice(0, 6);
        const secondImpressionList = impressionList.slice(6);
        const shortImpressions: Record<string, any>[] = [];

        const breadcrumbs = getBreadCrumbImpression();

        shortImpressionList.forEach(function (impressionItem: Record<string, any>)
        {
            const shortImpression = buildEcommerceItem(impressionItem, breadcrumbs);
            shortImpressions.push(shortImpression);

            const $cardHolder = $("#w-productcard__holder-" + impressionItem["aid"]);

            $cardHolder.on("click", function ()
            {
                const items = buildEcommerceItem(impressionItem, breadcrumbs);
                sendDataLayer({ ecommerce: null });
                sendDataLayer({
                    "event": "productClick",
                    "ecommerce": {
                        "items": [items]
                    }
                });
            });

            $(`#w-productcard__holder-${impressionItem["aid"]} .favorite-add-holder`).off("click").on("click", function (e: JQuery.TriggeredEvent)
            {
                e.stopPropagation();
            });

            $(`#w-productcard__holder-${impressionItem["aid"]} .productcompare-add`).off("click").on("click", function (e: JQuery.TriggeredEvent)
            {
                e.stopPropagation();
            });
        });

        if (shortImpressions.length > 0)
        {
            sendDataLayer({
                "ecommerce": {
                    "items": shortImpressions
                }
            });

            sendDataLayer({
                "event": "productView",
                "category": "Ecommerce",
                "action": location.pathname
            });

            sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.
        }

        secondImpressionList.forEach(function (impressionItem: Record<string, any>)
        {
            const $cardHolder = $("#w-productcard__holder-" + impressionItem["aid"]);

            onScrolledIntoView($cardHolder, function ()
            {
                const currentBreadcrumbs = getBreadCrumbImpression();
                const items = buildEcommerceItem(impressionItem, currentBreadcrumbs);

                sendDataLayer({ ecommerce: null });
                sendDataLayer({
                    "event": "productView",
                    "ecommerce": {
                        "items": [items]
                    }
                });
            });

            $cardHolder.on("click", function ()
            {
                const currentBreadcrumbs = getBreadCrumbImpression();
                const items = buildEcommerceItem(impressionItem, currentBreadcrumbs);

                sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.
                sendDataLayer({
                    "event": "productClick",
                    "ecommerce": {
                        "items": [items]
                    }
                });
            });

            $(`#w-productcard__holder-${impressionItem["aid"]} .favorite-add-holder`).off("click").on("click", function (e: JQuery.TriggeredEvent)
            {
                e.stopPropagation();
            });

            $(`#w-productcard__holder-${impressionItem["aid"]} .productcompare-add`).off("click").on("click", function (e: JQuery.TriggeredEvent)
            {
                e.stopPropagation();
            });
        });

        impressionList = null;
    }

    if (buttonImpressionList)
    {
        sendDataLayer({
            "ecommerce": {
                "promoView": {
                    "promotions": buttonImpressionList
                }
            }
        });
        buttonImpressionList = null;
    }
}

//#region Page history

function pushPageHistory(newPage?: number | string): void
{
    let resetPageWhenDone = false;

    if (initialPageNumber != null && newPage == 1)
    {
        const tmpPage = initialPageNumber;
        initialPageNumber = null;
        switchPage(tmpPage, false);
        return;
    }
    else if (newPage === undefined)
    {
        const queryPage = queryStringValue("page");

        if (queryPage.length > 0)
        {
            const parsedPage = parseInt(queryPage);

            if (parsedPage > 1)
                newPage = parsedPage;
        }
    }

    let url = document.location.pathname.toLowerCase();
    let priceMin: string | number = 0;
    let priceMax: string | number = 0;

    const propertyValues: { Name: string; Min: number; Max: number }[] = [];

    {
        const minValue = parseInt($("input[name='min']").val() as string) || 0;
        const maxValue = parseInt($("input[name='max']").val() as string) || 0;
        const currentMin = parseInt($(".cur-min").val() as string) || 0;
        const currentMax = parseInt($(".cur-max").val() as string) || 0;

        if (minValue == currentMin && getParameterByName("price-min").length > 0)
        {
            priceMin = getParameterByName("price-min");
            $(".cur-min").val(priceMin);
        }

        if (currentMin > minValue && currentMin < maxValue)
            priceMin = currentMin;
        else if (priceMin == 0 && currentMin == currentMax && maxValue == currentMin)
            priceMin = currentMin;

        if (priceMin == 0 && parseInt(getParameterByName("price-min")) > 0)
            priceMin = currentMin;

        if (maxValue == currentMax && getParameterByName("price-max").length > 0)
        {
            priceMax = getParameterByName("price-max");
            $(".cur-max").val(priceMax);
        }

        if (currentMax < maxValue && currentMax > minValue)
            priceMax = currentMax;
        else if (priceMax == 0 && currentMin == currentMax && minValue == currentMax)
            priceMax = currentMax;

        if (priceMax == 0 && parseInt(getParameterByName("price-max")) > 0)
            priceMax = currentMax;
    }

    if (propertySliderHolder != null && propertySliderHolder.length > 0)
    {
        const checkedProperties = new Set<string>();

        const desktopSliders = propertySliderHolder.filter(x => !x.target.classList.contains("j-filtermobile"));

        desktopSliders.forEach(function (item: any)
        {
            const target = $(item.target).parent().parent();
            if (target.length > 0)
            {
                const propName = target.find("input[name='prop-name']").val() as string;

                // Optimized: Substituted linear array parsing lookups with an instant Set look up handler
                if (!checkedProperties.has(propName))
                {
                    checkedProperties.add(propName);

                    const minValue = parseInt(target.find("input[name='prop-min']").val() as string) || 0;
                    const maxValue = parseInt(target.find("input[name='prop-max']").val() as string) || 0;
                    const currentMin = parseInt(target.find(".prop-cur-min").val() as string) || 0;
                    const currentMax = parseInt(target.find(".prop-cur-max").val() as string) || 0;

                    let selectedMinValue: string | number = currentMin;
                    let selectedMaxValue: string | number = currentMax;

                    if (minValue == currentMin && getParameterByName(propName + "-min").length > 0)
                    {
                        selectedMinValue = getParameterByName(propName + "-min");
                        $(".prop-cur-min").val(selectedMinValue);
                    }

                    if (currentMin > minValue && currentMin < maxValue)
                        selectedMinValue = currentMin;
                    else if (selectedMinValue == 0 && currentMin == currentMax && maxValue == currentMin)
                        selectedMinValue = currentMin;

                    if (selectedMinValue == 0 && parseInt(getParameterByName(propName + "-min")) > 0)
                        selectedMinValue = currentMin;

                    if (selectedMinValue == minValue)
                        selectedMinValue = 0;

                    if (maxValue == currentMax && getParameterByName(propName + "-max").length > 0)
                    {
                        selectedMaxValue = getParameterByName(propName + "-max");
                        $(".prop-cur-max").val(selectedMaxValue);
                    }

                    if (currentMax < maxValue && currentMax > minValue)
                        selectedMaxValue = currentMax;
                    else if (selectedMaxValue == 0 && currentMin == currentMax && minValue == currentMax)
                        selectedMaxValue = currentMax;

                    if (selectedMaxValue == 0 && parseInt(getParameterByName(propName + "-max")) > 0)
                        selectedMaxValue = currentMax;

                    if (selectedMaxValue == maxValue)
                        selectedMaxValue = 0;

                    if (Number(selectedMinValue) > 0 || Number(selectedMaxValue) > 0)
                    {
                        propertyValues.push({
                            Name: propName,
                            Min: Number(selectedMinValue),
                            Max: Number(selectedMaxValue)
                        });
                    }
                }
            }
        });
    }

    const searchParams = new URLSearchParams(document.location.search);

    if (Number(newPage) > 1)
        searchParams.set("page", String(newPage));
    else
        searchParams.delete("page");

    {
        if (Number(priceMin) > 0)
            searchParams.set("price-min", String(priceMin));
        else
            searchParams.delete("price-min");

        if (Number(priceMax) > 0)
            searchParams.set("price-max", String(priceMax));
        else
            searchParams.delete("price-max");
    }

    if (!filterWizard.applyingFilterFromWizard)
    {
        for (let i = 0; i < propertyValues.length; i++)
        {
            const item = propertyValues[i];

            if (item.Min > 0)
                searchParams.set(`${item.Name}-min`, String(item.Min));
            else
                searchParams.delete(`${item.Name}-min`);

            if (item.Max > 0)
                searchParams.set(`${item.Name}-max`, String(item.Max));
            else
                searchParams.delete(`${item.Name}-max`);
        }
    }

    const compiledQueryString = searchParams.toString();
    const query = compiledQueryString ? "?" + compiledQueryString : "";

    let oldUrl = document.location.pathname.toLowerCase();
    let hash = document.location.hash;
    let virtualUrl = url;

    if (hash.length > 1)
    {
        hash = hash.substring(1);
        const hashItems = hash.split("_");

        for (let i = 0; i < hashItems.length; i++)
        {
            const currentItem = hashItems[i];
            const [propStr, valStr] = currentItem.split("-");
            const property = parseInt(propStr);
            const value = parseInt(valStr);

            if (property > 0 && value > 0)
            {
                const item = $(`.w-filter__sublist-item[data-property-id='${property}'][data-option-id='${value}']`);
                let text = "";

                if (item.length > 0)
                    text = item.attr("title") || item.find("a").text() || "";

                if (text !== "")
                {
                    const escapedText = escapeForUrl(text);
                    virtualUrl += "/" + escapedText + "/";
                    oldUrl += "/" + escapedText + "/";
                }
            }
        }
    }

    const multipleSlashesRegex = /\/{2,}/g;
    oldUrl = oldUrl.replace(multipleSlashesRegex, "/");
    oldUrl += document.location.search.toLowerCase();

    virtualUrl = virtualUrl.replace(multipleSlashesRegex, "/");
    virtualUrl += query;
    url += query;

    if (virtualUrl !== oldUrl)
    {
        if (document.location.hash.length > 0)
            url += document.location.hash;

        history.pushState({}, "", url);
    }

    $(".j-filter__list-item[data-property-id='price']").show();

    if (resetPageWhenDone)
    {
        setTimeout(function ()
        {
            switchPage(1, true);
        }, 250);
    }
}

//#endregion Page history

//#region Helper functions

function cleanSearchValue(term: string | null | undefined): string
{
    if (term != null)
        return term.replace(/(%|\(|\))/g, "");
    else
        return "";
}

function removeAccents(strAccents: string): string
{
    const accents = "ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøDŽdžÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÝÿýŽž";
    const accentsOut = "AAAAAAaaaaaasOOOOOOOooooooDZdzEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYYyyZz";

    return strAccents.split("").map((char) =>
    {
        const index = accents.indexOf(char);
        if (index !== -1)
            return accentsOut.charAt(index);

        return char;
    }).join("");
}

function clone<T>(obj: T): T
{
    if (obj == null || typeof obj !== "object")
        return obj;

    const copy = new (obj.constructor as new () => any)();

    for (const attr in obj)
    {
        if (Object.prototype.hasOwnProperty.call(obj, attr))
            copy[attr] = (obj as any)[attr];
    }

    return copy as T;
}

//#endregion Helper functions

export { };

(window as any).filterSpinner = filterSpinner;